/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.6.0 (NJsonSchema v10.0.28.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as moment from 'moment';


export enum UserCategory {
    UndefinedUserCategory = 0,
    HostAdminUser = 1,
    TenantAdminUser = 2,
    StaffAdminUser = 3,
    StaffUser = 4,
    ProviderUser = 5,
    ConsumerUser = 6,
}

export class CreateStaffUserInput implements ICreateStaffUserInput {
    staffUserGroupId!: number;
    securityQuestion1!: string;
    securityQuestion2!: string;
    securityQuestion3!: string;
    securityAnswer1!: string;
    securityAnswer2!: string;
    securityAnswer3!: string;
    userCategory?: UserCategory | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse?: string | undefined;

    constructor(data?: ICreateStaffUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffUserGroupId = _data["staffUserGroupId"];
            this.securityQuestion1 = _data["securityQuestion1"];
            this.securityQuestion2 = _data["securityQuestion2"];
            this.securityQuestion3 = _data["securityQuestion3"];
            this.securityAnswer1 = _data["securityAnswer1"];
            this.securityAnswer2 = _data["securityAnswer2"];
            this.securityAnswer3 = _data["securityAnswer3"];
            this.userCategory = _data["userCategory"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): CreateStaffUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffUserGroupId"] = this.staffUserGroupId;
        data["securityQuestion1"] = this.securityQuestion1;
        data["securityQuestion2"] = this.securityQuestion2;
        data["securityQuestion3"] = this.securityQuestion3;
        data["securityAnswer1"] = this.securityAnswer1;
        data["securityAnswer2"] = this.securityAnswer2;
        data["securityAnswer3"] = this.securityAnswer3;
        data["userCategory"] = this.userCategory;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface ICreateStaffUserInput {
    staffUserGroupId: number;
    securityQuestion1: string;
    securityQuestion2: string;
    securityQuestion3: string;
    securityAnswer1: string;
    securityAnswer2: string;
    securityAnswer3: string;
    userCategory?: UserCategory | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse?: string | undefined;
}

export class SetSecurityQuestionsInput implements ISetSecurityQuestionsInput {
    securityQuestion1!: string;
    securityQuestion2!: string;
    securityQuestion3!: string;
    securityAnswer1!: string;
    securityAnswer2!: string;
    securityAnswer3!: string;

    constructor(data?: ISetSecurityQuestionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityQuestion1 = _data["securityQuestion1"];
            this.securityQuestion2 = _data["securityQuestion2"];
            this.securityQuestion3 = _data["securityQuestion3"];
            this.securityAnswer1 = _data["securityAnswer1"];
            this.securityAnswer2 = _data["securityAnswer2"];
            this.securityAnswer3 = _data["securityAnswer3"];
        }
    }

    static fromJS(data: any): SetSecurityQuestionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetSecurityQuestionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityQuestion1"] = this.securityQuestion1;
        data["securityQuestion2"] = this.securityQuestion2;
        data["securityQuestion3"] = this.securityQuestion3;
        data["securityAnswer1"] = this.securityAnswer1;
        data["securityAnswer2"] = this.securityAnswer2;
        data["securityAnswer3"] = this.securityAnswer3;
        return data; 
    }
}

export interface ISetSecurityQuestionsInput {
    securityQuestion1: string;
    securityQuestion2: string;
    securityQuestion3: string;
    securityAnswer1: string;
    securityAnswer2: string;
    securityAnswer3: string;
}

export class UpdateSecurityQuestionsInput implements IUpdateSecurityQuestionsInput {
    userName!: string;
    password!: string;
    securityQuestion1!: string;
    securityQuestion2!: string;
    securityQuestion3!: string;
    securityAnswer1!: string;
    securityAnswer2!: string;
    securityAnswer3!: string;

    constructor(data?: IUpdateSecurityQuestionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.securityQuestion1 = _data["securityQuestion1"];
            this.securityQuestion2 = _data["securityQuestion2"];
            this.securityQuestion3 = _data["securityQuestion3"];
            this.securityAnswer1 = _data["securityAnswer1"];
            this.securityAnswer2 = _data["securityAnswer2"];
            this.securityAnswer3 = _data["securityAnswer3"];
        }
    }

    static fromJS(data: any): UpdateSecurityQuestionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityQuestionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["securityQuestion1"] = this.securityQuestion1;
        data["securityQuestion2"] = this.securityQuestion2;
        data["securityQuestion3"] = this.securityQuestion3;
        data["securityAnswer1"] = this.securityAnswer1;
        data["securityAnswer2"] = this.securityAnswer2;
        data["securityAnswer3"] = this.securityAnswer3;
        return data; 
    }
}

export interface IUpdateSecurityQuestionsInput {
    userName: string;
    password: string;
    securityQuestion1: string;
    securityQuestion2: string;
    securityQuestion3: string;
    securityAnswer1: string;
    securityAnswer2: string;
    securityAnswer3: string;
}

export class SendPasswordResetCodeByUserNameInput implements ISendPasswordResetCodeByUserNameInput {
    userName!: string;

    constructor(data?: ISendPasswordResetCodeByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ISendPasswordResetCodeByUserNameInput {
    userName: string;
}

export class RetrieveRandomSecurityQInput implements IRetrieveRandomSecurityQInput {
    userId?: number | undefined;
    resetCode?: string | undefined;
    c?: string | undefined;

    constructor(data?: IRetrieveRandomSecurityQInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): RetrieveRandomSecurityQInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveRandomSecurityQInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["c"] = this.c;
        return data; 
    }
}

export interface IRetrieveRandomSecurityQInput {
    userId?: number | undefined;
    resetCode?: string | undefined;
    c?: string | undefined;
}

export class SecurityQuestionDto implements ISecurityQuestionDto {
    securityQuestionId!: number;
    securityQuestion!: string;

    constructor(data?: ISecurityQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityQuestionId = _data["securityQuestionId"];
            this.securityQuestion = _data["securityQuestion"];
        }
    }

    static fromJS(data: any): SecurityQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityQuestionId"] = this.securityQuestionId;
        data["securityQuestion"] = this.securityQuestion;
        return data; 
    }
}

export interface ISecurityQuestionDto {
    securityQuestionId: number;
    securityQuestion: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    securityQuestion?: string | undefined;
    securityAnswer?: string | undefined;
    userId?: number | undefined;
    resetCode?: string | undefined;
    password?: string | undefined;
    returnUrl?: string | undefined;
    singleSignIn?: string | undefined;
    c?: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityQuestion = _data["securityQuestion"];
            this.securityAnswer = _data["securityAnswer"];
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityQuestion"] = this.securityQuestion;
        data["securityAnswer"] = this.securityAnswer;
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data; 
    }
}

export interface IResetPasswordInput {
    securityQuestion?: string | undefined;
    securityAnswer?: string | undefined;
    userId?: number | undefined;
    resetCode?: string | undefined;
    password?: string | undefined;
    returnUrl?: string | undefined;
    singleSignIn?: string | undefined;
    c?: string | undefined;
}

export class RequestEmailUpdateInput implements IRequestEmailUpdateInput {
    newRequestedEmail!: string;

    constructor(data?: IRequestEmailUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newRequestedEmail = _data["newRequestedEmail"];
        }
    }

    static fromJS(data: any): RequestEmailUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEmailUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newRequestedEmail"] = this.newRequestedEmail;
        return data; 
    }
}

export interface IRequestEmailUpdateInput {
    newRequestedEmail: string;
}

export class ConfirmEmailUpdateInput implements IConfirmEmailUpdateInput {
    userId?: number | undefined;
    newEmailAddress?: string | undefined;
    confirmationCode?: string | undefined;
    c?: string | undefined;

    constructor(data?: IConfirmEmailUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newEmailAddress = _data["newEmailAddress"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ConfirmEmailUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newEmailAddress"] = this.newEmailAddress;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data; 
    }
}

export interface IConfirmEmailUpdateInput {
    userId?: number | undefined;
    newEmailAddress?: string | undefined;
    confirmationCode?: string | undefined;
    c?: string | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state?: TenantAvailabilityState | undefined;
    tenantId?: number | undefined;
    serverRootAddress?: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state?: TenantAvailabilityState | undefined;
    tenantId?: number | undefined;
    serverRootAddress?: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c?: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data; 
    }
}

export interface IResolveTenantIdInput {
    c?: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    userCategory?: UserCategory | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse?: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCategory = _data["userCategory"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCategory"] = this.userCategory;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    userCategory?: UserCategory | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse?: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin?: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin?: boolean | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin?: boolean | undefined;
    userName?: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin?: boolean | undefined;
    userName?: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId?: number | undefined;
    confirmationCode?: string | undefined;
    c?: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId?: number | undefined;
    confirmationCode?: string | undefined;
    c?: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId?: number | undefined;
    userId?: number | undefined;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId?: number | undefined;
    userId?: number | undefined;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken?: string | undefined;
    tenancyName?: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId?: number | undefined;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data; 
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId?: number | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId?: number | undefined;
    targetUserId?: number | undefined;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId?: number | undefined;
    targetUserId?: number | undefined;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken?: string | undefined;
    tenancyName?: string | undefined;
}

export class CreateContactUsInputDto implements ICreateContactUsInputDto {
    contactUsCategory?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateContactUsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUsCategory = _data["contactUsCategory"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.personName = _data["personName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateContactUsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactUsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUsCategory"] = this.contactUsCategory;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["personName"] = this.personName;
        data["email"] = this.email;
        return data; 
    }
}

export interface ICreateContactUsInputDto {
    contactUsCategory?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;
}

export class ContactUsDto implements IContactUsDto {
    contactUsCategory?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;
    id?: number | undefined;

    constructor(data?: IContactUsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUsCategory = _data["contactUsCategory"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.personName = _data["personName"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContactUsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUsCategory"] = this.contactUsCategory;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["personName"] = this.personName;
        data["email"] = this.email;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactUsDto {
    contactUsCategory?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;
    id?: number | undefined;
}

export enum ContactUsReasons {
    Feedback = 0,
    ProgramAssistanceRequest = 1,
    TechnicalAssistanceRequest = 2,
}

export class ContactUsListItemDto implements IContactUsListItemDto {
    type?: ContactUsReasons | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactUsListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.personName = _data["personName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactUsListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["personName"] = this.personName;
        data["email"] = this.email;
        return data; 
    }
}

export interface IContactUsListItemDto {
    type?: ContactUsReasons | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    personName?: string | undefined;
    email?: string | undefined;
}

export class PagedResultDtoOfContactUsListItemDto implements IPagedResultDtoOfContactUsListItemDto {
    totalCount?: number | undefined;
    items?: ContactUsListItemDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactUsListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactUsListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactUsListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactUsListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactUsListItemDto {
    totalCount?: number | undefined;
    items?: ContactUsListItemDto[] | undefined;
}

export class CustomerUserSummary implements ICustomerUserSummary {
    userId?: number | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: moment.Moment | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICustomerUserSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CustomerUserSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data; 
    }
}

export interface ICustomerUserSummary {
    userId?: number | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: moment.Moment | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export class CustomerUserProfileStateDto implements ICustomerUserProfileStateDto {
    isCompleteContactInfo?: boolean | undefined;
    isCompletePersonalInfo?: boolean | undefined;
    isCompleteSecurityQuestions?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: ICustomerUserProfileStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCompleteContactInfo = _data["isCompleteContactInfo"];
            this.isCompletePersonalInfo = _data["isCompletePersonalInfo"];
            this.isCompleteSecurityQuestions = _data["isCompleteSecurityQuestions"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerUserProfileStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserProfileStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompleteContactInfo"] = this.isCompleteContactInfo;
        data["isCompletePersonalInfo"] = this.isCompletePersonalInfo;
        data["isCompleteSecurityQuestions"] = this.isCompleteSecurityQuestions;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerUserProfileStateDto {
    isCompleteContactInfo?: boolean | undefined;
    isCompletePersonalInfo?: boolean | undefined;
    isCompleteSecurityQuestions?: boolean | undefined;
    id?: number | undefined;
}

export enum USState {
    AL = 0,
    AK = 1,
    AS = 2,
    AZ = 3,
    AR = 4,
    CA = 5,
    CO = 6,
    CT = 7,
    DE = 8,
    DC = 9,
    FM = 10,
    FL = 11,
    GA = 12,
    GU = 13,
    HI = 14,
    ID = 15,
    IL = 16,
    IN = 17,
    IA = 18,
    KS = 19,
    KY = 20,
    LA = 21,
    ME = 22,
    MH = 23,
    MD = 24,
    MA = 25,
    MI = 26,
    MN = 27,
    MS = 28,
    MO = 29,
    MT = 30,
    NE = 31,
    NV = 32,
    NH = 33,
    NJ = 34,
    NM = 35,
    NY = 36,
    NC = 37,
    ND = 38,
    MP = 39,
    OH = 40,
    OK = 41,
    OR = 42,
    PW = 43,
    PA = 44,
    PR = 45,
    RI = 46,
    SC = 47,
    SD = 48,
    TN = 49,
    TX = 50,
    UT = 51,
    VT = 52,
    VI = 53,
    VA = 54,
    WA = 55,
    WV = 56,
    WI = 57,
    WY = 58,
    AE = 59,
    AP = 60,
    AA = 61,
}

export class AddressInputDto implements IAddressInputDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: USState | undefined;
    postalCode?: string | undefined;
    id?: number | undefined;

    constructor(data?: IAddressInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.usStateCode = _data["usStateCode"];
            this.postalCode = _data["postalCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddressInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["usStateCode"] = this.usStateCode;
        data["postalCode"] = this.postalCode;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAddressInputDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: USState | undefined;
    postalCode?: string | undefined;
    id?: number | undefined;
}

export class EzContactInfo implements IEzContactInfo {
    phoneNumber?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEzContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EzContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EzContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data; 
    }
}

export interface IEzContactInfo {
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export class PersonalInfoDto implements IPersonalInfoDto {
    prefix?: string | undefined;
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string;
    suffix?: string | undefined;
    dob?: moment.Moment | undefined;
    gender?: number | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IPersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): PersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IPersonalInfoDto {
    prefix?: string | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    suffix?: string | undefined;
    dob?: moment.Moment | undefined;
    gender?: number | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum Language {
    English = 0,
    Spanish = 1,
}

export class CurrentCustomerUserProfileDto implements ICurrentCustomerUserProfileDto {
    userName?: string | undefined;
    mailingAddress?: AddressInputDto | undefined;
    contactInfo?: EzContactInfo | undefined;
    personalInfo?: PersonalInfoDto | undefined;
    pendingChangesForPersonalInfo?: PersonalInfoDto | undefined;
    pendingChangesForPersonalInfoSubmittedDate?: moment.Moment | undefined;
    personalInfoLastUpdateDate?: moment.Moment | undefined;
    preferredSpokenLanguage?: Language | undefined;
    preferredWrittenLanguage?: Language | undefined;
    receiveNotificationsByEmail?: boolean | undefined;
    securityQuestion1?: string | undefined;
    securityQuestion2?: string | undefined;
    securityQuestion3?: string | undefined;
    isNewEmailVerificationPending?: boolean | undefined;
    newRequestedEmail?: string | undefined;
    isUpdateRequireApproval?: boolean | undefined;
    userId?: number | undefined;
    id?: number | undefined;

    constructor(data?: ICurrentCustomerUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.mailingAddress = _data["mailingAddress"] ? AddressInputDto.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.contactInfo = _data["contactInfo"] ? EzContactInfo.fromJS(_data["contactInfo"]) : <any>undefined;
            this.personalInfo = _data["personalInfo"] ? PersonalInfoDto.fromJS(_data["personalInfo"]) : <any>undefined;
            this.pendingChangesForPersonalInfo = _data["pendingChangesForPersonalInfo"] ? PersonalInfoDto.fromJS(_data["pendingChangesForPersonalInfo"]) : <any>undefined;
            this.pendingChangesForPersonalInfoSubmittedDate = _data["pendingChangesForPersonalInfoSubmittedDate"] ? moment(_data["pendingChangesForPersonalInfoSubmittedDate"].toString()) : <any>undefined;
            this.personalInfoLastUpdateDate = _data["personalInfoLastUpdateDate"] ? moment(_data["personalInfoLastUpdateDate"].toString()) : <any>undefined;
            this.preferredSpokenLanguage = _data["preferredSpokenLanguage"];
            this.preferredWrittenLanguage = _data["preferredWrittenLanguage"];
            this.receiveNotificationsByEmail = _data["receiveNotificationsByEmail"];
            this.securityQuestion1 = _data["securityQuestion1"];
            this.securityQuestion2 = _data["securityQuestion2"];
            this.securityQuestion3 = _data["securityQuestion3"];
            this.isNewEmailVerificationPending = _data["isNewEmailVerificationPending"];
            this.newRequestedEmail = _data["newRequestedEmail"];
            this.isUpdateRequireApproval = _data["isUpdateRequireApproval"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurrentCustomerUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCustomerUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["pendingChangesForPersonalInfo"] = this.pendingChangesForPersonalInfo ? this.pendingChangesForPersonalInfo.toJSON() : <any>undefined;
        data["pendingChangesForPersonalInfoSubmittedDate"] = this.pendingChangesForPersonalInfoSubmittedDate ? this.pendingChangesForPersonalInfoSubmittedDate.toISOString() : <any>undefined;
        data["personalInfoLastUpdateDate"] = this.personalInfoLastUpdateDate ? this.personalInfoLastUpdateDate.toISOString() : <any>undefined;
        data["preferredSpokenLanguage"] = this.preferredSpokenLanguage;
        data["preferredWrittenLanguage"] = this.preferredWrittenLanguage;
        data["receiveNotificationsByEmail"] = this.receiveNotificationsByEmail;
        data["securityQuestion1"] = this.securityQuestion1;
        data["securityQuestion2"] = this.securityQuestion2;
        data["securityQuestion3"] = this.securityQuestion3;
        data["isNewEmailVerificationPending"] = this.isNewEmailVerificationPending;
        data["newRequestedEmail"] = this.newRequestedEmail;
        data["isUpdateRequireApproval"] = this.isUpdateRequireApproval;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrentCustomerUserProfileDto {
    userName?: string | undefined;
    mailingAddress?: AddressInputDto | undefined;
    contactInfo?: EzContactInfo | undefined;
    personalInfo?: PersonalInfoDto | undefined;
    pendingChangesForPersonalInfo?: PersonalInfoDto | undefined;
    pendingChangesForPersonalInfoSubmittedDate?: moment.Moment | undefined;
    personalInfoLastUpdateDate?: moment.Moment | undefined;
    preferredSpokenLanguage?: Language | undefined;
    preferredWrittenLanguage?: Language | undefined;
    receiveNotificationsByEmail?: boolean | undefined;
    securityQuestion1?: string | undefined;
    securityQuestion2?: string | undefined;
    securityQuestion3?: string | undefined;
    isNewEmailVerificationPending?: boolean | undefined;
    newRequestedEmail?: string | undefined;
    isUpdateRequireApproval?: boolean | undefined;
    userId?: number | undefined;
    id?: number | undefined;
}

export class EzAddress implements IEzAddress {
    longitude?: number | undefined;
    latitude?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: USState | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IEzAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.usStateCode = _data["usStateCode"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): EzAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EzAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["usStateCode"] = this.usStateCode;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data; 
    }
}

export interface IEzAddress {
    longitude?: number | undefined;
    latitude?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: USState | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class UpdateContactInfoInputDto implements IUpdateContactInfoInputDto {
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IUpdateContactInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): UpdateContactInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IUpdateContactInfoInputDto {
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class CustomerUserProfilePreferencesDto implements ICustomerUserProfilePreferencesDto {
    preferredSpokenLanguage?: Language | undefined;
    preferredWrittenLanguage?: Language | undefined;
    emailType?: string | undefined;
    receiveNotificationsByEmail?: boolean | undefined;

    constructor(data?: ICustomerUserProfilePreferencesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredSpokenLanguage = _data["preferredSpokenLanguage"];
            this.preferredWrittenLanguage = _data["preferredWrittenLanguage"];
            this.emailType = _data["emailType"];
            this.receiveNotificationsByEmail = _data["receiveNotificationsByEmail"];
        }
    }

    static fromJS(data: any): CustomerUserProfilePreferencesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserProfilePreferencesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredSpokenLanguage"] = this.preferredSpokenLanguage;
        data["preferredWrittenLanguage"] = this.preferredWrittenLanguage;
        data["emailType"] = this.emailType;
        data["receiveNotificationsByEmail"] = this.receiveNotificationsByEmail;
        return data; 
    }
}

export interface ICustomerUserProfilePreferencesDto {
    preferredSpokenLanguage?: Language | undefined;
    preferredWrittenLanguage?: Language | undefined;
    emailType?: string | undefined;
    receiveNotificationsByEmail?: boolean | undefined;
}

export class SearchLocationsDto implements ISearchLocationsDto {
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    maxDistance?: number | undefined;

    constructor(data?: ISearchLocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.maxDistance = _data["maxDistance"];
        }
    }

    static fromJS(data: any): SearchLocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["maxDistance"] = this.maxDistance;
        return data; 
    }
}

export interface ISearchLocationsDto {
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    maxDistance?: number | undefined;
}

export enum USCounty {
    AK_AleutiansEast = 0,
    AK_AleutiansWest = 1,
    AK_Anchorage = 2,
    AK_Bethel = 3,
    AK_BristolBay = 4,
    AK_Denali = 5,
    AK_Dillingham = 6,
    AK_FairbanksNorthStar = 7,
    AK_Haines = 8,
    AK_HoonahAngoon = 9,
    AK_Juneau = 10,
    AK_KenaiPeninsula = 11,
    AK_KetchikanGateway = 12,
    AK_KodiakIsland = 13,
    AK_LakeAndPeninsula = 14,
    AK_MatanuskaSusitna = 15,
    AK_Nome = 16,
    AK_NorthSlope = 17,
    AK_NorthwestArctic = 18,
    AK_Petersburg = 19,
    AK_PrinceOfWalesHyder = 20,
    AK_Sitka = 21,
    AK_Skagway = 22,
    AK_SoutheastFairbanks = 23,
    AK_ValdezCordova = 24,
    AK_WadeHampton = 25,
    AK_Wrangell = 26,
    AK_Yakutat = 27,
    AK_YukonKoyukuk = 28,
    AL_Autauga = 29,
    AL_Baldwin = 30,
    AL_Barbour = 31,
    AL_Bibb = 32,
    AL_Blount = 33,
    AL_Bullock = 34,
    AL_Butler = 35,
    AL_Calhoun = 36,
    AL_Chambers = 37,
    AL_Cherokee = 38,
    AL_Chilton = 39,
    AL_Choctaw = 40,
    AL_Clarke = 41,
    AL_Clay = 42,
    AL_Cleburne = 43,
    AL_Coffee = 44,
    AL_Colbert = 45,
    AL_Conecuh = 46,
    AL_Coosa = 47,
    AL_Covington = 48,
    AL_Crenshaw = 49,
    AL_Cullman = 50,
    AL_Dale = 51,
    AL_Dallas = 52,
    AL_DeKalb = 53,
    AL_Elmore = 54,
    AL_Escambia = 55,
    AL_Etowah = 56,
    AL_Fayette = 57,
    AL_Franklin = 58,
    AL_Geneva = 59,
    AL_Greene = 60,
    AL_Hale = 61,
    AL_Henry = 62,
    AL_Houston = 63,
    AL_Jackson = 64,
    AL_Jefferson = 65,
    AL_Lamar = 66,
    AL_Lauderdale = 67,
    AL_Lawrence = 68,
    AL_Lee = 69,
    AL_Limestone = 70,
    AL_Lowndes = 71,
    AL_Macon = 72,
    AL_Madison = 73,
    AL_Marengo = 74,
    AL_Marion = 75,
    AL_Marshall = 76,
    AL_Mobile = 77,
    AL_Monroe = 78,
    AL_Montgomery = 79,
    AL_Morgan = 80,
    AL_Perry = 81,
    AL_Pickens = 82,
    AL_Pike = 83,
    AL_Randolph = 84,
    AL_Russell = 85,
    AL_SaintClair = 86,
    AL_Shelby = 87,
    AL_Sumter = 88,
    AL_Talladega = 89,
    AL_Tallapoosa = 90,
    AL_Tuscaloosa = 91,
    AL_Walker = 92,
    AL_Washington = 93,
    AL_Wilcox = 94,
    AL_Winston = 95,
    AR_Arkansas = 96,
    AR_Ashley = 97,
    AR_Baxter = 98,
    AR_Benton = 99,
    AR_Boone = 100,
    AR_Bradley = 101,
    AR_Calhoun = 102,
    AR_Carroll = 103,
    AR_Chicot = 104,
    AR_Clark = 105,
    AR_Clay = 106,
    AR_Cleburne = 107,
    AR_Cleveland = 108,
    AR_Columbia = 109,
    AR_Conway = 110,
    AR_Craighead = 111,
    AR_Crawford = 112,
    AR_Crittenden = 113,
    AR_Cross = 114,
    AR_Dallas = 115,
    AR_Desha = 116,
    AR_Drew = 117,
    AR_Faulkner = 118,
    AR_Franklin = 119,
    AR_Fulton = 120,
    AR_Garland = 121,
    AR_Grant = 122,
    AR_Greene = 123,
    AR_Hempstead = 124,
    AR_HotSpring = 125,
    AR_Howard = 126,
    AR_Independence = 127,
    AR_Izard = 128,
    AR_Jackson = 129,
    AR_Jefferson = 130,
    AR_Johnson = 131,
    AR_Lafayette = 132,
    AR_Lawrence = 133,
    AR_Lee = 134,
    AR_Lincoln = 135,
    AR_LittleRiver = 136,
    AR_Logan = 137,
    AR_Lonoke = 138,
    AR_Madison = 139,
    AR_Marion = 140,
    AR_Miller = 141,
    AR_Mississippi = 142,
    AR_Monroe = 143,
    AR_Montgomery = 144,
    AR_Nevada = 145,
    AR_Newton = 146,
    AR_Ouachita = 147,
    AR_Perry = 148,
    AR_Phillips = 149,
    AR_Pike = 150,
    AR_Poinsett = 151,
    AR_Polk = 152,
    AR_Pope = 153,
    AR_Prairie = 154,
    AR_Pulaski = 155,
    AR_Randolph = 156,
    AR_SaintFrancis = 157,
    AR_Saline = 158,
    AR_Scott = 159,
    AR_Searcy = 160,
    AR_Sebastian = 161,
    AR_Sevier = 162,
    AR_Sharp = 163,
    AR_Stone = 164,
    AR_Union = 165,
    AR_VanBuren = 166,
    AR_Washington = 167,
    AR_White = 168,
    AR_Woodruff = 169,
    AR_Yell = 170,
    AS_AmericanSamoa = 171,
    AZ_Apache = 172,
    AZ_Cochise = 173,
    AZ_Coconino = 174,
    AZ_Gila = 175,
    AZ_Graham = 176,
    AZ_Greenlee = 177,
    AZ_LaPaz = 178,
    AZ_Maricopa = 179,
    AZ_Mohave = 180,
    AZ_Navajo = 181,
    AZ_Pima = 182,
    AZ_Pinal = 183,
    AZ_SantaCruz = 184,
    AZ_Yavapai = 185,
    AZ_Yuma = 186,
    CA_Alameda = 187,
    CA_Alpine = 188,
    CA_Amador = 189,
    CA_Butte = 190,
    CA_Calaveras = 191,
    CA_Colusa = 192,
    CA_ContraCosta = 193,
    CA_DelNorte = 194,
    CA_ElDorado = 195,
    CA_Fresno = 196,
    CA_Glenn = 197,
    CA_Humboldt = 198,
    CA_Imperial = 199,
    CA_Inyo = 200,
    CA_Kern = 201,
    CA_Kings = 202,
    CA_Lake = 203,
    CA_Lassen = 204,
    CA_LosAngeles = 205,
    CA_Madera = 206,
    CA_Marin = 207,
    CA_Mariposa = 208,
    CA_Mendocino = 209,
    CA_Merced = 210,
    CA_Modoc = 211,
    CA_Mono = 212,
    CA_Monterey = 213,
    CA_Napa = 214,
    CA_Nevada = 215,
    CA_Orange = 216,
    CA_Placer = 217,
    CA_Plumas = 218,
    CA_Riverside = 219,
    CA_Sacramento = 220,
    CA_SanBenito = 221,
    CA_SanBernardino = 222,
    CA_SanDiego = 223,
    CA_SanFrancisco = 224,
    CA_SanJoaquin = 225,
    CA_SanLuisObispo = 226,
    CA_SanMateo = 227,
    CA_SantaBarbara = 228,
    CA_SantaClara = 229,
    CA_SantaCruz = 230,
    CA_Shasta = 231,
    CA_Sierra = 232,
    CA_Siskiyou = 233,
    CA_Solano = 234,
    CA_Sonoma = 235,
    CA_Stanislaus = 236,
    CA_Sutter = 237,
    CA_Tehama = 238,
    CA_Trinity = 239,
    CA_Tulare = 240,
    CA_Tuolumne = 241,
    CA_Ventura = 242,
    CA_Yolo = 243,
    CA_Yuba = 244,
    CO_Adams = 245,
    CO_Alamosa = 246,
    CO_Arapahoe = 247,
    CO_Archuleta = 248,
    CO_Baca = 249,
    CO_Bent = 250,
    CO_Boulder = 251,
    CO_Broomfield = 252,
    CO_Chaffee = 253,
    CO_Cheyenne = 254,
    CO_ClearCreek = 255,
    CO_Conejos = 256,
    CO_Costilla = 257,
    CO_Crowley = 258,
    CO_Custer = 259,
    CO_Delta = 260,
    CO_Denver = 261,
    CO_Dolores = 262,
    CO_Douglas = 263,
    CO_Eagle = 264,
    CO_ElPaso = 265,
    CO_Elbert = 266,
    CO_Fremont = 267,
    CO_Garfield = 268,
    CO_Gilpin = 269,
    CO_Grand = 270,
    CO_Gunnison = 271,
    CO_Hinsdale = 272,
    CO_Huerfano = 273,
    CO_Jackson = 274,
    CO_Jefferson = 275,
    CO_Kiowa = 276,
    CO_KitCarson = 277,
    CO_LaPlata = 278,
    CO_Lake = 279,
    CO_Larimer = 280,
    CO_LasAnimas = 281,
    CO_Lincoln = 282,
    CO_Logan = 283,
    CO_Mesa = 284,
    CO_Mineral = 285,
    CO_Moffat = 286,
    CO_Montezuma = 287,
    CO_Montrose = 288,
    CO_Morgan = 289,
    CO_Otero = 290,
    CO_Ouray = 291,
    CO_Park = 292,
    CO_Phillips = 293,
    CO_Pitkin = 294,
    CO_Prowers = 295,
    CO_Pueblo = 296,
    CO_RioBlanco = 297,
    CO_RioGrande = 298,
    CO_Routt = 299,
    CO_Saguache = 300,
    CO_SanJuan = 301,
    CO_SanMiguel = 302,
    CO_Sedgwick = 303,
    CO_Summit = 304,
    CO_Teller = 305,
    CO_Washington = 306,
    CO_Weld = 307,
    CO_Yuma = 308,
    CT_Fairfield = 309,
    CT_Hartford = 310,
    CT_Litchfield = 311,
    CT_Middlesex = 312,
    CT_NewHaven = 313,
    CT_NewLondon = 314,
    CT_Tolland = 315,
    CT_Windham = 316,
    DC_DistrictOfColumbia = 317,
    DE_Kent = 318,
    DE_NewCastle = 319,
    DE_Sussex = 320,
    FL_Alachua = 321,
    FL_Baker = 322,
    FL_Bay = 323,
    FL_Bradford = 324,
    FL_Brevard = 325,
    FL_Broward = 326,
    FL_Calhoun = 327,
    FL_Charlotte = 328,
    FL_Citrus = 329,
    FL_Clay = 330,
    FL_Collier = 331,
    FL_Columbia = 332,
    FL_DeSoto = 333,
    FL_Dixie = 334,
    FL_Duval = 335,
    FL_Escambia = 336,
    FL_Flagler = 337,
    FL_Franklin = 338,
    FL_Gadsden = 339,
    FL_Gilchrist = 340,
    FL_Glades = 341,
    FL_Gulf = 342,
    FL_Hamilton = 343,
    FL_Hardee = 344,
    FL_Hendry = 345,
    FL_Hernando = 346,
    FL_Highlands = 347,
    FL_Hillsborough = 348,
    FL_Holmes = 349,
    FL_IndianRiver = 350,
    FL_Jackson = 351,
    FL_Jefferson = 352,
    FL_Lafayette = 353,
    FL_Lake = 354,
    FL_Lee = 355,
    FL_Leon = 356,
    FL_Levy = 357,
    FL_Liberty = 358,
    FL_Madison = 359,
    FL_Manatee = 360,
    FL_Marion = 361,
    FL_Martin = 362,
    FL_MiamiDade = 363,
    FL_Monroe = 364,
    FL_Nassau = 365,
    FL_Okaloosa = 366,
    FL_Okeechobee = 367,
    FL_Orange = 368,
    FL_Osceola = 369,
    FL_PalmBeach = 370,
    FL_Pasco = 371,
    FL_Pinellas = 372,
    FL_Polk = 373,
    FL_Putnam = 374,
    FL_SaintJohns = 375,
    FL_SaintLucie = 376,
    FL_SantaRosa = 377,
    FL_Sarasota = 378,
    FL_Seminole = 379,
    FL_Sumter = 380,
    FL_Suwannee = 381,
    FL_Taylor = 382,
    FL_Union = 383,
    FL_Volusia = 384,
    FL_Wakulla = 385,
    FL_Walton = 386,
    FL_Washington = 387,
    FM_FederatedStatesOfMicro = 388,
    GA_Appling = 389,
    GA_Atkinson = 390,
    GA_Bacon = 391,
    GA_Baker = 392,
    GA_Baldwin = 393,
    GA_Banks = 394,
    GA_Barrow = 395,
    GA_Bartow = 396,
    GA_BenHill = 397,
    GA_Berrien = 398,
    GA_Bibb = 399,
    GA_Bleckley = 400,
    GA_Brantley = 401,
    GA_Brooks = 402,
    GA_Bryan = 403,
    GA_Bulloch = 404,
    GA_Burke = 405,
    GA_Butts = 406,
    GA_Calhoun = 407,
    GA_Camden = 408,
    GA_Candler = 409,
    GA_Carroll = 410,
    GA_Catoosa = 411,
    GA_Charlton = 412,
    GA_Chatham = 413,
    GA_Chattahoochee = 414,
    GA_Chattooga = 415,
    GA_Cherokee = 416,
    GA_Clarke = 417,
    GA_Clay = 418,
    GA_Clayton = 419,
    GA_Clinch = 420,
    GA_Cobb = 421,
    GA_Coffee = 422,
    GA_Colquitt = 423,
    GA_Columbia = 424,
    GA_Cook = 425,
    GA_Coweta = 426,
    GA_Crawford = 427,
    GA_Crisp = 428,
    GA_Dade = 429,
    GA_Dawson = 430,
    GA_Decatur = 431,
    GA_Dekalb = 432,
    GA_Dodge = 433,
    GA_Dooly = 434,
    GA_Dougherty = 435,
    GA_Douglas = 436,
    GA_Early = 437,
    GA_Echols = 438,
    GA_Effingham = 439,
    GA_Elbert = 440,
    GA_Emanuel = 441,
    GA_Evans = 442,
    GA_Fannin = 443,
    GA_Fayette = 444,
    GA_Floyd = 445,
    GA_Forsyth = 446,
    GA_Franklin = 447,
    GA_Fulton = 448,
    GA_Gilmer = 449,
    GA_Glascock = 450,
    GA_Glynn = 451,
    GA_Gordon = 452,
    GA_Grady = 453,
    GA_Greene = 454,
    GA_Gwinnett = 455,
    GA_Habersham = 456,
    GA_Hall = 457,
    GA_Hancock = 458,
    GA_Haralson = 459,
    GA_Harris = 460,
    GA_Hart = 461,
    GA_Heard = 462,
    GA_Henry = 463,
    GA_Houston = 464,
    GA_Irwin = 465,
    GA_Jackson = 466,
    GA_Jasper = 467,
    GA_JeffDavis = 468,
    GA_Jefferson = 469,
    GA_Jenkins = 470,
    GA_Johnson = 471,
    GA_Jones = 472,
    GA_Lamar = 473,
    GA_Lanier = 474,
    GA_Laurens = 475,
    GA_Lee = 476,
    GA_Liberty = 477,
    GA_Lincoln = 478,
    GA_Long = 479,
    GA_Lowndes = 480,
    GA_Lumpkin = 481,
    GA_Macon = 482,
    GA_Madison = 483,
    GA_Marion = 484,
    GA_Mcduffie = 485,
    GA_Mcintosh = 486,
    GA_Meriwether = 487,
    GA_Miller = 488,
    GA_Mitchell = 489,
    GA_Monroe = 490,
    GA_Montgomery = 491,
    GA_Morgan = 492,
    GA_Murray = 493,
    GA_Muscogee = 494,
    GA_Newton = 495,
    GA_Oconee = 496,
    GA_Oglethorpe = 497,
    GA_Paulding = 498,
    GA_Peach = 499,
    GA_Pickens = 500,
    GA_Pierce = 501,
    GA_Pike = 502,
    GA_Polk = 503,
    GA_Pulaski = 504,
    GA_Putnam = 505,
    GA_Quitman = 506,
    GA_Rabun = 507,
    GA_Randolph = 508,
    GA_Richmond = 509,
    GA_Rockdale = 510,
    GA_Schley = 511,
    GA_Screven = 512,
    GA_Seminole = 513,
    GA_Spalding = 514,
    GA_Stephens = 515,
    GA_Stewart = 516,
    GA_Sumter = 517,
    GA_Talbot = 518,
    GA_Taliaferro = 519,
    GA_Tattnall = 520,
    GA_Taylor = 521,
    GA_Telfair = 522,
    GA_Terrell = 523,
    GA_Thomas = 524,
    GA_Tift = 525,
    GA_Toombs = 526,
    GA_Towns = 527,
    GA_Treutlen = 528,
    GA_Troup = 529,
    GA_Turner = 530,
    GA_Twiggs = 531,
    GA_Union = 532,
    GA_Upson = 533,
    GA_Walker = 534,
    GA_Walton = 535,
    GA_Ware = 536,
    GA_Warren = 537,
    GA_Washington = 538,
    GA_Wayne = 539,
    GA_Webster = 540,
    GA_Wheeler = 541,
    GA_White = 542,
    GA_Whitfield = 543,
    GA_Wilcox = 544,
    GA_Wilkes = 545,
    GA_Wilkinson = 546,
    GA_Worth = 547,
    GU_Guam = 548,
    HI_Hawaii = 549,
    HI_Honolulu = 550,
    HI_Kauai = 551,
    HI_Maui = 552,
    IA_Adair = 553,
    IA_Adams = 554,
    IA_Allamakee = 555,
    IA_Appanoose = 556,
    IA_Audubon = 557,
    IA_Benton = 558,
    IA_BlackHawk = 559,
    IA_Boone = 560,
    IA_Bremer = 561,
    IA_Buchanan = 562,
    IA_BuenaVista = 563,
    IA_Butler = 564,
    IA_Calhoun = 565,
    IA_Carroll = 566,
    IA_Cass = 567,
    IA_Cedar = 568,
    IA_CerroGordo = 569,
    IA_Cherokee = 570,
    IA_Chickasaw = 571,
    IA_Clarke = 572,
    IA_Clay = 573,
    IA_Clayton = 574,
    IA_Clinton = 575,
    IA_Crawford = 576,
    IA_Dallas = 577,
    IA_Davis = 578,
    IA_Decatur = 579,
    IA_Delaware = 580,
    IA_DesMoines = 581,
    IA_Dickinson = 582,
    IA_Dubuque = 583,
    IA_Emmet = 584,
    IA_Fayette = 585,
    IA_Floyd = 586,
    IA_Franklin = 587,
    IA_Fremont = 588,
    IA_Greene = 589,
    IA_Grundy = 590,
    IA_Guthrie = 591,
    IA_Hamilton = 592,
    IA_Hancock = 593,
    IA_Hardin = 594,
    IA_Harrison = 595,
    IA_Henry = 596,
    IA_Howard = 597,
    IA_Humboldt = 598,
    IA_Ida = 599,
    IA_Iowa = 600,
    IA_Jackson = 601,
    IA_Jasper = 602,
    IA_Jefferson = 603,
    IA_Johnson = 604,
    IA_Jones = 605,
    IA_Keokuk = 606,
    IA_Kossuth = 607,
    IA_Lee = 608,
    IA_Linn = 609,
    IA_Louisa = 610,
    IA_Lucas = 611,
    IA_Lyon = 612,
    IA_Madison = 613,
    IA_Mahaska = 614,
    IA_Marion = 615,
    IA_Marshall = 616,
    IA_Mills = 617,
    IA_Mitchell = 618,
    IA_Monona = 619,
    IA_Monroe = 620,
    IA_Montgomery = 621,
    IA_Muscatine = 622,
    IA_Obrien = 623,
    IA_Osceola = 624,
    IA_Page = 625,
    IA_PaloAlto = 626,
    IA_Plymouth = 627,
    IA_Pocahontas = 628,
    IA_Polk = 629,
    IA_Pottawattamie = 630,
    IA_Poweshiek = 631,
    IA_Ringgold = 632,
    IA_Sac = 633,
    IA_Scott = 634,
    IA_Shelby = 635,
    IA_Sioux = 636,
    IA_Story = 637,
    IA_Tama = 638,
    IA_Taylor = 639,
    IA_Union = 640,
    IA_VanBuren = 641,
    IA_Wapello = 642,
    IA_Warren = 643,
    IA_Washington = 644,
    IA_Wayne = 645,
    IA_Webster = 646,
    IA_Winnebago = 647,
    IA_Winneshiek = 648,
    IA_Woodbury = 649,
    IA_Worth = 650,
    IA_Wright = 651,
    ID_Ada = 652,
    ID_Adams = 653,
    ID_Bannock = 654,
    ID_BearLake = 655,
    ID_Benewah = 656,
    ID_Bingham = 657,
    ID_Blaine = 658,
    ID_Boise = 659,
    ID_Bonner = 660,
    ID_Bonneville = 661,
    ID_Boundary = 662,
    ID_Butte = 663,
    ID_Camas = 664,
    ID_Canyon = 665,
    ID_Caribou = 666,
    ID_Cassia = 667,
    ID_Clark = 668,
    ID_Clearwater = 669,
    ID_Custer = 670,
    ID_Elmore = 671,
    ID_Franklin = 672,
    ID_Fremont = 673,
    ID_Gem = 674,
    ID_Gooding = 675,
    ID_Idaho = 676,
    ID_Jefferson = 677,
    ID_Jerome = 678,
    ID_Kootenai = 679,
    ID_Latah = 680,
    ID_Lemhi = 681,
    ID_Lewis = 682,
    ID_Lincoln = 683,
    ID_Madison = 684,
    ID_Minidoka = 685,
    ID_NezPerce = 686,
    ID_Oneida = 687,
    ID_Owyhee = 688,
    ID_Payette = 689,
    ID_Power = 690,
    ID_Shoshone = 691,
    ID_Teton = 692,
    ID_TwinFalls = 693,
    ID_Valley = 694,
    ID_Washington = 695,
    IL_Adams = 696,
    IL_Alexander = 697,
    IL_Bond = 698,
    IL_Boone = 699,
    IL_Brown = 700,
    IL_Bureau = 701,
    IL_Calhoun = 702,
    IL_Carroll = 703,
    IL_Cass = 704,
    IL_Champaign = 705,
    IL_Christian = 706,
    IL_Clark = 707,
    IL_Clay = 708,
    IL_Clinton = 709,
    IL_Coles = 710,
    IL_Cook = 711,
    IL_Crawford = 712,
    IL_Cumberland = 713,
    IL_Dekalb = 714,
    IL_Dewitt = 715,
    IL_Douglas = 716,
    IL_Dupage = 717,
    IL_Edgar = 718,
    IL_Edwards = 719,
    IL_Effingham = 720,
    IL_Fayette = 721,
    IL_Ford = 722,
    IL_Franklin = 723,
    IL_Fulton = 724,
    IL_Gallatin = 725,
    IL_Greene = 726,
    IL_Grundy = 727,
    IL_Hamilton = 728,
    IL_Hancock = 729,
    IL_Hardin = 730,
    IL_Henderson = 731,
    IL_Henry = 732,
    IL_Iroquois = 733,
    IL_Jackson = 734,
    IL_Jasper = 735,
    IL_Jefferson = 736,
    IL_Jersey = 737,
    IL_JoDaviess = 738,
    IL_Johnson = 739,
    IL_Kane = 740,
    IL_Kankakee = 741,
    IL_Kendall = 742,
    IL_Knox = 743,
    IL_LaSalle = 744,
    IL_Lake = 745,
    IL_Lawrence = 746,
    IL_Lee = 747,
    IL_Livingston = 748,
    IL_Logan = 749,
    IL_Macon = 750,
    IL_Macoupin = 751,
    IL_Madison = 752,
    IL_Marion = 753,
    IL_Marshall = 754,
    IL_Mason = 755,
    IL_Massac = 756,
    IL_Mcdonough = 757,
    IL_Mchenry = 758,
    IL_Mclean = 759,
    IL_Menard = 760,
    IL_Mercer = 761,
    IL_Monroe = 762,
    IL_Montgomery = 763,
    IL_Morgan = 764,
    IL_Moultrie = 765,
    IL_Ogle = 766,
    IL_Peoria = 767,
    IL_Perry = 768,
    IL_Piatt = 769,
    IL_Pike = 770,
    IL_Pope = 771,
    IL_Pulaski = 772,
    IL_Putnam = 773,
    IL_Randolph = 774,
    IL_Richland = 775,
    IL_RockIsland = 776,
    IL_SaintClair = 777,
    IL_Saline = 778,
    IL_Sangamon = 779,
    IL_Schuyler = 780,
    IL_Scott = 781,
    IL_Shelby = 782,
    IL_Stark = 783,
    IL_Stephenson = 784,
    IL_Tazewell = 785,
    IL_Union = 786,
    IL_Vermilion = 787,
    IL_Wabash = 788,
    IL_Warren = 789,
    IL_Washington = 790,
    IL_Wayne = 791,
    IL_White = 792,
    IL_Whiteside = 793,
    IL_Will = 794,
    IL_Williamson = 795,
    IL_Winnebago = 796,
    IL_Woodford = 797,
    IN_Adams = 798,
    IN_Allen = 799,
    IN_Bartholomew = 800,
    IN_Benton = 801,
    IN_Blackford = 802,
    IN_Boone = 803,
    IN_Brown = 804,
    IN_Carroll = 805,
    IN_Cass = 806,
    IN_Clark = 807,
    IN_Clay = 808,
    IN_Clinton = 809,
    IN_Crawford = 810,
    IN_Daviess = 811,
    IN_DeKalb = 812,
    IN_Dearborn = 813,
    IN_Decatur = 814,
    IN_Delaware = 815,
    IN_Dubois = 816,
    IN_Elkhart = 817,
    IN_Fayette = 818,
    IN_Floyd = 819,
    IN_Fountain = 820,
    IN_Franklin = 821,
    IN_Fulton = 822,
    IN_Gibson = 823,
    IN_Grant = 824,
    IN_Greene = 825,
    IN_Hamilton = 826,
    IN_Hancock = 827,
    IN_Harrison = 828,
    IN_Hendricks = 829,
    IN_Henry = 830,
    IN_Howard = 831,
    IN_Huntington = 832,
    IN_Jackson = 833,
    IN_Jasper = 834,
    IN_Jay = 835,
    IN_Jefferson = 836,
    IN_Jennings = 837,
    IN_Johnson = 838,
    IN_Knox = 839,
    IN_Kosciusko = 840,
    IN_LaPorte = 841,
    IN_Lagrange = 842,
    IN_Lake = 843,
    IN_Lawrence = 844,
    IN_Madison = 845,
    IN_Marion = 846,
    IN_Marshall = 847,
    IN_Martin = 848,
    IN_Miami = 849,
    IN_Monroe = 850,
    IN_Montgomery = 851,
    IN_Morgan = 852,
    IN_Newton = 853,
    IN_Noble = 854,
    IN_Ohio = 855,
    IN_Orange = 856,
    IN_Owen = 857,
    IN_Parke = 858,
    IN_Perry = 859,
    IN_Pike = 860,
    IN_Porter = 861,
    IN_Posey = 862,
    IN_Pulaski = 863,
    IN_Putnam = 864,
    IN_Randolph = 865,
    IN_Ripley = 866,
    IN_Rush = 867,
    IN_Scott = 868,
    IN_Shelby = 869,
    IN_Spencer = 870,
    IN_StJoseph = 871,
    IN_Starke = 872,
    IN_Steuben = 873,
    IN_Sullivan = 874,
    IN_Switzerland = 875,
    IN_Tippecanoe = 876,
    IN_Tipton = 877,
    IN_Union = 878,
    IN_Vanderburgh = 879,
    IN_Vermillion = 880,
    IN_Vigo = 881,
    IN_Wabash = 882,
    IN_Warren = 883,
    IN_Warrick = 884,
    IN_Washington = 885,
    IN_Wayne = 886,
    IN_Wells = 887,
    IN_White = 888,
    IN_Whitley = 889,
    KS_Allen = 890,
    KS_Anderson = 891,
    KS_Atchison = 892,
    KS_Barber = 893,
    KS_Barton = 894,
    KS_Bourbon = 895,
    KS_Brown = 896,
    KS_Butler = 897,
    KS_Chase = 898,
    KS_Chautauqua = 899,
    KS_Cherokee = 900,
    KS_Cheyenne = 901,
    KS_Clark = 902,
    KS_Clay = 903,
    KS_Cloud = 904,
    KS_Coffey = 905,
    KS_Comanche = 906,
    KS_Cowley = 907,
    KS_Crawford = 908,
    KS_Decatur = 909,
    KS_Dickinson = 910,
    KS_Doniphan = 911,
    KS_Douglas = 912,
    KS_Edwards = 913,
    KS_Elk = 914,
    KS_Ellis = 915,
    KS_Ellsworth = 916,
    KS_Finney = 917,
    KS_Ford = 918,
    KS_Franklin = 919,
    KS_Geary = 920,
    KS_Gove = 921,
    KS_Graham = 922,
    KS_Grant = 923,
    KS_Gray = 924,
    KS_Greeley = 925,
    KS_Greenwood = 926,
    KS_Hamilton = 927,
    KS_Harper = 928,
    KS_Harvey = 929,
    KS_Haskell = 930,
    KS_Hodgeman = 931,
    KS_Jackson = 932,
    KS_Jefferson = 933,
    KS_Jewell = 934,
    KS_Johnson = 935,
    KS_Kearny = 936,
    KS_Kingman = 937,
    KS_Kiowa = 938,
    KS_Labette = 939,
    KS_Lane = 940,
    KS_Leavenworth = 941,
    KS_Lincoln = 942,
    KS_Linn = 943,
    KS_Logan = 944,
    KS_Lyon = 945,
    KS_Marion = 946,
    KS_Marshall = 947,
    KS_Mcpherson = 948,
    KS_Meade = 949,
    KS_Miami = 950,
    KS_Mitchell = 951,
    KS_Montgomery = 952,
    KS_Morris = 953,
    KS_Morton = 954,
    KS_Nemaha = 955,
    KS_Neosho = 956,
    KS_Ness = 957,
    KS_Norton = 958,
    KS_Osage = 959,
    KS_Osborne = 960,
    KS_Ottawa = 961,
    KS_Pawnee = 962,
    KS_Phillips = 963,
    KS_Pottawatomie = 964,
    KS_Pratt = 965,
    KS_Rawlins = 966,
    KS_Reno = 967,
    KS_Republic = 968,
    KS_Rice = 969,
    KS_Riley = 970,
    KS_Rooks = 971,
    KS_Rush = 972,
    KS_Russell = 973,
    KS_Saline = 974,
    KS_Scott = 975,
    KS_Sedgwick = 976,
    KS_Seward = 977,
    KS_Shawnee = 978,
    KS_Sheridan = 979,
    KS_Sherman = 980,
    KS_Smith = 981,
    KS_Stafford = 982,
    KS_Stanton = 983,
    KS_Stevens = 984,
    KS_Sumner = 985,
    KS_Thomas = 986,
    KS_Trego = 987,
    KS_Wabaunsee = 988,
    KS_Wallace = 989,
    KS_Washington = 990,
    KS_Wichita = 991,
    KS_Wilson = 992,
    KS_Woodson = 993,
    KS_Wyandotte = 994,
    KY_Adair = 995,
    KY_Allen = 996,
    KY_Anderson = 997,
    KY_Ballard = 998,
    KY_Barren = 999,
    KY_Bath = 1000,
    KY_Bell = 1001,
    KY_Boone = 1002,
    KY_Bourbon = 1003,
    KY_Boyd = 1004,
    KY_Boyle = 1005,
    KY_Bracken = 1006,
    KY_Breathitt = 1007,
    KY_Breckinridge = 1008,
    KY_Bullitt = 1009,
    KY_Butler = 1010,
    KY_Caldwell = 1011,
    KY_Calloway = 1012,
    KY_Campbell = 1013,
    KY_Carlisle = 1014,
    KY_Carroll = 1015,
    KY_Carter = 1016,
    KY_Casey = 1017,
    KY_Christian = 1018,
    KY_Clark = 1019,
    KY_Clay = 1020,
    KY_Clinton = 1021,
    KY_Crittenden = 1022,
    KY_Cumberland = 1023,
    KY_Daviess = 1024,
    KY_Edmonson = 1025,
    KY_Elliott = 1026,
    KY_Estill = 1027,
    KY_Fayette = 1028,
    KY_Fleming = 1029,
    KY_Floyd = 1030,
    KY_Franklin = 1031,
    KY_Fulton = 1032,
    KY_Gallatin = 1033,
    KY_Garrard = 1034,
    KY_Grant = 1035,
    KY_Graves = 1036,
    KY_Grayson = 1037,
    KY_Green = 1038,
    KY_Greenup = 1039,
    KY_Hancock = 1040,
    KY_Hardin = 1041,
    KY_Harlan = 1042,
    KY_Harrison = 1043,
    KY_Hart = 1044,
    KY_Henderson = 1045,
    KY_Henry = 1046,
    KY_Hickman = 1047,
    KY_Hopkins = 1048,
    KY_Jackson = 1049,
    KY_Jefferson = 1050,
    KY_Jessamine = 1051,
    KY_Johnson = 1052,
    KY_Kenton = 1053,
    KY_Knott = 1054,
    KY_Knox = 1055,
    KY_Larue = 1056,
    KY_Laurel = 1057,
    KY_Lawrence = 1058,
    KY_Lee = 1059,
    KY_Leslie = 1060,
    KY_Letcher = 1061,
    KY_Lewis = 1062,
    KY_Lincoln = 1063,
    KY_Livingston = 1064,
    KY_Logan = 1065,
    KY_Lyon = 1066,
    KY_Madison = 1067,
    KY_Magoffin = 1068,
    KY_Marion = 1069,
    KY_Marshall = 1070,
    KY_Martin = 1071,
    KY_Mason = 1072,
    KY_Mccracken = 1073,
    KY_Mccreary = 1074,
    KY_Mclean = 1075,
    KY_Meade = 1076,
    KY_Menifee = 1077,
    KY_Mercer = 1078,
    KY_Metcalfe = 1079,
    KY_Monroe = 1080,
    KY_Montgomery = 1081,
    KY_Morgan = 1082,
    KY_Muhlenberg = 1083,
    KY_Nelson = 1084,
    KY_Nicholas = 1085,
    KY_Ohio = 1086,
    KY_Oldham = 1087,
    KY_Owen = 1088,
    KY_Owsley = 1089,
    KY_Pendleton = 1090,
    KY_Perry = 1091,
    KY_Pike = 1092,
    KY_Powell = 1093,
    KY_Pulaski = 1094,
    KY_Robertson = 1095,
    KY_Rockcastle = 1096,
    KY_Rowan = 1097,
    KY_Russell = 1098,
    KY_Scott = 1099,
    KY_Shelby = 1100,
    KY_Simpson = 1101,
    KY_Spencer = 1102,
    KY_Taylor = 1103,
    KY_Todd = 1104,
    KY_Trigg = 1105,
    KY_Trimble = 1106,
    KY_Union = 1107,
    KY_Warren = 1108,
    KY_Washington = 1109,
    KY_Wayne = 1110,
    KY_Webster = 1111,
    KY_Whitley = 1112,
    KY_Wolfe = 1113,
    KY_Woodford = 1114,
    LA_Acadia = 1115,
    LA_Allen = 1116,
    LA_Ascension = 1117,
    LA_Assumption = 1118,
    LA_Avoyelles = 1119,
    LA_Beauregard = 1120,
    LA_Bienville = 1121,
    LA_Bossier = 1122,
    LA_Caddo = 1123,
    LA_Calcasieu = 1124,
    LA_Caldwell = 1125,
    LA_Cameron = 1126,
    LA_Catahoula = 1127,
    LA_Claiborne = 1128,
    LA_Concordia = 1129,
    LA_DeSoto = 1130,
    LA_EastBatonRouge = 1131,
    LA_EastCarroll = 1132,
    LA_EastFeliciana = 1133,
    LA_Evangeline = 1134,
    LA_Franklin = 1135,
    LA_Grant = 1136,
    LA_Iberia = 1137,
    LA_Iberville = 1138,
    LA_Jackson = 1139,
    LA_JeffersonDavis = 1140,
    LA_Jefferson = 1141,
    LA_LaSalle = 1142,
    LA_Lafayette = 1143,
    LA_Lafourche = 1144,
    LA_Lincoln = 1145,
    LA_Livingston = 1146,
    LA_Madison = 1147,
    LA_Morehouse = 1148,
    LA_Natchitoches = 1149,
    LA_Orleans = 1150,
    LA_Ouachita = 1151,
    LA_Plaquemines = 1152,
    LA_PointeCoupee = 1153,
    LA_Rapides = 1154,
    LA_RedRiver = 1155,
    LA_Richland = 1156,
    LA_Sabine = 1157,
    LA_SaintBernard = 1158,
    LA_SaintCharles = 1159,
    LA_SaintHelena = 1160,
    LA_SaintJames = 1161,
    LA_SaintLandry = 1162,
    LA_SaintMartin = 1163,
    LA_SaintMary = 1164,
    LA_SaintTammany = 1165,
    LA_StJohnTheBaptist = 1166,
    LA_Tangipahoa = 1167,
    LA_Tensas = 1168,
    LA_Terrebonne = 1169,
    LA_Union = 1170,
    LA_Vermilion = 1171,
    LA_Vernon = 1172,
    LA_Washington = 1173,
    LA_Webster = 1174,
    LA_WestBatonRouge = 1175,
    LA_WestCarroll = 1176,
    LA_WestFeliciana = 1177,
    LA_Winn = 1178,
    MA_Barnstable = 1179,
    MA_Berkshire = 1180,
    MA_Bristol = 1181,
    MA_Dukes = 1182,
    MA_Essex = 1183,
    MA_Franklin = 1184,
    MA_Hampden = 1185,
    MA_Hampshire = 1186,
    MA_Middlesex = 1187,
    MA_Nantucket = 1188,
    MA_Norfolk = 1189,
    MA_Plymouth = 1190,
    MA_Suffolk = 1191,
    MA_Worcester = 1192,
    MD_Allegany = 1193,
    MD_AnneArundel = 1194,
    MD_BaltimoreCity = 1195,
    MD_Baltimore = 1196,
    MD_Calvert = 1197,
    MD_Caroline = 1198,
    MD_Carroll = 1199,
    MD_Cecil = 1200,
    MD_Charles = 1201,
    MD_Dorchester = 1202,
    MD_Frederick = 1203,
    MD_Garrett = 1204,
    MD_Harford = 1205,
    MD_Howard = 1206,
    MD_Kent = 1207,
    MD_Montgomery = 1208,
    MD_PrinceGeorges = 1209,
    MD_QueenAnnes = 1210,
    MD_SaintMarys = 1211,
    MD_Somerset = 1212,
    MD_Talbot = 1213,
    MD_Washington = 1214,
    MD_Wicomico = 1215,
    MD_Worcester = 1216,
    ME_Androscoggin = 1217,
    ME_Aroostook = 1218,
    ME_Cumberland = 1219,
    ME_Franklin = 1220,
    ME_Hancock = 1221,
    ME_Kennebec = 1222,
    ME_Knox = 1223,
    ME_Lincoln = 1224,
    ME_Oxford = 1225,
    ME_Penobscot = 1226,
    ME_Piscataquis = 1227,
    ME_Sagadahoc = 1228,
    ME_Somerset = 1229,
    ME_Waldo = 1230,
    ME_Washington = 1231,
    ME_York = 1232,
    MH_MarshallIslands = 1233,
    MI_Alcona = 1234,
    MI_Alger = 1235,
    MI_Allegan = 1236,
    MI_Alpena = 1237,
    MI_Antrim = 1238,
    MI_Arenac = 1239,
    MI_Baraga = 1240,
    MI_Barry = 1241,
    MI_Bay = 1242,
    MI_Benzie = 1243,
    MI_Berrien = 1244,
    MI_Branch = 1245,
    MI_Calhoun = 1246,
    MI_Cass = 1247,
    MI_Charlevoix = 1248,
    MI_Cheboygan = 1249,
    MI_Chippewa = 1250,
    MI_Clare = 1251,
    MI_Clinton = 1252,
    MI_Crawford = 1253,
    MI_Delta = 1254,
    MI_Dickinson = 1255,
    MI_Eaton = 1256,
    MI_Emmet = 1257,
    MI_Genesee = 1258,
    MI_Gladwin = 1259,
    MI_Gogebic = 1260,
    MI_GrandTraverse = 1261,
    MI_Gratiot = 1262,
    MI_Hillsdale = 1263,
    MI_Houghton = 1264,
    MI_Huron = 1265,
    MI_Ingham = 1266,
    MI_Ionia = 1267,
    MI_Iosco = 1268,
    MI_Iron = 1269,
    MI_Isabella = 1270,
    MI_Jackson = 1271,
    MI_Kalamazoo = 1272,
    MI_Kalkaska = 1273,
    MI_Kent = 1274,
    MI_Keweenaw = 1275,
    MI_Lake = 1276,
    MI_Lapeer = 1277,
    MI_Leelanau = 1278,
    MI_Lenawee = 1279,
    MI_Livingston = 1280,
    MI_Luce = 1281,
    MI_Mackinac = 1282,
    MI_Macomb = 1283,
    MI_Manistee = 1284,
    MI_Marquette = 1285,
    MI_Mason = 1286,
    MI_Mecosta = 1287,
    MI_Menominee = 1288,
    MI_Midland = 1289,
    MI_Missaukee = 1290,
    MI_Monroe = 1291,
    MI_Montcalm = 1292,
    MI_Montmorency = 1293,
    MI_Muskegon = 1294,
    MI_Newaygo = 1295,
    MI_Oakland = 1296,
    MI_Oceana = 1297,
    MI_Ogemaw = 1298,
    MI_Ontonagon = 1299,
    MI_Osceola = 1300,
    MI_Oscoda = 1301,
    MI_Otsego = 1302,
    MI_Ottawa = 1303,
    MI_PresqueIsle = 1304,
    MI_Roscommon = 1305,
    MI_Saginaw = 1306,
    MI_SaintClair = 1307,
    MI_SaintJoseph = 1308,
    MI_Sanilac = 1309,
    MI_Schoolcraft = 1310,
    MI_Shiawassee = 1311,
    MI_Tuscola = 1312,
    MI_VanBuren = 1313,
    MI_Washtenaw = 1314,
    MI_Wayne = 1315,
    MI_Wexford = 1316,
    MN_Aitkin = 1317,
    MN_Anoka = 1318,
    MN_Becker = 1319,
    MN_Beltrami = 1320,
    MN_Benton = 1321,
    MN_BigStone = 1322,
    MN_BlueEarth = 1323,
    MN_Brown = 1324,
    MN_Carlton = 1325,
    MN_Carver = 1326,
    MN_Cass = 1327,
    MN_Chippewa = 1328,
    MN_Chisago = 1329,
    MN_Clay = 1330,
    MN_Clearwater = 1331,
    MN_Cook = 1332,
    MN_Cottonwood = 1333,
    MN_CrowWing = 1334,
    MN_Dakota = 1335,
    MN_Dodge = 1336,
    MN_Douglas = 1337,
    MN_Faribault = 1338,
    MN_Fillmore = 1339,
    MN_Freeborn = 1340,
    MN_Goodhue = 1341,
    MN_Grant = 1342,
    MN_Hennepin = 1343,
    MN_Houston = 1344,
    MN_Hubbard = 1345,
    MN_Isanti = 1346,
    MN_Itasca = 1347,
    MN_Jackson = 1348,
    MN_Kanabec = 1349,
    MN_Kandiyohi = 1350,
    MN_Kittson = 1351,
    MN_Koochiching = 1352,
    MN_LacQuiParle = 1353,
    MN_LakeOfTheWoods = 1354,
    MN_Lake = 1355,
    MN_LeSueur = 1356,
    MN_Lincoln = 1357,
    MN_Lyon = 1358,
    MN_Mahnomen = 1359,
    MN_Marshall = 1360,
    MN_Martin = 1361,
    MN_Mcleod = 1362,
    MN_Meeker = 1363,
    MN_MilleLacs = 1364,
    MN_Morrison = 1365,
    MN_Mower = 1366,
    MN_Murray = 1367,
    MN_Nicollet = 1368,
    MN_Nobles = 1369,
    MN_Norman = 1370,
    MN_Olmsted = 1371,
    MN_OtterTail = 1372,
    MN_Pennington = 1373,
    MN_Pine = 1374,
    MN_Pipestone = 1375,
    MN_Polk = 1376,
    MN_Pope = 1377,
    MN_Ramsey = 1378,
    MN_RedLake = 1379,
    MN_Redwood = 1380,
    MN_Renville = 1381,
    MN_Rice = 1382,
    MN_Rock = 1383,
    MN_Roseau = 1384,
    MN_SaintLouis = 1385,
    MN_Scott = 1386,
    MN_Sherburne = 1387,
    MN_Sibley = 1388,
    MN_Stearns = 1389,
    MN_Steele = 1390,
    MN_Stevens = 1391,
    MN_Swift = 1392,
    MN_Todd = 1393,
    MN_Traverse = 1394,
    MN_Wabasha = 1395,
    MN_Wadena = 1396,
    MN_Waseca = 1397,
    MN_Washington = 1398,
    MN_Watonwan = 1399,
    MN_Wilkin = 1400,
    MN_Winona = 1401,
    MN_Wright = 1402,
    MN_YellowMedicine = 1403,
    MO_Adair = 1404,
    MO_Andrew = 1405,
    MO_Atchison = 1406,
    MO_Audrain = 1407,
    MO_Barry = 1408,
    MO_Barton = 1409,
    MO_Bates = 1410,
    MO_Benton = 1411,
    MO_Bollinger = 1412,
    MO_Boone = 1413,
    MO_Buchanan = 1414,
    MO_Butler = 1415,
    MO_Caldwell = 1416,
    MO_Callaway = 1417,
    MO_Camden = 1418,
    MO_CapeGirardeau = 1419,
    MO_Carroll = 1420,
    MO_Carter = 1421,
    MO_Cass = 1422,
    MO_Cedar = 1423,
    MO_Chariton = 1424,
    MO_Christian = 1425,
    MO_Clark = 1426,
    MO_Clay = 1427,
    MO_Clinton = 1428,
    MO_Cole = 1429,
    MO_Cooper = 1430,
    MO_Crawford = 1431,
    MO_Dade = 1432,
    MO_Dallas = 1433,
    MO_Daviess = 1434,
    MO_Dekalb = 1435,
    MO_Dent = 1436,
    MO_Douglas = 1437,
    MO_Dunklin = 1438,
    MO_Franklin = 1439,
    MO_Gasconade = 1440,
    MO_Gentry = 1441,
    MO_Greene = 1442,
    MO_Grundy = 1443,
    MO_Harrison = 1444,
    MO_Henry = 1445,
    MO_Hickory = 1446,
    MO_Holt = 1447,
    MO_Howard = 1448,
    MO_Howell = 1449,
    MO_Iron = 1450,
    MO_Jackson = 1451,
    MO_Jasper = 1452,
    MO_Jefferson = 1453,
    MO_Johnson = 1454,
    MO_Knox = 1455,
    MO_Laclede = 1456,
    MO_Lafayette = 1457,
    MO_Lawrence = 1458,
    MO_Lewis = 1459,
    MO_Lincoln = 1460,
    MO_Linn = 1461,
    MO_Livingston = 1462,
    MO_Macon = 1463,
    MO_Madison = 1464,
    MO_Maries = 1465,
    MO_Marion = 1466,
    MO_Mcdonald = 1467,
    MO_Mercer = 1468,
    MO_Miller = 1469,
    MO_Mississippi = 1470,
    MO_Moniteau = 1471,
    MO_Monroe = 1472,
    MO_Montgomery = 1473,
    MO_Morgan = 1474,
    MO_NewMadrid = 1475,
    MO_Newton = 1476,
    MO_Nodaway = 1477,
    MO_Oregon = 1478,
    MO_Osage = 1479,
    MO_Ozark = 1480,
    MO_Pemiscot = 1481,
    MO_Perry = 1482,
    MO_Pettis = 1483,
    MO_Phelps = 1484,
    MO_Pike = 1485,
    MO_Platte = 1486,
    MO_Polk = 1487,
    MO_Pulaski = 1488,
    MO_Putnam = 1489,
    MO_Ralls = 1490,
    MO_Randolph = 1491,
    MO_Ray = 1492,
    MO_Reynolds = 1493,
    MO_Ripley = 1494,
    MO_SaintCharles = 1495,
    MO_SaintClair = 1496,
    MO_SaintFrancois = 1497,
    MO_SaintLouisCity = 1498,
    MO_SaintLouis = 1499,
    MO_SainteGenevieve = 1500,
    MO_Saline = 1501,
    MO_Schuyler = 1502,
    MO_Scotland = 1503,
    MO_Scott = 1504,
    MO_Shannon = 1505,
    MO_Shelby = 1506,
    MO_Stoddard = 1507,
    MO_Stone = 1508,
    MO_Sullivan = 1509,
    MO_Taney = 1510,
    MO_Texas = 1511,
    MO_Vernon = 1512,
    MO_Warren = 1513,
    MO_Washington = 1514,
    MO_Wayne = 1515,
    MO_Webster = 1516,
    MO_Worth = 1517,
    MO_Wright = 1518,
    MP_NorthernMarianaIslands = 1519,
    MS_Adams = 1520,
    MS_Alcorn = 1521,
    MS_Amite = 1522,
    MS_Attala = 1523,
    MS_Benton = 1524,
    MS_Bolivar = 1525,
    MS_Calhoun = 1526,
    MS_Carroll = 1527,
    MS_Chickasaw = 1528,
    MS_Choctaw = 1529,
    MS_Claiborne = 1530,
    MS_Clarke = 1531,
    MS_Clay = 1532,
    MS_Coahoma = 1533,
    MS_Copiah = 1534,
    MS_Covington = 1535,
    MS_Desoto = 1536,
    MS_Forrest = 1537,
    MS_Franklin = 1538,
    MS_George = 1539,
    MS_Greene = 1540,
    MS_Grenada = 1541,
    MS_Hancock = 1542,
    MS_Harrison = 1543,
    MS_Hinds = 1544,
    MS_Holmes = 1545,
    MS_Humphreys = 1546,
    MS_Issaquena = 1547,
    MS_Itawamba = 1548,
    MS_Jackson = 1549,
    MS_Jasper = 1550,
    MS_JeffersonDavis = 1551,
    MS_Jefferson = 1552,
    MS_Jones = 1553,
    MS_Kemper = 1554,
    MS_Lafayette = 1555,
    MS_Lamar = 1556,
    MS_Lauderdale = 1557,
    MS_Lawrence = 1558,
    MS_Leake = 1559,
    MS_Lee = 1560,
    MS_Leflore = 1561,
    MS_Lincoln = 1562,
    MS_Lowndes = 1563,
    MS_Madison = 1564,
    MS_Marion = 1565,
    MS_Marshall = 1566,
    MS_Monroe = 1567,
    MS_Montgomery = 1568,
    MS_Neshoba = 1569,
    MS_Newton = 1570,
    MS_Noxubee = 1571,
    MS_Oktibbeha = 1572,
    MS_Panola = 1573,
    MS_PearlRiver = 1574,
    MS_Perry = 1575,
    MS_Pike = 1576,
    MS_Pontotoc = 1577,
    MS_Prentiss = 1578,
    MS_Quitman = 1579,
    MS_Rankin = 1580,
    MS_Scott = 1581,
    MS_Sharkey = 1582,
    MS_Simpson = 1583,
    MS_Smith = 1584,
    MS_Stone = 1585,
    MS_Sunflower = 1586,
    MS_Tallahatchie = 1587,
    MS_Tate = 1588,
    MS_Tippah = 1589,
    MS_Tishomingo = 1590,
    MS_Tunica = 1591,
    MS_Union = 1592,
    MS_Walthall = 1593,
    MS_Warren = 1594,
    MS_Washington = 1595,
    MS_Wayne = 1596,
    MS_Webster = 1597,
    MS_Wilkinson = 1598,
    MS_Winston = 1599,
    MS_Yalobusha = 1600,
    MS_Yazoo = 1601,
    MT_Beaverhead = 1602,
    MT_BigHorn = 1603,
    MT_Blaine = 1604,
    MT_Broadwater = 1605,
    MT_Carbon = 1606,
    MT_Carter = 1607,
    MT_Cascade = 1608,
    MT_Chouteau = 1609,
    MT_Custer = 1610,
    MT_Daniels = 1611,
    MT_Dawson = 1612,
    MT_DeerLodge = 1613,
    MT_Fallon = 1614,
    MT_Fergus = 1615,
    MT_Flathead = 1616,
    MT_Gallatin = 1617,
    MT_Garfield = 1618,
    MT_Glacier = 1619,
    MT_GoldenValley = 1620,
    MT_Granite = 1621,
    MT_Hill = 1622,
    MT_Jefferson = 1623,
    MT_JudithBasin = 1624,
    MT_Lake = 1625,
    MT_LewisAndClark = 1626,
    MT_Liberty = 1627,
    MT_Lincoln = 1628,
    MT_Madison = 1629,
    MT_Mccone = 1630,
    MT_Meagher = 1631,
    MT_Mineral = 1632,
    MT_Missoula = 1633,
    MT_Musselshell = 1634,
    MT_Park = 1635,
    MT_Petroleum = 1636,
    MT_Phillips = 1637,
    MT_Pondera = 1638,
    MT_PowderRiver = 1639,
    MT_Powell = 1640,
    MT_Prairie = 1641,
    MT_Ravalli = 1642,
    MT_Richland = 1643,
    MT_Roosevelt = 1644,
    MT_Rosebud = 1645,
    MT_Sanders = 1646,
    MT_Sheridan = 1647,
    MT_SilverBow = 1648,
    MT_Stillwater = 1649,
    MT_SweetGrass = 1650,
    MT_Teton = 1651,
    MT_Toole = 1652,
    MT_Treasure = 1653,
    MT_Valley = 1654,
    MT_Wheatland = 1655,
    MT_Wibaux = 1656,
    MT_Yellowstone = 1657,
    NC_Alamance = 1658,
    NC_Alexander = 1659,
    NC_Alleghany = 1660,
    NC_Anson = 1661,
    NC_Ashe = 1662,
    NC_Avery = 1663,
    NC_Beaufort = 1664,
    NC_Bertie = 1665,
    NC_Bladen = 1666,
    NC_Brunswick = 1667,
    NC_Buncombe = 1668,
    NC_Burke = 1669,
    NC_Cabarrus = 1670,
    NC_Caldwell = 1671,
    NC_Camden = 1672,
    NC_Carteret = 1673,
    NC_Caswell = 1674,
    NC_Catawba = 1675,
    NC_Chatham = 1676,
    NC_Cherokee = 1677,
    NC_Chowan = 1678,
    NC_Clay = 1679,
    NC_Cleveland = 1680,
    NC_Columbus = 1681,
    NC_Craven = 1682,
    NC_Cumberland = 1683,
    NC_Currituck = 1684,
    NC_Dare = 1685,
    NC_Davidson = 1686,
    NC_Davie = 1687,
    NC_Duplin = 1688,
    NC_Durham = 1689,
    NC_Edgecombe = 1690,
    NC_Forsyth = 1691,
    NC_Franklin = 1692,
    NC_Gaston = 1693,
    NC_Gates = 1694,
    NC_Graham = 1695,
    NC_Granville = 1696,
    NC_Greene = 1697,
    NC_Guilford = 1698,
    NC_Halifax = 1699,
    NC_Harnett = 1700,
    NC_Haywood = 1701,
    NC_Henderson = 1702,
    NC_Hertford = 1703,
    NC_Hoke = 1704,
    NC_Hyde = 1705,
    NC_Iredell = 1706,
    NC_Jackson = 1707,
    NC_Johnston = 1708,
    NC_Jones = 1709,
    NC_Lee = 1710,
    NC_Lenoir = 1711,
    NC_Lincoln = 1712,
    NC_Macon = 1713,
    NC_Madison = 1714,
    NC_Martin = 1715,
    NC_Mcdowell = 1716,
    NC_Mecklenburg = 1717,
    NC_Mitchell = 1718,
    NC_Montgomery = 1719,
    NC_Moore = 1720,
    NC_Nash = 1721,
    NC_NewHanover = 1722,
    NC_Northampton = 1723,
    NC_Onslow = 1724,
    NC_Orange = 1725,
    NC_Pamlico = 1726,
    NC_Pasquotank = 1727,
    NC_Pender = 1728,
    NC_Perquimans = 1729,
    NC_Person = 1730,
    NC_Pitt = 1731,
    NC_Polk = 1732,
    NC_Randolph = 1733,
    NC_Richmond = 1734,
    NC_Robeson = 1735,
    NC_Rockingham = 1736,
    NC_Rowan = 1737,
    NC_Rutherford = 1738,
    NC_Sampson = 1739,
    NC_Scotland = 1740,
    NC_Stanly = 1741,
    NC_Stokes = 1742,
    NC_Surry = 1743,
    NC_Swain = 1744,
    NC_Transylvania = 1745,
    NC_Tyrrell = 1746,
    NC_Union = 1747,
    NC_Vance = 1748,
    NC_Wake = 1749,
    NC_Warren = 1750,
    NC_Washington = 1751,
    NC_Watauga = 1752,
    NC_Wayne = 1753,
    NC_Wilkes = 1754,
    NC_Wilson = 1755,
    NC_Yadkin = 1756,
    NC_Yancey = 1757,
    ND_Adams = 1758,
    ND_Barnes = 1759,
    ND_Benson = 1760,
    ND_Billings = 1761,
    ND_Bottineau = 1762,
    ND_Bowman = 1763,
    ND_Burke = 1764,
    ND_Burleigh = 1765,
    ND_Cass = 1766,
    ND_Cavalier = 1767,
    ND_Dickey = 1768,
    ND_Divide = 1769,
    ND_Dunn = 1770,
    ND_Eddy = 1771,
    ND_Emmons = 1772,
    ND_Foster = 1773,
    ND_GoldenValley = 1774,
    ND_GrandForks = 1775,
    ND_Grant = 1776,
    ND_Griggs = 1777,
    ND_Hettinger = 1778,
    ND_Kidder = 1779,
    ND_Lamoure = 1780,
    ND_Logan = 1781,
    ND_Mchenry = 1782,
    ND_Mcintosh = 1783,
    ND_Mckenzie = 1784,
    ND_Mclean = 1785,
    ND_Mercer = 1786,
    ND_Morton = 1787,
    ND_Mountrail = 1788,
    ND_Nelson = 1789,
    ND_Oliver = 1790,
    ND_Pembina = 1791,
    ND_Pierce = 1792,
    ND_Ramsey = 1793,
    ND_Ransom = 1794,
    ND_Renville = 1795,
    ND_Richland = 1796,
    ND_Rolette = 1797,
    ND_Sargent = 1798,
    ND_Sheridan = 1799,
    ND_Sioux = 1800,
    ND_Slope = 1801,
    ND_Stark = 1802,
    ND_Steele = 1803,
    ND_Stutsman = 1804,
    ND_Towner = 1805,
    ND_Traill = 1806,
    ND_Walsh = 1807,
    ND_Ward = 1808,
    ND_Wells = 1809,
    ND_Williams = 1810,
    NE_Adams = 1811,
    NE_Antelope = 1812,
    NE_Arthur = 1813,
    NE_Banner = 1814,
    NE_Blaine = 1815,
    NE_Boone = 1816,
    NE_BoxButte = 1817,
    NE_Boyd = 1818,
    NE_Brown = 1819,
    NE_Buffalo = 1820,
    NE_Burt = 1821,
    NE_Butler = 1822,
    NE_Cass = 1823,
    NE_Cedar = 1824,
    NE_Chase = 1825,
    NE_Cherry = 1826,
    NE_Cheyenne = 1827,
    NE_Clay = 1828,
    NE_Colfax = 1829,
    NE_Cuming = 1830,
    NE_Custer = 1831,
    NE_Dakota = 1832,
    NE_Dawes = 1833,
    NE_Dawson = 1834,
    NE_Deuel = 1835,
    NE_Dixon = 1836,
    NE_Dodge = 1837,
    NE_Douglas = 1838,
    NE_Dundy = 1839,
    NE_Fillmore = 1840,
    NE_Franklin = 1841,
    NE_Frontier = 1842,
    NE_Furnas = 1843,
    NE_Gage = 1844,
    NE_Garden = 1845,
    NE_Garfield = 1846,
    NE_Gosper = 1847,
    NE_Grant = 1848,
    NE_Greeley = 1849,
    NE_Hall = 1850,
    NE_Hamilton = 1851,
    NE_Harlan = 1852,
    NE_Hayes = 1853,
    NE_Hitchcock = 1854,
    NE_Holt = 1855,
    NE_Hooker = 1856,
    NE_Howard = 1857,
    NE_Jefferson = 1858,
    NE_Johnson = 1859,
    NE_Kearney = 1860,
    NE_Keith = 1861,
    NE_KeyaPaha = 1862,
    NE_Kimball = 1863,
    NE_Knox = 1864,
    NE_Lancaster = 1865,
    NE_Lincoln = 1866,
    NE_Logan = 1867,
    NE_Loup = 1868,
    NE_Madison = 1869,
    NE_Mcpherson = 1870,
    NE_Merrick = 1871,
    NE_Morrill = 1872,
    NE_Nance = 1873,
    NE_Nemaha = 1874,
    NE_Nuckolls = 1875,
    NE_Otoe = 1876,
    NE_Pawnee = 1877,
    NE_Perkins = 1878,
    NE_Phelps = 1879,
    NE_Pierce = 1880,
    NE_Platte = 1881,
    NE_Polk = 1882,
    NE_RedWillow = 1883,
    NE_Richardson = 1884,
    NE_Rock = 1885,
    NE_Saline = 1886,
    NE_Sarpy = 1887,
    NE_Saunders = 1888,
    NE_ScottsBluff = 1889,
    NE_Seward = 1890,
    NE_Sheridan = 1891,
    NE_Sherman = 1892,
    NE_Sioux = 1893,
    NE_Stanton = 1894,
    NE_Thayer = 1895,
    NE_Thomas = 1896,
    NE_Thurston = 1897,
    NE_Valley = 1898,
    NE_Washington = 1899,
    NE_Wayne = 1900,
    NE_Webster = 1901,
    NE_Wheeler = 1902,
    NE_York = 1903,
    NH_Belknap = 1904,
    NH_Carroll = 1905,
    NH_Cheshire = 1906,
    NH_Coos = 1907,
    NH_Grafton = 1908,
    NH_Hillsborough = 1909,
    NH_Merrimack = 1910,
    NH_Rockingham = 1911,
    NH_Strafford = 1912,
    NH_Sullivan = 1913,
    NJ_Atlantic = 1914,
    NJ_Bergen = 1915,
    NJ_Burlington = 1916,
    NJ_Camden = 1917,
    NJ_CapeMay = 1918,
    NJ_Cumberland = 1919,
    NJ_Essex = 1920,
    NJ_Gloucester = 1921,
    NJ_Hudson = 1922,
    NJ_Hunterdon = 1923,
    NJ_Mercer = 1924,
    NJ_Middlesex = 1925,
    NJ_Monmouth = 1926,
    NJ_Morris = 1927,
    NJ_Ocean = 1928,
    NJ_Passaic = 1929,
    NJ_Salem = 1930,
    NJ_Somerset = 1931,
    NJ_Sussex = 1932,
    NJ_Union = 1933,
    NJ_Warren = 1934,
    NM_Bernalillo = 1935,
    NM_Catron = 1936,
    NM_Chaves = 1937,
    NM_Cibola = 1938,
    NM_Colfax = 1939,
    NM_Curry = 1940,
    NM_DeBaca = 1941,
    NM_DonaAna = 1942,
    NM_Eddy = 1943,
    NM_Grant = 1944,
    NM_Guadalupe = 1945,
    NM_Harding = 1946,
    NM_Hidalgo = 1947,
    NM_Lea = 1948,
    NM_Lincoln = 1949,
    NM_LosAlamos = 1950,
    NM_Luna = 1951,
    NM_Mckinley = 1952,
    NM_Mora = 1953,
    NM_Otero = 1954,
    NM_Quay = 1955,
    NM_RioArriba = 1956,
    NM_Roosevelt = 1957,
    NM_SanJuan = 1958,
    NM_SanMiguel = 1959,
    NM_Sandoval = 1960,
    NM_SantaFe = 1961,
    NM_Sierra = 1962,
    NM_Socorro = 1963,
    NM_Taos = 1964,
    NM_Torrance = 1965,
    NM_Union = 1966,
    NM_Valencia = 1967,
    NV_CarsonCity = 1968,
    NV_Churchill = 1969,
    NV_Clark = 1970,
    NV_Douglas = 1971,
    NV_Elko = 1972,
    NV_Esmeralda = 1973,
    NV_Eureka = 1974,
    NV_Humboldt = 1975,
    NV_Lander = 1976,
    NV_Lincoln = 1977,
    NV_Lyon = 1978,
    NV_Mineral = 1979,
    NV_Nye = 1980,
    NV_Pershing = 1981,
    NV_Storey = 1982,
    NV_Washoe = 1983,
    NV_WhitePine = 1984,
    NY_Albany = 1985,
    NY_Allegany = 1986,
    NY_Bronx = 1987,
    NY_Broome = 1988,
    NY_Cattaraugus = 1989,
    NY_Cayuga = 1990,
    NY_Chautauqua = 1991,
    NY_Chemung = 1992,
    NY_Chenango = 1993,
    NY_Clinton = 1994,
    NY_Columbia = 1995,
    NY_Cortland = 1996,
    NY_Delaware = 1997,
    NY_Dutchess = 1998,
    NY_Erie = 1999,
    NY_Essex = 2000,
    NY_Franklin = 2001,
    NY_Fulton = 2002,
    NY_Genesee = 2003,
    NY_Greene = 2004,
    NY_Hamilton = 2005,
    NY_Herkimer = 2006,
    NY_Jefferson = 2007,
    NY_Kings = 2008,
    NY_Lewis = 2009,
    NY_Livingston = 2010,
    NY_Madison = 2011,
    NY_Monroe = 2012,
    NY_Montgomery = 2013,
    NY_Nassau = 2014,
    NY_NewYork = 2015,
    NY_Niagara = 2016,
    NY_Oneida = 2017,
    NY_Onondaga = 2018,
    NY_Ontario = 2019,
    NY_Orange = 2020,
    NY_Orleans = 2021,
    NY_Oswego = 2022,
    NY_Otsego = 2023,
    NY_Putnam = 2024,
    NY_Queens = 2025,
    NY_Rensselaer = 2026,
    NY_Richmond = 2027,
    NY_Rockland = 2028,
    NY_SaintLawrence = 2029,
    NY_Saratoga = 2030,
    NY_Schenectady = 2031,
    NY_Schoharie = 2032,
    NY_Schuyler = 2033,
    NY_Seneca = 2034,
    NY_Steuben = 2035,
    NY_Suffolk = 2036,
    NY_Sullivan = 2037,
    NY_Tioga = 2038,
    NY_Tompkins = 2039,
    NY_Ulster = 2040,
    NY_Warren = 2041,
    NY_Washington = 2042,
    NY_Wayne = 2043,
    NY_Westchester = 2044,
    NY_Wyoming = 2045,
    NY_Yates = 2046,
    OH_Adams = 2047,
    OH_Allen = 2048,
    OH_Ashland = 2049,
    OH_Ashtabula = 2050,
    OH_Athens = 2051,
    OH_Auglaize = 2052,
    OH_Belmont = 2053,
    OH_Brown = 2054,
    OH_Butler = 2055,
    OH_Carroll = 2056,
    OH_Champaign = 2057,
    OH_Clark = 2058,
    OH_Clermont = 2059,
    OH_Clinton = 2060,
    OH_Columbiana = 2061,
    OH_Coshocton = 2062,
    OH_Crawford = 2063,
    OH_Cuyahoga = 2064,
    OH_Darke = 2065,
    OH_Defiance = 2066,
    OH_Delaware = 2067,
    OH_Erie = 2068,
    OH_Fairfield = 2069,
    OH_Fayette = 2070,
    OH_Franklin = 2071,
    OH_Fulton = 2072,
    OH_Gallia = 2073,
    OH_Geauga = 2074,
    OH_Greene = 2075,
    OH_Guernsey = 2076,
    OH_Hamilton = 2077,
    OH_Hancock = 2078,
    OH_Hardin = 2079,
    OH_Harrison = 2080,
    OH_Henry = 2081,
    OH_Highland = 2082,
    OH_Hocking = 2083,
    OH_Holmes = 2084,
    OH_Huron = 2085,
    OH_Jackson = 2086,
    OH_Jefferson = 2087,
    OH_Knox = 2088,
    OH_Lake = 2089,
    OH_Lawrence = 2090,
    OH_Licking = 2091,
    OH_Logan = 2092,
    OH_Lorain = 2093,
    OH_Lucas = 2094,
    OH_Madison = 2095,
    OH_Mahoning = 2096,
    OH_Marion = 2097,
    OH_Medina = 2098,
    OH_Meigs = 2099,
    OH_Mercer = 2100,
    OH_Miami = 2101,
    OH_Monroe = 2102,
    OH_Montgomery = 2103,
    OH_Morgan = 2104,
    OH_Morrow = 2105,
    OH_Muskingum = 2106,
    OH_Noble = 2107,
    OH_Ottawa = 2108,
    OH_Paulding = 2109,
    OH_Perry = 2110,
    OH_Pickaway = 2111,
    OH_Pike = 2112,
    OH_Portage = 2113,
    OH_Preble = 2114,
    OH_Putnam = 2115,
    OH_Richland = 2116,
    OH_Ross = 2117,
    OH_Sandusky = 2118,
    OH_Scioto = 2119,
    OH_Seneca = 2120,
    OH_Shelby = 2121,
    OH_Stark = 2122,
    OH_Summit = 2123,
    OH_Trumbull = 2124,
    OH_Tuscarawas = 2125,
    OH_Union = 2126,
    OH_VanWert = 2127,
    OH_Vinton = 2128,
    OH_Warren = 2129,
    OH_Washington = 2130,
    OH_Wayne = 2131,
    OH_Williams = 2132,
    OH_Wood = 2133,
    OH_Wyandot = 2134,
    OK_Adair = 2135,
    OK_Alfalfa = 2136,
    OK_Atoka = 2137,
    OK_Beaver = 2138,
    OK_Beckham = 2139,
    OK_Blaine = 2140,
    OK_Bryan = 2141,
    OK_Caddo = 2142,
    OK_Canadian = 2143,
    OK_Carter = 2144,
    OK_Cherokee = 2145,
    OK_Choctaw = 2146,
    OK_Cimarron = 2147,
    OK_Cleveland = 2148,
    OK_Coal = 2149,
    OK_Comanche = 2150,
    OK_Cotton = 2151,
    OK_Craig = 2152,
    OK_Creek = 2153,
    OK_Custer = 2154,
    OK_Delaware = 2155,
    OK_Dewey = 2156,
    OK_Ellis = 2157,
    OK_Garfield = 2158,
    OK_Garvin = 2159,
    OK_Grady = 2160,
    OK_Grant = 2161,
    OK_Greer = 2162,
    OK_Harmon = 2163,
    OK_Harper = 2164,
    OK_Haskell = 2165,
    OK_Hughes = 2166,
    OK_Jackson = 2167,
    OK_Jefferson = 2168,
    OK_Johnston = 2169,
    OK_Kay = 2170,
    OK_Kingfisher = 2171,
    OK_Kiowa = 2172,
    OK_Latimer = 2173,
    OK_LeFlore = 2174,
    OK_Lincoln = 2175,
    OK_Logan = 2176,
    OK_Love = 2177,
    OK_Major = 2178,
    OK_Marshall = 2179,
    OK_Mayes = 2180,
    OK_Mcclain = 2181,
    OK_Mccurtain = 2182,
    OK_Mcintosh = 2183,
    OK_Murray = 2184,
    OK_Muskogee = 2185,
    OK_Noble = 2186,
    OK_Nowata = 2187,
    OK_Okfuskee = 2188,
    OK_Oklahoma = 2189,
    OK_Okmulgee = 2190,
    OK_Osage = 2191,
    OK_Ottawa = 2192,
    OK_Pawnee = 2193,
    OK_Payne = 2194,
    OK_Pittsburg = 2195,
    OK_Pontotoc = 2196,
    OK_Pottawatomie = 2197,
    OK_Pushmataha = 2198,
    OK_RogerMills = 2199,
    OK_Rogers = 2200,
    OK_Seminole = 2201,
    OK_Sequoyah = 2202,
    OK_Stephens = 2203,
    OK_Texas = 2204,
    OK_Tillman = 2205,
    OK_Tulsa = 2206,
    OK_Wagoner = 2207,
    OK_Washington = 2208,
    OK_Washita = 2209,
    OK_Woods = 2210,
    OK_Woodward = 2211,
    OR_Baker = 2212,
    OR_Benton = 2213,
    OR_Clackamas = 2214,
    OR_Clatsop = 2215,
    OR_Columbia = 2216,
    OR_Coos = 2217,
    OR_Crook = 2218,
    OR_Curry = 2219,
    OR_Deschutes = 2220,
    OR_Douglas = 2221,
    OR_Gilliam = 2222,
    OR_Grant = 2223,
    OR_Harney = 2224,
    OR_HoodRiver = 2225,
    OR_Jackson = 2226,
    OR_Jefferson = 2227,
    OR_Josephine = 2228,
    OR_Klamath = 2229,
    OR_Lake = 2230,
    OR_Lane = 2231,
    OR_Lincoln = 2232,
    OR_Linn = 2233,
    OR_Malheur = 2234,
    OR_Marion = 2235,
    OR_Morrow = 2236,
    OR_Multnomah = 2237,
    OR_Polk = 2238,
    OR_Sherman = 2239,
    OR_Tillamook = 2240,
    OR_Umatilla = 2241,
    OR_Union = 2242,
    OR_Wallowa = 2243,
    OR_Wasco = 2244,
    OR_Washington = 2245,
    OR_Wheeler = 2246,
    OR_Yamhill = 2247,
    PA_Adams = 2248,
    PA_Allegheny = 2249,
    PA_Armstrong = 2250,
    PA_Beaver = 2251,
    PA_Bedford = 2252,
    PA_Berks = 2253,
    PA_Blair = 2254,
    PA_Bradford = 2255,
    PA_Bucks = 2256,
    PA_Butler = 2257,
    PA_Cambria = 2258,
    PA_Cameron = 2259,
    PA_Carbon = 2260,
    PA_Centre = 2261,
    PA_Chester = 2262,
    PA_Clarion = 2263,
    PA_Clearfield = 2264,
    PA_Clinton = 2265,
    PA_Columbia = 2266,
    PA_Crawford = 2267,
    PA_Cumberland = 2268,
    PA_Dauphin = 2269,
    PA_Delaware = 2270,
    PA_Elk = 2271,
    PA_Erie = 2272,
    PA_Fayette = 2273,
    PA_Forest = 2274,
    PA_Franklin = 2275,
    PA_Fulton = 2276,
    PA_Greene = 2277,
    PA_Huntingdon = 2278,
    PA_Indiana = 2279,
    PA_Jefferson = 2280,
    PA_Juniata = 2281,
    PA_Lackawanna = 2282,
    PA_Lancaster = 2283,
    PA_Lawrence = 2284,
    PA_Lebanon = 2285,
    PA_Lehigh = 2286,
    PA_Luzerne = 2287,
    PA_Lycoming = 2288,
    PA_Mckean = 2289,
    PA_Mercer = 2290,
    PA_Mifflin = 2291,
    PA_Monroe = 2292,
    PA_Montgomery = 2293,
    PA_Montour = 2294,
    PA_Northampton = 2295,
    PA_Northumberland = 2296,
    PA_Perry = 2297,
    PA_Philadelphia = 2298,
    PA_Pike = 2299,
    PA_Potter = 2300,
    PA_Schuylkill = 2301,
    PA_Snyder = 2302,
    PA_Somerset = 2303,
    PA_Sullivan = 2304,
    PA_Susquehanna = 2305,
    PA_Tioga = 2306,
    PA_Union = 2307,
    PA_Venango = 2308,
    PA_Warren = 2309,
    PA_Washington = 2310,
    PA_Wayne = 2311,
    PA_Westmoreland = 2312,
    PA_Wyoming = 2313,
    PA_York = 2314,
    PR_Adjuntas = 2315,
    PR_Aguada = 2316,
    PR_Aguadilla = 2317,
    PR_AguasBuenas = 2318,
    PR_Aibonito = 2319,
    PR_Anasco = 2320,
    PR_Arecibo = 2321,
    PR_Arroyo = 2322,
    PR_Barceloneta = 2323,
    PR_Barranquitas = 2324,
    PR_Bayamon = 2325,
    PR_CaboRojo = 2326,
    PR_Caguas = 2327,
    PR_Camuy = 2328,
    PR_Canovanas = 2329,
    PR_Carolina = 2330,
    PR_Catano = 2331,
    PR_Cayey = 2332,
    PR_Ceiba = 2333,
    PR_Ciales = 2334,
    PR_Cidra = 2335,
    PR_Coamo = 2336,
    PR_Comerio = 2337,
    PR_Corozal = 2338,
    PR_Culebra = 2339,
    PR_Dorado = 2340,
    PR_Fajardo = 2341,
    PR_Florida = 2342,
    PR_Guanica = 2343,
    PR_Guayama = 2344,
    PR_Guayanilla = 2345,
    PR_Guaynabo = 2346,
    PR_Gurabo = 2347,
    PR_Hatillo = 2348,
    PR_Hormigueros = 2349,
    PR_Humacao = 2350,
    PR_Isabela = 2351,
    PR_Jayuya = 2352,
    PR_JuanaDiaz = 2353,
    PR_Juncos = 2354,
    PR_Lajas = 2355,
    PR_Lares = 2356,
    PR_LasMarias = 2357,
    PR_LasPiedras = 2358,
    PR_Loiza = 2359,
    PR_Luquillo = 2360,
    PR_Manati = 2361,
    PR_Maricao = 2362,
    PR_Maunabo = 2363,
    PR_Mayaguez = 2364,
    PR_Moca = 2365,
    PR_Morovis = 2366,
    PR_Naguabo = 2367,
    PR_Naranjito = 2368,
    PR_Orocovis = 2369,
    PR_Patillas = 2370,
    PR_Penuelas = 2371,
    PR_Ponce = 2372,
    PR_Quebradillas = 2373,
    PR_Rincon = 2374,
    PR_RioGrande = 2375,
    PR_SabanaGrande = 2376,
    PR_Salinas = 2377,
    PR_SanGerman = 2378,
    PR_SanJuan = 2379,
    PR_SanLorenzo = 2380,
    PR_SanSebastian = 2381,
    PR_SantaIsabel = 2382,
    PR_ToaAlta = 2383,
    PR_ToaBaja = 2384,
    PR_TrujilloAlto = 2385,
    PR_Utuado = 2386,
    PR_VegaAlta = 2387,
    PR_VegaBaja = 2388,
    PR_Vieques = 2389,
    PR_Villalba = 2390,
    PR_Yabucoa = 2391,
    PR_Yauco = 2392,
    PW_Palau = 2393,
    RI_Bristol = 2394,
    RI_Kent = 2395,
    RI_Newport = 2396,
    RI_Providence = 2397,
    RI_Washington = 2398,
    SC_Abbeville = 2399,
    SC_Aiken = 2400,
    SC_Allendale = 2401,
    SC_Anderson = 2402,
    SC_Bamberg = 2403,
    SC_Barnwell = 2404,
    SC_Beaufort = 2405,
    SC_Berkeley = 2406,
    SC_Calhoun = 2407,
    SC_Charleston = 2408,
    SC_Cherokee = 2409,
    SC_Chester = 2410,
    SC_Chesterfield = 2411,
    SC_Clarendon = 2412,
    SC_Colleton = 2413,
    SC_Darlington = 2414,
    SC_Dillon = 2415,
    SC_Dorchester = 2416,
    SC_Edgefield = 2417,
    SC_Fairfield = 2418,
    SC_Florence = 2419,
    SC_Georgetown = 2420,
    SC_Greenville = 2421,
    SC_Greenwood = 2422,
    SC_Hampton = 2423,
    SC_Horry = 2424,
    SC_Jasper = 2425,
    SC_Kershaw = 2426,
    SC_Lancaster = 2427,
    SC_Laurens = 2428,
    SC_Lee = 2429,
    SC_Lexington = 2430,
    SC_Marion = 2431,
    SC_Marlboro = 2432,
    SC_Mccormick = 2433,
    SC_Newberry = 2434,
    SC_Oconee = 2435,
    SC_Orangeburg = 2436,
    SC_Pickens = 2437,
    SC_Richland = 2438,
    SC_Saluda = 2439,
    SC_Spartanburg = 2440,
    SC_Sumter = 2441,
    SC_Union = 2442,
    SC_Williamsburg = 2443,
    SC_York = 2444,
    SD_Aurora = 2445,
    SD_Beadle = 2446,
    SD_Bennett = 2447,
    SD_BonHomme = 2448,
    SD_Brookings = 2449,
    SD_Brown = 2450,
    SD_Brule = 2451,
    SD_Buffalo = 2452,
    SD_Butte = 2453,
    SD_Campbell = 2454,
    SD_CharlesMix = 2455,
    SD_Clark = 2456,
    SD_Clay = 2457,
    SD_Codington = 2458,
    SD_Corson = 2459,
    SD_Custer = 2460,
    SD_Davison = 2461,
    SD_Day = 2462,
    SD_Deuel = 2463,
    SD_Dewey = 2464,
    SD_Douglas = 2465,
    SD_Edmunds = 2466,
    SD_FallRiver = 2467,
    SD_Faulk = 2468,
    SD_Grant = 2469,
    SD_Gregory = 2470,
    SD_Haakon = 2471,
    SD_Hamlin = 2472,
    SD_Hand = 2473,
    SD_Hanson = 2474,
    SD_Harding = 2475,
    SD_Hughes = 2476,
    SD_Hutchinson = 2477,
    SD_Hyde = 2478,
    SD_Jackson = 2479,
    SD_Jerauld = 2480,
    SD_Jones = 2481,
    SD_Kingsbury = 2482,
    SD_Lake = 2483,
    SD_Lawrence = 2484,
    SD_Lincoln = 2485,
    SD_Lyman = 2486,
    SD_Marshall = 2487,
    SD_Mccook = 2488,
    SD_Mcpherson = 2489,
    SD_Meade = 2490,
    SD_Mellette = 2491,
    SD_Miner = 2492,
    SD_Minnehaha = 2493,
    SD_Moody = 2494,
    SD_Pennington = 2495,
    SD_Perkins = 2496,
    SD_Potter = 2497,
    SD_Roberts = 2498,
    SD_Sanborn = 2499,
    SD_Shannon = 2500,
    SD_Spink = 2501,
    SD_Stanley = 2502,
    SD_Sully = 2503,
    SD_Todd = 2504,
    SD_Tripp = 2505,
    SD_Turner = 2506,
    SD_Union = 2507,
    SD_Walworth = 2508,
    SD_Yankton = 2509,
    SD_Ziebach = 2510,
    TN_Anderson = 2511,
    TN_Bedford = 2512,
    TN_Benton = 2513,
    TN_Bledsoe = 2514,
    TN_Blount = 2515,
    TN_Bradley = 2516,
    TN_Campbell = 2517,
    TN_Cannon = 2518,
    TN_Carroll = 2519,
    TN_Carter = 2520,
    TN_Cheatham = 2521,
    TN_Chester = 2522,
    TN_Claiborne = 2523,
    TN_Clay = 2524,
    TN_Cocke = 2525,
    TN_Coffee = 2526,
    TN_Crockett = 2527,
    TN_Cumberland = 2528,
    TN_Davidson = 2529,
    TN_Decatur = 2530,
    TN_Dekalb = 2531,
    TN_Dickson = 2532,
    TN_Dyer = 2533,
    TN_Fayette = 2534,
    TN_Fentress = 2535,
    TN_Franklin = 2536,
    TN_Gibson = 2537,
    TN_Giles = 2538,
    TN_Grainger = 2539,
    TN_Greene = 2540,
    TN_Grundy = 2541,
    TN_Hamblen = 2542,
    TN_Hamilton = 2543,
    TN_Hancock = 2544,
    TN_Hardeman = 2545,
    TN_Hardin = 2546,
    TN_Hawkins = 2547,
    TN_Haywood = 2548,
    TN_Henderson = 2549,
    TN_Henry = 2550,
    TN_Hickman = 2551,
    TN_Houston = 2552,
    TN_Humphreys = 2553,
    TN_Jackson = 2554,
    TN_Jefferson = 2555,
    TN_Johnson = 2556,
    TN_Knox = 2557,
    TN_Lake = 2558,
    TN_Lauderdale = 2559,
    TN_Lawrence = 2560,
    TN_Lewis = 2561,
    TN_Lincoln = 2562,
    TN_Loudon = 2563,
    TN_Macon = 2564,
    TN_Madison = 2565,
    TN_Marion = 2566,
    TN_Marshall = 2567,
    TN_Maury = 2568,
    TN_Mcminn = 2569,
    TN_Mcnairy = 2570,
    TN_Meigs = 2571,
    TN_Monroe = 2572,
    TN_Montgomery = 2573,
    TN_Moore = 2574,
    TN_Morgan = 2575,
    TN_Obion = 2576,
    TN_Overton = 2577,
    TN_Perry = 2578,
    TN_Pickett = 2579,
    TN_Polk = 2580,
    TN_Putnam = 2581,
    TN_Rhea = 2582,
    TN_Roane = 2583,
    TN_Robertson = 2584,
    TN_Rutherford = 2585,
    TN_Scott = 2586,
    TN_Sequatchie = 2587,
    TN_Sevier = 2588,
    TN_Shelby = 2589,
    TN_Smith = 2590,
    TN_Stewart = 2591,
    TN_Sullivan = 2592,
    TN_Sumner = 2593,
    TN_Tipton = 2594,
    TN_Trousdale = 2595,
    TN_Unicoi = 2596,
    TN_Union = 2597,
    TN_VanBuren = 2598,
    TN_Warren = 2599,
    TN_Washington = 2600,
    TN_Wayne = 2601,
    TN_Weakley = 2602,
    TN_White = 2603,
    TN_Williamson = 2604,
    TN_Wilson = 2605,
    TX_Anderson = 2606,
    TX_Andrews = 2607,
    TX_Angelina = 2608,
    TX_Aransas = 2609,
    TX_Archer = 2610,
    TX_Armstrong = 2611,
    TX_Atascosa = 2612,
    TX_Austin = 2613,
    TX_Bailey = 2614,
    TX_Bandera = 2615,
    TX_Bastrop = 2616,
    TX_Baylor = 2617,
    TX_Bee = 2618,
    TX_Bell = 2619,
    TX_Bexar = 2620,
    TX_Blanco = 2621,
    TX_Borden = 2622,
    TX_Bosque = 2623,
    TX_Bowie = 2624,
    TX_Brazoria = 2625,
    TX_Brazos = 2626,
    TX_Brewster = 2627,
    TX_Briscoe = 2628,
    TX_Brooks = 2629,
    TX_Brown = 2630,
    TX_Burleson = 2631,
    TX_Burnet = 2632,
    TX_Caldwell = 2633,
    TX_Calhoun = 2634,
    TX_Callahan = 2635,
    TX_Cameron = 2636,
    TX_Camp = 2637,
    TX_Carson = 2638,
    TX_Cass = 2639,
    TX_Castro = 2640,
    TX_Chambers = 2641,
    TX_Cherokee = 2642,
    TX_Childress = 2643,
    TX_Clay = 2644,
    TX_Cochran = 2645,
    TX_Coke = 2646,
    TX_Coleman = 2647,
    TX_Collin = 2648,
    TX_Collingsworth = 2649,
    TX_Colorado = 2650,
    TX_Comal = 2651,
    TX_Comanche = 2652,
    TX_Concho = 2653,
    TX_Cooke = 2654,
    TX_Coryell = 2655,
    TX_Cottle = 2656,
    TX_Crane = 2657,
    TX_Crockett = 2658,
    TX_Crosby = 2659,
    TX_Culberson = 2660,
    TX_Dallam = 2661,
    TX_Dallas = 2662,
    TX_Dawson = 2663,
    TX_DeWitt = 2664,
    TX_DeafSmith = 2665,
    TX_Delta = 2666,
    TX_Denton = 2667,
    TX_Dickens = 2668,
    TX_Dimmit = 2669,
    TX_Donley = 2670,
    TX_Duval = 2671,
    TX_Eastland = 2672,
    TX_Ector = 2673,
    TX_Edwards = 2674,
    TX_ElPaso = 2675,
    TX_Ellis = 2676,
    TX_Erath = 2677,
    TX_Falls = 2678,
    TX_Fannin = 2679,
    TX_Fayette = 2680,
    TX_Fisher = 2681,
    TX_Floyd = 2682,
    TX_Foard = 2683,
    TX_FortBend = 2684,
    TX_Franklin = 2685,
    TX_Freestone = 2686,
    TX_Frio = 2687,
    TX_Gaines = 2688,
    TX_Galveston = 2689,
    TX_Garza = 2690,
    TX_Gillespie = 2691,
    TX_Glasscock = 2692,
    TX_Goliad = 2693,
    TX_Gonzales = 2694,
    TX_Gray = 2695,
    TX_Grayson = 2696,
    TX_Gregg = 2697,
    TX_Grimes = 2698,
    TX_Guadalupe = 2699,
    TX_Hale = 2700,
    TX_Hall = 2701,
    TX_Hamilton = 2702,
    TX_Hansford = 2703,
    TX_Hardeman = 2704,
    TX_Hardin = 2705,
    TX_Harris = 2706,
    TX_Harrison = 2707,
    TX_Hartley = 2708,
    TX_Haskell = 2709,
    TX_Hays = 2710,
    TX_Hemphill = 2711,
    TX_Henderson = 2712,
    TX_Hidalgo = 2713,
    TX_Hill = 2714,
    TX_Hockley = 2715,
    TX_Hood = 2716,
    TX_Hopkins = 2717,
    TX_Houston = 2718,
    TX_Howard = 2719,
    TX_Hudspeth = 2720,
    TX_Hunt = 2721,
    TX_Hutchinson = 2722,
    TX_Irion = 2723,
    TX_Jack = 2724,
    TX_Jackson = 2725,
    TX_Jasper = 2726,
    TX_JeffDavis = 2727,
    TX_Jefferson = 2728,
    TX_JimHogg = 2729,
    TX_JimWells = 2730,
    TX_Johnson = 2731,
    TX_Jones = 2732,
    TX_Karnes = 2733,
    TX_Kaufman = 2734,
    TX_Kendall = 2735,
    TX_Kenedy = 2736,
    TX_Kent = 2737,
    TX_Kerr = 2738,
    TX_Kimble = 2739,
    TX_King = 2740,
    TX_Kinney = 2741,
    TX_Kleberg = 2742,
    TX_Knox = 2743,
    TX_LaSalle = 2744,
    TX_Lamar = 2745,
    TX_Lamb = 2746,
    TX_Lampasas = 2747,
    TX_Lavaca = 2748,
    TX_Lee = 2749,
    TX_Leon = 2750,
    TX_Liberty = 2751,
    TX_Limestone = 2752,
    TX_Lipscomb = 2753,
    TX_LiveOak = 2754,
    TX_Llano = 2755,
    TX_Loving = 2756,
    TX_Lubbock = 2757,
    TX_Lynn = 2758,
    TX_Madison = 2759,
    TX_Marion = 2760,
    TX_Martin = 2761,
    TX_Mason = 2762,
    TX_Matagorda = 2763,
    TX_Maverick = 2764,
    TX_Mcculloch = 2765,
    TX_Mclennan = 2766,
    TX_Mcmullen = 2767,
    TX_Medina = 2768,
    TX_Menard = 2769,
    TX_Midland = 2770,
    TX_Milam = 2771,
    TX_Mills = 2772,
    TX_Mitchell = 2773,
    TX_Montague = 2774,
    TX_Montgomery = 2775,
    TX_Moore = 2776,
    TX_Morris = 2777,
    TX_Motley = 2778,
    TX_Nacogdoches = 2779,
    TX_Navarro = 2780,
    TX_Newton = 2781,
    TX_Nolan = 2782,
    TX_Nueces = 2783,
    TX_Ochiltree = 2784,
    TX_Oldham = 2785,
    TX_Orange = 2786,
    TX_PaloPinto = 2787,
    TX_Panola = 2788,
    TX_Parker = 2789,
    TX_Parmer = 2790,
    TX_Pecos = 2791,
    TX_Polk = 2792,
    TX_Potter = 2793,
    TX_Presidio = 2794,
    TX_Rains = 2795,
    TX_Randall = 2796,
    TX_Reagan = 2797,
    TX_Real = 2798,
    TX_RedRiver = 2799,
    TX_Reeves = 2800,
    TX_Refugio = 2801,
    TX_Roberts = 2802,
    TX_Robertson = 2803,
    TX_Rockwall = 2804,
    TX_Runnels = 2805,
    TX_Rusk = 2806,
    TX_Sabine = 2807,
    TX_SanAugustine = 2808,
    TX_SanJacinto = 2809,
    TX_SanPatricio = 2810,
    TX_SanSaba = 2811,
    TX_Schleicher = 2812,
    TX_Scurry = 2813,
    TX_Shackelford = 2814,
    TX_Shelby = 2815,
    TX_Sherman = 2816,
    TX_Smith = 2817,
    TX_Somervell = 2818,
    TX_Starr = 2819,
    TX_Stephens = 2820,
    TX_Sterling = 2821,
    TX_Stonewall = 2822,
    TX_Sutton = 2823,
    TX_Swisher = 2824,
    TX_Tarrant = 2825,
    TX_Taylor = 2826,
    TX_Terrell = 2827,
    TX_Terry = 2828,
    TX_Throckmorton = 2829,
    TX_Titus = 2830,
    TX_TomGreen = 2831,
    TX_Travis = 2832,
    TX_Trinity = 2833,
    TX_Tyler = 2834,
    TX_Upshur = 2835,
    TX_Upton = 2836,
    TX_Uvalde = 2837,
    TX_ValVerde = 2838,
    TX_VanZandt = 2839,
    TX_Victoria = 2840,
    TX_Walker = 2841,
    TX_Waller = 2842,
    TX_Ward = 2843,
    TX_Washington = 2844,
    TX_Webb = 2845,
    TX_Wharton = 2846,
    TX_Wheeler = 2847,
    TX_Wichita = 2848,
    TX_Wilbarger = 2849,
    TX_Willacy = 2850,
    TX_Williamson = 2851,
    TX_Wilson = 2852,
    TX_Winkler = 2853,
    TX_Wise = 2854,
    TX_Wood = 2855,
    TX_Yoakum = 2856,
    TX_Young = 2857,
    TX_Zapata = 2858,
    TX_Zavala = 2859,
    UT_Beaver = 2860,
    UT_BoxElder = 2861,
    UT_Cache = 2862,
    UT_Carbon = 2863,
    UT_Daggett = 2864,
    UT_Davis = 2865,
    UT_Duchesne = 2866,
    UT_Emery = 2867,
    UT_Garfield = 2868,
    UT_Grand = 2869,
    UT_Iron = 2870,
    UT_Juab = 2871,
    UT_Kane = 2872,
    UT_Millard = 2873,
    UT_Morgan = 2874,
    UT_Piute = 2875,
    UT_Rich = 2876,
    UT_SaltLake = 2877,
    UT_SanJuan = 2878,
    UT_Sanpete = 2879,
    UT_Sevier = 2880,
    UT_Summit = 2881,
    UT_Tooele = 2882,
    UT_Uintah = 2883,
    UT_Utah = 2884,
    UT_Wasatch = 2885,
    UT_Washington = 2886,
    UT_Wayne = 2887,
    UT_Weber = 2888,
    VA_Accomack = 2889,
    VA_Albemarle = 2890,
    VA_AlexandriaCity = 2891,
    VA_Alleghany = 2892,
    VA_Amelia = 2893,
    VA_Amherst = 2894,
    VA_Appomattox = 2895,
    VA_Arlington = 2896,
    VA_Augusta = 2897,
    VA_Bath = 2898,
    VA_Bedford = 2899,
    VA_Bland = 2900,
    VA_Botetourt = 2901,
    VA_Bristol = 2902,
    VA_Brunswick = 2903,
    VA_Buchanan = 2904,
    VA_Buckingham = 2905,
    VA_BuenaVistaCity = 2906,
    VA_Campbell = 2907,
    VA_Caroline = 2908,
    VA_Carroll = 2909,
    VA_CharlesCity = 2910,
    VA_Charlotte = 2911,
    VA_CharlottesvilleCity = 2912,
    VA_ChesapeakeCity = 2913,
    VA_Chesterfield = 2914,
    VA_Clarke = 2915,
    VA_ColonialHeightsCity = 2916,
    VA_CovingtonCity = 2917,
    VA_Craig = 2918,
    VA_Culpeper = 2919,
    VA_Cumberland = 2920,
    VA_DanvilleCity = 2921,
    VA_Dickenson = 2922,
    VA_Dinwiddie = 2923,
    VA_Essex = 2924,
    VA_FairfaxCity = 2925,
    VA_Fairfax = 2926,
    VA_FallsChurchCity = 2927,
    VA_Fauquier = 2928,
    VA_Floyd = 2929,
    VA_Fluvanna = 2930,
    VA_FranklinCity = 2931,
    VA_Franklin = 2932,
    VA_Frederick = 2933,
    VA_FredericksburgCity = 2934,
    VA_GalaxCity = 2935,
    VA_Giles = 2936,
    VA_Gloucester = 2937,
    VA_Goochland = 2938,
    VA_Grayson = 2939,
    VA_Greene = 2940,
    VA_Greensville = 2941,
    VA_Halifax = 2942,
    VA_HamptonCity = 2943,
    VA_Hanover = 2944,
    VA_HarrisonburgCity = 2945,
    VA_Henrico = 2946,
    VA_Henry = 2947,
    VA_Highland = 2948,
    VA_HopewellCity = 2949,
    VA_IsleOfWight = 2950,
    VA_JamesCity = 2951,
    VA_KingAndQueen = 2952,
    VA_KingGeorge = 2953,
    VA_KingWilliam = 2954,
    VA_Lancaster = 2955,
    VA_Lee = 2956,
    VA_LexingtonCity = 2957,
    VA_Loudoun = 2958,
    VA_Louisa = 2959,
    VA_Lunenburg = 2960,
    VA_LynchburgCity = 2961,
    VA_Madison = 2962,
    VA_ManassasCity = 2963,
    VA_ManassasParkCity = 2964,
    VA_MartinsvilleCity = 2965,
    VA_Mathews = 2966,
    VA_Mecklenburg = 2967,
    VA_Middlesex = 2968,
    VA_Montgomery = 2969,
    VA_Nelson = 2970,
    VA_NewKent = 2971,
    VA_NewportNewsCity = 2972,
    VA_NorfolkCity = 2973,
    VA_Northampton = 2974,
    VA_Northumberland = 2975,
    VA_NortonCity = 2976,
    VA_Nottoway = 2977,
    VA_Orange = 2978,
    VA_Page = 2979,
    VA_Patrick = 2980,
    VA_PetersburgCity = 2981,
    VA_Pittsylvania = 2982,
    VA_PoquosonCity = 2983,
    VA_PortsmouthCity = 2984,
    VA_Powhatan = 2985,
    VA_PrinceEdward = 2986,
    VA_PrinceGeorge = 2987,
    VA_PrinceWilliam = 2988,
    VA_Pulaski = 2989,
    VA_Radford = 2990,
    VA_Rappahannock = 2991,
    VA_RichmondCity = 2992,
    VA_Richmond = 2993,
    VA_RoanokeCity = 2994,
    VA_Roanoke = 2995,
    VA_Rockbridge = 2996,
    VA_Rockingham = 2997,
    VA_Russell = 2998,
    VA_Salem = 2999,
    VA_Scott = 3000,
    VA_Shenandoah = 3001,
    VA_Smyth = 3002,
    VA_Southampton = 3003,
    VA_Spotsylvania = 3004,
    VA_Stafford = 3005,
    VA_StauntonCity = 3006,
    VA_SuffolkCity = 3007,
    VA_Surry = 3008,
    VA_Sussex = 3009,
    VA_Tazewell = 3010,
    VA_VirginiaBeachCity = 3011,
    VA_Warren = 3012,
    VA_Washington = 3013,
    VA_WaynesboroCity = 3014,
    VA_Westmoreland = 3015,
    VA_WilliamsburgCity = 3016,
    VA_WinchesterCity = 3017,
    VA_Wise = 3018,
    VA_Wythe = 3019,
    VA_York = 3020,
    VI_SaintCroix = 3021,
    VI_SaintJohn = 3022,
    VI_SaintThomas = 3023,
    VT_Addison = 3024,
    VT_Bennington = 3025,
    VT_Caledonia = 3026,
    VT_Chittenden = 3027,
    VT_Essex = 3028,
    VT_Franklin = 3029,
    VT_GrandIsle = 3030,
    VT_Lamoille = 3031,
    VT_Orange = 3032,
    VT_Orleans = 3033,
    VT_Rutland = 3034,
    VT_Washington = 3035,
    VT_Windham = 3036,
    VT_Windsor = 3037,
    WA_Adams = 3038,
    WA_Asotin = 3039,
    WA_Benton = 3040,
    WA_Chelan = 3041,
    WA_Clallam = 3042,
    WA_Clark = 3043,
    WA_Columbia = 3044,
    WA_Cowlitz = 3045,
    WA_Douglas = 3046,
    WA_Ferry = 3047,
    WA_Franklin = 3048,
    WA_Garfield = 3049,
    WA_Grant = 3050,
    WA_GraysHarbor = 3051,
    WA_Island = 3052,
    WA_Jefferson = 3053,
    WA_King = 3054,
    WA_Kitsap = 3055,
    WA_Kittitas = 3056,
    WA_Klickitat = 3057,
    WA_Lewis = 3058,
    WA_Lincoln = 3059,
    WA_Mason = 3060,
    WA_Okanogan = 3061,
    WA_Pacific = 3062,
    WA_PendOreille = 3063,
    WA_Pierce = 3064,
    WA_SanJuan = 3065,
    WA_Skagit = 3066,
    WA_Skamania = 3067,
    WA_Snohomish = 3068,
    WA_Spokane = 3069,
    WA_Stevens = 3070,
    WA_Thurston = 3071,
    WA_Wahkiakum = 3072,
    WA_WallaWalla = 3073,
    WA_Whatcom = 3074,
    WA_Whitman = 3075,
    WA_Yakima = 3076,
    WI_Adams = 3077,
    WI_Ashland = 3078,
    WI_Barron = 3079,
    WI_Bayfield = 3080,
    WI_Brown = 3081,
    WI_Buffalo = 3082,
    WI_Burnett = 3083,
    WI_Calumet = 3084,
    WI_Chippewa = 3085,
    WI_Clark = 3086,
    WI_Columbia = 3087,
    WI_Crawford = 3088,
    WI_Dane = 3089,
    WI_Dodge = 3090,
    WI_Door = 3091,
    WI_Douglas = 3092,
    WI_Dunn = 3093,
    WI_EauClaire = 3094,
    WI_Florence = 3095,
    WI_FondDuLac = 3096,
    WI_Forest = 3097,
    WI_Grant = 3098,
    WI_GreenLake = 3099,
    WI_Green = 3100,
    WI_Iowa = 3101,
    WI_Iron = 3102,
    WI_Jackson = 3103,
    WI_Jefferson = 3104,
    WI_Juneau = 3105,
    WI_Kenosha = 3106,
    WI_Kewaunee = 3107,
    WI_LaCrosse = 3108,
    WI_Lafayette = 3109,
    WI_Langlade = 3110,
    WI_Lincoln = 3111,
    WI_Manitowoc = 3112,
    WI_Marathon = 3113,
    WI_Marinette = 3114,
    WI_Marquette = 3115,
    WI_Menominee = 3116,
    WI_Milwaukee = 3117,
    WI_Monroe = 3118,
    WI_Oconto = 3119,
    WI_Oneida = 3120,
    WI_Outagamie = 3121,
    WI_Ozaukee = 3122,
    WI_Pepin = 3123,
    WI_Pierce = 3124,
    WI_Polk = 3125,
    WI_Portage = 3126,
    WI_Price = 3127,
    WI_Racine = 3128,
    WI_Richland = 3129,
    WI_Rock = 3130,
    WI_Rusk = 3131,
    WI_SaintCroix = 3132,
    WI_Sauk = 3133,
    WI_Sawyer = 3134,
    WI_Shawano = 3135,
    WI_Sheboygan = 3136,
    WI_Taylor = 3137,
    WI_Trempealeau = 3138,
    WI_Vernon = 3139,
    WI_Vilas = 3140,
    WI_Walworth = 3141,
    WI_Washburn = 3142,
    WI_Washington = 3143,
    WI_Waukesha = 3144,
    WI_Waupaca = 3145,
    WI_Waushara = 3146,
    WI_Winnebago = 3147,
    WI_Wood = 3148,
    WV_Barbour = 3149,
    WV_Berkeley = 3150,
    WV_Boone = 3151,
    WV_Braxton = 3152,
    WV_Brooke = 3153,
    WV_Cabell = 3154,
    WV_Calhoun = 3155,
    WV_Clay = 3156,
    WV_Doddridge = 3157,
    WV_Fayette = 3158,
    WV_Gilmer = 3159,
    WV_Grant = 3160,
    WV_Greenbrier = 3161,
    WV_Hampshire = 3162,
    WV_Hancock = 3163,
    WV_Hardy = 3164,
    WV_Harrison = 3165,
    WV_Jackson = 3166,
    WV_Jefferson = 3167,
    WV_Kanawha = 3168,
    WV_Lewis = 3169,
    WV_Lincoln = 3170,
    WV_Logan = 3171,
    WV_Marion = 3172,
    WV_Marshall = 3173,
    WV_Mason = 3174,
    WV_Mcdowell = 3175,
    WV_Mercer = 3176,
    WV_Mineral = 3177,
    WV_Mingo = 3178,
    WV_Monongalia = 3179,
    WV_Monroe = 3180,
    WV_Morgan = 3181,
    WV_Nicholas = 3182,
    WV_Ohio = 3183,
    WV_Pendleton = 3184,
    WV_Pleasants = 3185,
    WV_Pocahontas = 3186,
    WV_Preston = 3187,
    WV_Putnam = 3188,
    WV_Raleigh = 3189,
    WV_Randolph = 3190,
    WV_Ritchie = 3191,
    WV_Roane = 3192,
    WV_Summers = 3193,
    WV_Taylor = 3194,
    WV_Tucker = 3195,
    WV_Tyler = 3196,
    WV_Upshur = 3197,
    WV_Wayne = 3198,
    WV_Webster = 3199,
    WV_Wetzel = 3200,
    WV_Wirt = 3201,
    WV_Wood = 3202,
    WV_Wyoming = 3203,
    WY_Albany = 3204,
    WY_BigHorn = 3205,
    WY_Campbell = 3206,
    WY_Carbon = 3207,
    WY_Converse = 3208,
    WY_Crook = 3209,
    WY_Fremont = 3210,
    WY_Goshen = 3211,
    WY_HotSprings = 3212,
    WY_Johnson = 3213,
    WY_Laramie = 3214,
    WY_Lincoln = 3215,
    WY_Natrona = 3216,
    WY_Niobrara = 3217,
    WY_Park = 3218,
    WY_Platte = 3219,
    WY_Sheridan = 3220,
    WY_Sublette = 3221,
    WY_Sweetwater = 3222,
    WY_Teton = 3223,
    WY_Uinta = 3224,
    WY_Washakie = 3225,
    WY_Weston = 3226,
    AA_Full = 3227,
    AE_Full = 3228,
    AP_Full = 3229,
}

export class GeoLocationDto implements IGeoLocationDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    county?: USCounty | undefined;
    usState?: USState | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: IGeoLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.usState = _data["usState"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GeoLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["county"] = this.county;
        data["usState"] = this.usState;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IGeoLocationDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    county?: USCounty | undefined;
    usState?: USState | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class ValidateCityStatePostalCodeInput implements IValidateCityStatePostalCodeInput {
    city?: string | undefined;
    usState?: USState | undefined;
    postalCode?: string | undefined;

    constructor(data?: IValidateCityStatePostalCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.usState = _data["usState"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): ValidateCityStatePostalCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCityStatePostalCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["usState"] = this.usState;
        data["postalCode"] = this.postalCode;
        return data; 
    }
}

export interface IValidateCityStatePostalCodeInput {
    city?: string | undefined;
    usState?: USState | undefined;
    postalCode?: string | undefined;
}

export class AddressValidationResultDto implements IAddressValidationResultDto {
    inputAddress?: ValidateCityStatePostalCodeInput | undefined;
    standardizedAddress?: GeoLocationDto | undefined;
    isAddressValid?: boolean | undefined;

    constructor(data?: IAddressValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputAddress = _data["inputAddress"] ? ValidateCityStatePostalCodeInput.fromJS(_data["inputAddress"]) : <any>undefined;
            this.standardizedAddress = _data["standardizedAddress"] ? GeoLocationDto.fromJS(_data["standardizedAddress"]) : <any>undefined;
            this.isAddressValid = _data["isAddressValid"];
        }
    }

    static fromJS(data: any): AddressValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputAddress"] = this.inputAddress ? this.inputAddress.toJSON() : <any>undefined;
        data["standardizedAddress"] = this.standardizedAddress ? this.standardizedAddress.toJSON() : <any>undefined;
        data["isAddressValid"] = this.isAddressValid;
        return data; 
    }
}

export interface IAddressValidationResultDto {
    inputAddress?: ValidateCityStatePostalCodeInput | undefined;
    standardizedAddress?: GeoLocationDto | undefined;
    isAddressValid?: boolean | undefined;
}

export class LookupItemDto implements ILookupItemDto {
    id!: string;
    shortName!: string;
    longName!: string;

    constructor(data?: ILookupItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortName = _data["shortName"];
            this.longName = _data["longName"];
        }
    }

    static fromJS(data: any): LookupItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortName"] = this.shortName;
        data["longName"] = this.longName;
        return data; 
    }
}

export interface ILookupItemDto {
    id: string;
    shortName: string;
    longName: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class NotificationData implements INotificationData {
    readonly type?: string | undefined;
    properties?: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId?: number | undefined;
    notificationName?: string | undefined;
    data?: NotificationData | undefined;
    entityType?: string | undefined;
    entityTypeName?: string | undefined;
    entityId?: any | undefined;
    severity?: NotificationSeverity | undefined;
    creationTime?: moment.Moment | undefined;
    id?: string | undefined;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId?: number | undefined;
    notificationName?: string | undefined;
    data?: NotificationData | undefined;
    entityType?: string | undefined;
    entityTypeName?: string | undefined;
    entityId?: any | undefined;
    severity?: NotificationSeverity | undefined;
    creationTime?: moment.Moment | undefined;
    id?: string | undefined;
}

export class UserNotification implements IUserNotification {
    tenantId?: number | undefined;
    userId?: number | undefined;
    state?: UserNotificationState | undefined;
    notification?: TenantNotification | undefined;
    id?: string | undefined;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId?: number | undefined;
    userId?: number | undefined;
    state?: UserNotificationState | undefined;
    notification?: TenantNotification | undefined;
    id?: string | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount?: number | undefined;
    totalCount?: number | undefined;
    items?: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount?: number | undefined;
    totalCount?: number | undefined;
    items?: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id?: string | undefined;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id?: string | undefined;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName?: string | undefined;
    description?: string | undefined;
    name!: string;
    isSubscribed?: boolean | undefined;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName?: string | undefined;
    description?: string | undefined;
    name: string;
    isSubscribed?: boolean | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications?: boolean | undefined;
    notifications?: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications?: boolean | undefined;
    notifications?: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed?: boolean | undefined;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed?: boolean | undefined;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications?: boolean | undefined;
    notifications?: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications?: boolean | undefined;
    notifications?: NotificationSubscriptionDto[] | undefined;
}

export class CreateNotificationOutputDto implements ICreateNotificationOutputDto {
    success?: boolean | undefined;
    message?: string | undefined;

    constructor(data?: ICreateNotificationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateNotificationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICreateNotificationOutputDto {
    success?: boolean | undefined;
    message?: string | undefined;
}

export class IsImportFileExistInputDto implements IIsImportFileExistInputDto {
    fileHash!: string;
    fileName!: string;

    constructor(data?: IIsImportFileExistInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileHash = _data["fileHash"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): IsImportFileExistInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsImportFileExistInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileHash"] = this.fileHash;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IIsImportFileExistInputDto {
    fileHash: string;
    fileName: string;
}

export class IsImportFileExistResultDto implements IIsImportFileExistResultDto {
    creationTime!: moment.Moment;
    mimeType?: string | undefined;
    fileName!: string;
    fileHash!: string;

    constructor(data?: IIsImportFileExistResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
            this.fileHash = _data["fileHash"];
        }
    }

    static fromJS(data: any): IsImportFileExistResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsImportFileExistResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        data["fileHash"] = this.fileHash;
        return data; 
    }
}

export interface IIsImportFileExistResultDto {
    creationTime: moment.Moment;
    mimeType?: string | undefined;
    fileName: string;
    fileHash: string;
}

export class ImportDataFileInputDto implements IImportDataFileInputDto {
    mimeType!: string;
    fileName!: string;
    fileContent?: string | undefined;
    fileHash!: string;

    constructor(data?: IImportDataFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.fileHash = _data["fileHash"];
        }
    }

    static fromJS(data: any): ImportDataFileInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataFileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["fileHash"] = this.fileHash;
        return data; 
    }
}

export interface IImportDataFileInputDto {
    mimeType: string;
    fileName: string;
    fileContent?: string | undefined;
    fileHash: string;
}

export class ImportDataFileDto implements IImportDataFileDto {
    creationTime?: moment.Moment | undefined;
    idText?: string | undefined;
    tenantId?: number | undefined;
    userId?: number | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    fileHash?: string | undefined;
    binaryObjectId?: string | undefined;

    constructor(data?: IImportDataFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.idText = _data["idText"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.fileHash = _data["fileHash"];
            this.binaryObjectId = _data["binaryObjectId"];
        }
    }

    static fromJS(data: any): ImportDataFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["idText"] = this.idText;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["fileHash"] = this.fileHash;
        data["binaryObjectId"] = this.binaryObjectId;
        return data; 
    }
}

export interface IImportDataFileDto {
    creationTime?: moment.Moment | undefined;
    idText?: string | undefined;
    tenantId?: number | undefined;
    userId?: number | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    fileHash?: string | undefined;
    binaryObjectId?: string | undefined;
}

export class DataExportDownloadRef implements IDataExportDownloadRef {
    claimNumber?: string | undefined;
    claimId?: number | undefined;
    submissionIdText?: string | undefined;
    submissionId?: number | undefined;
    submissionType?: number | undefined;
    fileName?: string | undefined;
    downloadRef?: string | undefined;
    dataExportId?: number | undefined;

    constructor(data?: IDataExportDownloadRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.claimId = _data["claimId"];
            this.submissionIdText = _data["submissionIdText"];
            this.submissionId = _data["submissionId"];
            this.submissionType = _data["submissionType"];
            this.fileName = _data["fileName"];
            this.downloadRef = _data["downloadRef"];
            this.dataExportId = _data["dataExportId"];
        }
    }

    static fromJS(data: any): DataExportDownloadRef {
        data = typeof data === 'object' ? data : {};
        let result = new DataExportDownloadRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["claimId"] = this.claimId;
        data["submissionIdText"] = this.submissionIdText;
        data["submissionId"] = this.submissionId;
        data["submissionType"] = this.submissionType;
        data["fileName"] = this.fileName;
        data["downloadRef"] = this.downloadRef;
        data["dataExportId"] = this.dataExportId;
        return data; 
    }
}

export interface IDataExportDownloadRef {
    claimNumber?: string | undefined;
    claimId?: number | undefined;
    submissionIdText?: string | undefined;
    submissionId?: number | undefined;
    submissionType?: number | undefined;
    fileName?: string | undefined;
    downloadRef?: string | undefined;
    dataExportId?: number | undefined;
}

export class DataExportJSON implements IDataExportJSON {
    claimNumber?: string | undefined;
    claimId?: number | undefined;
    submissionIdText?: string | undefined;
    submissionId?: number | undefined;
    submissionType?: number | undefined;
    fileName?: string | undefined;
    numberOfRecords?: number | undefined;
    content?: string | undefined;

    constructor(data?: IDataExportJSON) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.claimId = _data["claimId"];
            this.submissionIdText = _data["submissionIdText"];
            this.submissionId = _data["submissionId"];
            this.submissionType = _data["submissionType"];
            this.fileName = _data["fileName"];
            this.numberOfRecords = _data["numberOfRecords"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): DataExportJSON {
        data = typeof data === 'object' ? data : {};
        let result = new DataExportJSON();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["claimId"] = this.claimId;
        data["submissionIdText"] = this.submissionIdText;
        data["submissionId"] = this.submissionId;
        data["submissionType"] = this.submissionType;
        data["fileName"] = this.fileName;
        data["numberOfRecords"] = this.numberOfRecords;
        data["content"] = this.content;
        return data; 
    }
}

export interface IDataExportJSON {
    claimNumber?: string | undefined;
    claimId?: number | undefined;
    submissionIdText?: string | undefined;
    submissionId?: number | undefined;
    submissionType?: number | undefined;
    fileName?: string | undefined;
    numberOfRecords?: number | undefined;
    content?: string | undefined;
}

export class DataExportDto implements IDataExportDto {
    dataExportId?: number | undefined;
    fromDate?: moment.Moment | undefined;
    toDate?: moment.Moment | undefined;
    startDateTime?: moment.Moment | undefined;
    endDateTime?: moment.Moment | undefined;
    dataExportDownloadRefs?: DataExportDownloadRef[] | undefined;
    dataExportJSONs?: DataExportJSON[] | undefined;

    constructor(data?: IDataExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataExportId = _data["dataExportId"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["dataExportDownloadRefs"])) {
                this.dataExportDownloadRefs = [] as any;
                for (let item of _data["dataExportDownloadRefs"])
                    this.dataExportDownloadRefs!.push(DataExportDownloadRef.fromJS(item));
            }
            if (Array.isArray(_data["dataExportJSONs"])) {
                this.dataExportJSONs = [] as any;
                for (let item of _data["dataExportJSONs"])
                    this.dataExportJSONs!.push(DataExportJSON.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataExportId"] = this.dataExportId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.dataExportDownloadRefs)) {
            data["dataExportDownloadRefs"] = [];
            for (let item of this.dataExportDownloadRefs)
                data["dataExportDownloadRefs"].push(item.toJSON());
        }
        if (Array.isArray(this.dataExportJSONs)) {
            data["dataExportJSONs"] = [];
            for (let item of this.dataExportJSONs)
                data["dataExportJSONs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDataExportDto {
    dataExportId?: number | undefined;
    fromDate?: moment.Moment | undefined;
    toDate?: moment.Moment | undefined;
    startDateTime?: moment.Moment | undefined;
    endDateTime?: moment.Moment | undefined;
    dataExportDownloadRefs?: DataExportDownloadRef[] | undefined;
    dataExportJSONs?: DataExportJSON[] | undefined;
}

export class CurrentStaffUserProfileEditDto implements ICurrentStaffUserProfileEditDto {
    staffPhone?: string | undefined;
    staffFax?: string | undefined;
    staffOrganization?: string | undefined;
    id?: number | undefined;

    constructor(data?: ICurrentStaffUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffPhone = _data["staffPhone"];
            this.staffFax = _data["staffFax"];
            this.staffOrganization = _data["staffOrganization"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurrentStaffUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentStaffUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffPhone"] = this.staffPhone;
        data["staffFax"] = this.staffFax;
        data["staffOrganization"] = this.staffOrganization;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrentStaffUserProfileEditDto {
    staffPhone?: string | undefined;
    staffFax?: string | undefined;
    staffOrganization?: string | undefined;
    id?: number | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber?: string | undefined;
    isPhoneNumberConfirmed?: boolean | undefined;
    timezone?: string | undefined;
    qrCodeSetupImageUrl?: string | undefined;
    isGoogleAuthenticatorEnabled?: boolean | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber?: string | undefined;
    isPhoneNumberConfirmed?: boolean | undefined;
    timezone?: string | undefined;
    qrCodeSetupImageUrl?: string | undefined;
    isGoogleAuthenticatorEnabled?: boolean | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl?: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl?: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber?: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber?: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    answerToRandomQuestion!: string;
    securityQuestion!: string;
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerToRandomQuestion = _data["answerToRandomQuestion"];
            this.securityQuestion = _data["securityQuestion"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerToRandomQuestion"] = this.answerToRandomQuestion;
        data["securityQuestion"] = this.securityQuestion;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    answerToRandomQuestion: string;
    securityQuestion: string;
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit?: boolean | undefined;
    requireLowercase?: boolean | undefined;
    requireNonAlphanumeric?: boolean | undefined;
    requireUppercase?: boolean | undefined;
    requiredLength?: number | undefined;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit?: boolean | undefined;
    requireLowercase?: boolean | undefined;
    requireNonAlphanumeric?: boolean | undefined;
    requireUppercase?: boolean | undefined;
    requiredLength?: number | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting?: PasswordComplexitySetting | undefined;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting?: PasswordComplexitySetting | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture?: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture?: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class PublicContactRequestDto implements IPublicContactRequestDto {
    subject!: string;
    message!: string;
    fromPersonName!: string;
    fromPersonEmail!: string;
    lkpContactCategoryId!: string;
    id?: number | undefined;

    constructor(data?: IPublicContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.fromPersonName = _data["fromPersonName"];
            this.fromPersonEmail = _data["fromPersonEmail"];
            this.lkpContactCategoryId = _data["lkpContactCategoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PublicContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["fromPersonName"] = this.fromPersonName;
        data["fromPersonEmail"] = this.fromPersonEmail;
        data["lkpContactCategoryId"] = this.lkpContactCategoryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPublicContactRequestDto {
    subject: string;
    message: string;
    fromPersonName: string;
    fromPersonEmail: string;
    lkpContactCategoryId: string;
    id?: number | undefined;
}

export class PagedResultDtoOfPublicContactRequestDto implements IPagedResultDtoOfPublicContactRequestDto {
    totalCount?: number | undefined;
    items?: PublicContactRequestDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPublicContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PublicContactRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPublicContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPublicContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPublicContactRequestDto {
    totalCount?: number | undefined;
    items?: PublicContactRequestDto[] | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name?: string | undefined;
    surname?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    profilePictureId?: string | undefined;
    id?: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name?: string | undefined;
    surname?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    profilePictureId?: string | undefined;
    id?: number | undefined;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName?: string | undefined;
    trialDayCount?: number | undefined;
    monthlyPrice?: number | undefined;
    annualPrice?: number | undefined;
    isHighestEdition?: boolean | undefined;
    isFree?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName?: string | undefined;
    trialDayCount?: number | undefined;
    monthlyPrice?: number | undefined;
    annualPrice?: number | undefined;
    isHighestEdition?: boolean | undefined;
    isFree?: boolean | undefined;
    id?: number | undefined;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    logoId?: string | undefined;
    logoFileType?: string | undefined;
    customCssId?: string | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    subscriptionPaymentType?: SubscriptionPaymentType | undefined;
    edition?: EditionInfoDto | undefined;
    creationTime?: moment.Moment | undefined;
    paymentPeriodType?: PaymentPeriodType | undefined;
    subscriptionDateString?: string | undefined;
    creationTimeString?: string | undefined;
    id?: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    logoId?: string | undefined;
    logoFileType?: string | undefined;
    customCssId?: string | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    subscriptionPaymentType?: SubscriptionPaymentType | undefined;
    edition?: EditionInfoDto | undefined;
    creationTime?: moment.Moment | undefined;
    paymentPeriodType?: PaymentPeriodType | undefined;
    subscriptionDateString?: string | undefined;
    creationTimeString?: string | undefined;
    id?: number | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version?: string | undefined;
    releaseDate?: moment.Moment | undefined;
    currency?: string | undefined;
    currencySign?: string | undefined;
    allowTenantsToChangeEmailSettings?: boolean | undefined;
    userDelegationIsEnabled?: boolean | undefined;
    features?: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version?: string | undefined;
    releaseDate?: moment.Moment | undefined;
    currency?: string | undefined;
    currencySign?: string | undefined;
    allowTenantsToChangeEmailSettings?: boolean | undefined;
    userDelegationIsEnabled?: boolean | undefined;
    features?: { [key: string]: boolean; } | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType?: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data; 
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType?: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader?: boolean | undefined;
    mobileFixedHeader?: boolean | undefined;
    headerSkin?: string | undefined;
    minimizeDesktopHeaderType?: string | undefined;
    headerMenuArrows?: boolean | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
            this.headerMenuArrows = _data["headerMenuArrows"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerMenuArrows"] = this.headerMenuArrows;
        return data; 
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader?: boolean | undefined;
    mobileFixedHeader?: boolean | undefined;
    headerSkin?: string | undefined;
    minimizeDesktopHeaderType?: string | undefined;
    headerMenuArrows?: boolean | undefined;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader?: boolean | undefined;
    subheaderStyle?: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        return data; 
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader?: boolean | undefined;
    subheaderStyle?: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position?: string | undefined;
    asideSkin?: string | undefined;
    fixedAside?: boolean | undefined;
    allowAsideMinimizing?: boolean | undefined;
    defaultMinimizedAside?: boolean | undefined;
    submenuToggle?: string | undefined;
    searchActive?: boolean | undefined;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        return data; 
    }
}

export interface IThemeMenuSettingsDto {
    position?: string | undefined;
    asideSkin?: string | undefined;
    fixedAside?: boolean | undefined;
    allowAsideMinimizing?: boolean | undefined;
    defaultMinimizedAside?: boolean | undefined;
    submenuToggle?: string | undefined;
    searchActive?: boolean | undefined;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter?: boolean | undefined;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter?: boolean | undefined;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme?: string | undefined;
    layout?: ThemeLayoutSettingsDto | undefined;
    header?: ThemeHeaderSettingsDto | undefined;
    subHeader?: ThemeSubHeaderSettingsDto | undefined;
    menu?: ThemeMenuSettingsDto | undefined;
    footer?: ThemeFooterSettingsDto | undefined;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IThemeSettingsDto {
    theme?: string | undefined;
    layout?: ThemeLayoutSettingsDto | undefined;
    header?: ThemeHeaderSettingsDto | undefined;
    subHeader?: ThemeSubHeaderSettingsDto | undefined;
    menu?: ThemeMenuSettingsDto | undefined;
    footer?: ThemeFooterSettingsDto | undefined;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings?: ThemeSettingsDto | undefined;
    isLeftMenuUsed?: boolean | undefined;
    isTopMenuUsed?: boolean | undefined;
    isTabMenuUsed?: boolean | undefined;
    allowMenuScroll?: boolean | undefined;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data; 
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings?: ThemeSettingsDto | undefined;
    isLeftMenuUsed?: boolean | undefined;
    isTopMenuUsed?: boolean | undefined;
    isTabMenuUsed?: boolean | undefined;
    allowMenuScroll?: boolean | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user?: UserLoginInfoDto | undefined;
    tenant?: TenantLoginInfoDto | undefined;
    application?: ApplicationInfoDto | undefined;
    theme?: UiCustomizationSettingsDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user?: UserLoginInfoDto | undefined;
    tenant?: TenantLoginInfoDto | undefined;
    application?: ApplicationInfoDto | undefined;
    theme?: UiCustomizationSettingsDto | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken?: string | undefined;
    encodedUserId?: string | undefined;
    encodedTenantId?: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken?: string | undefined;
    encodedUserId?: string | undefined;
    encodedTenantId?: string | undefined;
}

export class TenantAddressDto implements ITenantAddressDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    id?: number | undefined;

    constructor(data?: ITenantAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.usStateCode = _data["usStateCode"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["usStateCode"] = this.usStateCode;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantAddressDto {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    usStateCode?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    id?: number | undefined;
}

export class TenantInfoDto implements ITenantInfoDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    logoFileType?: string | undefined;
    logoId?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    address?: TenantAddressDto | undefined;
    vPostalBoxAddress?: TenantAddressDto | undefined;
    sendApplicationDestination?: string | undefined;
    useFillButton?: boolean | undefined;
    vPostalBoxEnabled?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: ITenantInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.logoFileType = _data["logoFileType"];
            this.logoId = _data["logoId"];
            this.workPhone = _data["workPhone"];
            this.email = _data["email"];
            this.address = _data["address"] ? TenantAddressDto.fromJS(_data["address"]) : <any>undefined;
            this.vPostalBoxAddress = _data["vPostalBoxAddress"] ? TenantAddressDto.fromJS(_data["vPostalBoxAddress"]) : <any>undefined;
            this.sendApplicationDestination = _data["sendApplicationDestination"];
            this.useFillButton = _data["useFillButton"];
            this.vPostalBoxEnabled = _data["vPostalBoxEnabled"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["logoFileType"] = this.logoFileType;
        data["logoId"] = this.logoId;
        data["workPhone"] = this.workPhone;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["vPostalBoxAddress"] = this.vPostalBoxAddress ? this.vPostalBoxAddress.toJSON() : <any>undefined;
        data["sendApplicationDestination"] = this.sendApplicationDestination;
        data["useFillButton"] = this.useFillButton;
        data["vPostalBoxEnabled"] = this.vPostalBoxEnabled;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantInfoDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    logoFileType?: string | undefined;
    logoId?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    address?: TenantAddressDto | undefined;
    vPostalBoxAddress?: TenantAddressDto | undefined;
    sendApplicationDestination?: string | undefined;
    useFillButton?: boolean | undefined;
    vPostalBoxEnabled?: boolean | undefined;
    id?: number | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    editionDisplayName?: string | undefined;
    connectionString?: string | undefined;
    isActive?: boolean | undefined;
    creationTime?: moment.Moment | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    editionId?: number | undefined;
    isInTrialPeriod?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    editionDisplayName?: string | undefined;
    connectionString?: string | undefined;
    isActive?: boolean | undefined;
    creationTime?: moment.Moment | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    editionId?: number | undefined;
    isInTrialPeriod?: boolean | undefined;
    id?: number | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount?: number | undefined;
    items?: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount?: number | undefined;
    items?: TenantListDto[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword?: string | undefined;
    connectionString?: string | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword?: string | undefined;
    connectionString?: string | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    displayName!: string;
    logoFileType?: string | undefined;
    logoId?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    creationStatus?: string | undefined;
    sendApplicationDestination?: string | undefined;
    tenancyName!: string;
    name!: string;
    connectionString?: string | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.logoFileType = _data["logoFileType"];
            this.logoId = _data["logoId"];
            this.workPhone = _data["workPhone"];
            this.email = _data["email"];
            this.creationStatus = _data["creationStatus"];
            this.sendApplicationDestination = _data["sendApplicationDestination"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["logoFileType"] = this.logoFileType;
        data["logoId"] = this.logoId;
        data["workPhone"] = this.workPhone;
        data["email"] = this.email;
        data["creationStatus"] = this.creationStatus;
        data["sendApplicationDestination"] = this.sendApplicationDestination;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    displayName: string;
    logoFileType?: string | undefined;
    logoId?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    creationStatus?: string | undefined;
    sendApplicationDestination?: string | undefined;
    tenancyName: string;
    name: string;
    connectionString?: string | undefined;
    editionId?: number | undefined;
    isActive?: boolean | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean | undefined;
    id?: number | undefined;
}

export class NameValueDto implements INameValueDto {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name?: string | undefined;
    value?: string | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name?: string | undefined;
    readonly attributes?: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name?: string | undefined;
    attributes?: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value?: string | undefined;
    displayText?: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value?: string | undefined;
    displayText?: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items?: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items?: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name?: string | undefined;
    attributes?: { [key: string]: any; } | undefined;
    validator?: IValueValidator | undefined;
    itemSource?: LocalizableComboboxItemSourceDto | undefined;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        this.attributes![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name?: string | undefined;
    attributes?: { [key: string]: any; } | undefined;
    validator?: IValueValidator | undefined;
    itemSource?: LocalizableComboboxItemSourceDto | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    inputType?: FeatureInputTypeDto | undefined;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    inputType?: FeatureInputTypeDto | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues?: NameValueDto[] | undefined;
    features?: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues?: NameValueDto[] | undefined;
    features?: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id?: number | undefined;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id?: number | undefined;
    featureValues: NameValueDto[];
}

export class EntityDto implements IEntityDto {
    id?: number | undefined;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id?: number | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone?: string | undefined;
    timezoneForComparison?: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone?: string | undefined;
    timezoneForComparison?: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled?: boolean | undefined;
    timeOutSecond?: number | undefined;
    showTimeOutNotificationSecond?: number | undefined;
    showLockScreenWhenTimedOut?: boolean | undefined;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data; 
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled?: boolean | undefined;
    timeOutSecond?: number | undefined;
    showTimeOutNotificationSecond?: number | undefined;
    showLockScreenWhenTimedOut?: boolean | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration?: boolean | undefined;
    isNewRegisteredUserActiveByDefault?: boolean | undefined;
    isEmailConfirmationRequiredForLogin?: boolean | undefined;
    useCaptchaOnRegistration?: boolean | undefined;
    useCaptchaOnLogin?: boolean | undefined;
    isCookieConsentEnabled?: boolean | undefined;
    isQuickThemeSelectEnabled?: boolean | undefined;
    sessionTimeOutSettings?: SessionTimeOutSettingsEditDto | undefined;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration?: boolean | undefined;
    isNewRegisteredUserActiveByDefault?: boolean | undefined;
    isEmailConfirmationRequiredForLogin?: boolean | undefined;
    useCaptchaOnRegistration?: boolean | undefined;
    useCaptchaOnLogin?: boolean | undefined;
    isCookieConsentEnabled?: boolean | undefined;
    isQuickThemeSelectEnabled?: boolean | undefined;
    sessionTimeOutSettings?: SessionTimeOutSettingsEditDto | undefined;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings?: boolean | undefined;
    defaultFromAddress?: string | undefined;
    defaultFromDisplayName?: string | undefined;
    smtpHost?: string | undefined;
    smtpPort?: number | undefined;
    smtpUserName?: string | undefined;
    smtpPassword?: string | undefined;
    smtpDomain?: string | undefined;
    smtpEnableSsl?: boolean | undefined;
    smtpUseDefaultCredentials?: boolean | undefined;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings?: boolean | undefined;
    defaultFromAddress?: string | undefined;
    defaultFromDisplayName?: string | undefined;
    smtpHost?: string | undefined;
    smtpPort?: number | undefined;
    smtpUserName?: string | undefined;
    smtpPassword?: string | undefined;
    smtpDomain?: string | undefined;
    smtpEnableSsl?: boolean | undefined;
    smtpUseDefaultCredentials?: boolean | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled?: boolean | undefined;
    isEnabled?: boolean | undefined;
    domain?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled?: boolean | undefined;
    isEnabled?: boolean | undefined;
    domain?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled?: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout?: number | undefined;
    defaultAccountLockoutSeconds?: number | undefined;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled?: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout?: number | undefined;
    defaultAccountLockoutSeconds?: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication?: boolean | undefined;
    isEnabled?: boolean | undefined;
    isEmailProviderEnabled?: boolean | undefined;
    isSmsProviderEnabled?: boolean | undefined;
    isRememberBrowserEnabled?: boolean | undefined;
    isGoogleAuthenticatorEnabled?: boolean | undefined;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication?: boolean | undefined;
    isEnabled?: boolean | undefined;
    isEmailProviderEnabled?: boolean | undefined;
    isSmsProviderEnabled?: boolean | undefined;
    isRememberBrowserEnabled?: boolean | undefined;
    isGoogleAuthenticatorEnabled?: boolean | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser?: boolean | undefined;
    useDefaultPasswordComplexitySettings?: boolean | undefined;
    passwordComplexity?: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity?: PasswordComplexitySetting | undefined;
    userLockOut?: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin?: TwoFactorLoginSettingsEditDto | undefined;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser?: boolean | undefined;
    useDefaultPasswordComplexitySettings?: boolean | undefined;
    passwordComplexity?: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity?: PasswordComplexitySetting | undefined;
    userLockOut?: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin?: TwoFactorLoginSettingsEditDto | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName?: string | undefined;
    address?: string | undefined;
    taxVatNo?: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName?: string | undefined;
    address?: string | undefined;
    taxVatNo?: string | undefined;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled?: boolean | undefined;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data; 
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled?: boolean | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general?: GeneralSettingsEditDto | undefined;
    userManagement!: TenantUserManagementSettingsEditDto;
    email?: TenantEmailSettingsEditDto | undefined;
    ldap?: LdapSettingsEditDto | undefined;
    security!: SecuritySettingsEditDto;
    billing?: TenantBillingSettingsEditDto | undefined;
    otherSettings?: TenantOtherSettingsEditDto | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general?: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto;
    email?: TenantEmailSettingsEditDto | undefined;
    ldap?: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto;
    billing?: TenantBillingSettingsEditDto | undefined;
    otherSettings?: TenantOtherSettingsEditDto | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode?: string | undefined;
    rememberClient?: boolean | undefined;
    twoFactorRememberClientToken?: string | undefined;
    singleSignIn?: boolean | undefined;
    returnUrl?: string | undefined;
    captchaResponse?: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode?: string | undefined;
    rememberClient?: boolean | undefined;
    twoFactorRememberClientToken?: string | undefined;
    singleSignIn?: boolean | undefined;
    returnUrl?: string | undefined;
    captchaResponse?: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    shouldResetPassword?: boolean | undefined;
    passwordResetCode?: string | undefined;
    userId?: number | undefined;
    requiresTwoFactorVerification?: boolean | undefined;
    twoFactorAuthProviders?: string[] | undefined;
    twoFactorRememberClientToken?: string | undefined;
    returnUrl?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpireInSeconds?: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    shouldResetPassword?: boolean | undefined;
    passwordResetCode?: string | undefined;
    userId?: number | undefined;
    requiresTwoFactorVerification?: boolean | undefined;
    twoFactorAuthProviders?: string[] | undefined;
    twoFactorRememberClientToken?: string | undefined;
    returnUrl?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpireInSeconds?: number | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IRefreshTokenResult {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId?: number | undefined;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId?: number | undefined;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name?: string | undefined;
    clientId?: string | undefined;
    additionalParams?: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name?: string | undefined;
    clientId?: string | undefined;
    additionalParams?: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl?: string | undefined;
    singleSignIn?: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl?: string | undefined;
    singleSignIn?: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    waitingForActivation?: boolean | undefined;
    returnUrl?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpireInSeconds?: number | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    waitingForActivation?: boolean | undefined;
    returnUrl?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpireInSeconds?: number | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId?: number | undefined;
    roleName?: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId?: number | undefined;
    roleName?: string | undefined;
}

export class UserListDto implements IUserListDto {
    userCategory?: UserCategory | undefined;
    staffUserGroupId?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureId?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    roles?: UserListRoleDto[] | undefined;
    isActive?: boolean | undefined;
    creationTime?: moment.Moment | undefined;
    id?: number | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCategory = _data["userCategory"];
            this.staffUserGroupId = _data["staffUserGroupId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCategory"] = this.userCategory;
        data["staffUserGroupId"] = this.staffUserGroupId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    userCategory?: UserCategory | undefined;
    staffUserGroupId?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureId?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    roles?: UserListRoleDto[] | undefined;
    isActive?: boolean | undefined;
    creationTime?: moment.Moment | undefined;
    id?: number | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount?: number | undefined;
    items?: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount?: number | undefined;
    items?: UserListDto[] | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType?: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string;
    fileType?: string | undefined;
    fileToken: string;
}

export class UserEditDto implements IUserEditDto {
    userCategory?: UserCategory | undefined;
    securityQuestion1?: string | undefined;
    securityQuestion2?: string | undefined;
    securityQuestion3?: string | undefined;
    securityAnswer1?: string | undefined;
    securityAnswer2?: string | undefined;
    securityAnswer3?: string | undefined;
    id?: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isTwoFactorEnabled?: boolean | undefined;
    isLockoutEnabled?: boolean | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCategory = _data["userCategory"];
            this.securityQuestion1 = _data["securityQuestion1"];
            this.securityQuestion2 = _data["securityQuestion2"];
            this.securityQuestion3 = _data["securityQuestion3"];
            this.securityAnswer1 = _data["securityAnswer1"];
            this.securityAnswer2 = _data["securityAnswer2"];
            this.securityAnswer3 = _data["securityAnswer3"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCategory"] = this.userCategory;
        data["securityQuestion1"] = this.securityQuestion1;
        data["securityQuestion2"] = this.securityQuestion2;
        data["securityQuestion3"] = this.securityQuestion3;
        data["securityAnswer1"] = this.securityAnswer1;
        data["securityAnswer2"] = this.securityAnswer2;
        data["securityAnswer3"] = this.securityAnswer3;
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data; 
    }
}

export interface IUserEditDto {
    userCategory?: UserCategory | undefined;
    securityQuestion1?: string | undefined;
    securityQuestion2?: string | undefined;
    securityQuestion3?: string | undefined;
    securityAnswer1?: string | undefined;
    securityAnswer2?: string | undefined;
    securityAnswer3?: string | undefined;
    id?: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isTwoFactorEnabled?: boolean | undefined;
    isLockoutEnabled?: boolean | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;
    isAssigned?: boolean | undefined;
    inheritedFromOrganizationUnit?: boolean | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;
    isAssigned?: boolean | undefined;
    inheritedFromOrganizationUnit?: boolean | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId?: number | undefined;
    code?: string | undefined;
    displayName?: string | undefined;
    memberCount?: number | undefined;
    roleCount?: number | undefined;
    lastModificationTime?: moment.Moment | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: moment.Moment | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId?: number | undefined;
    code?: string | undefined;
    displayName?: string | undefined;
    memberCount?: number | undefined;
    roleCount?: number | undefined;
    lastModificationTime?: moment.Moment | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: moment.Moment | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId?: string | undefined;
    user?: UserEditDto | undefined;
    roles?: UserRoleDto[] | undefined;
    allOrganizationUnits?: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits?: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId?: string | undefined;
    user?: UserEditDto | undefined;
    roles?: UserRoleDto[] | undefined;
    allOrganizationUnits?: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits?: string[] | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    isGrantedByDefault?: boolean | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    isGrantedByDefault?: boolean | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions?: FlatPermissionDto[] | undefined;
    grantedPermissionNames?: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions?: FlatPermissionDto[] | undefined;
    grantedPermissionNames?: string[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id?: number | undefined;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id?: number | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id?: number | undefined;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id?: number | undefined;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    organizationUnits?: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail?: boolean | undefined;
    setRandomPassword?: boolean | undefined;
    organizationUnits?: number[] | undefined;
}

export enum DataExportItemCategoryEnum {
    All = 1,
    ClaimApplication = 2,
    ClaimUpdateRequest = 3,
    ClaimAccessRequest = 4,
    UserPersonalInfoUpdateRequest = 5,
    UserContactInfoUpdate = 6,
}

export class RetrieveDataExportItemsInput implements IRetrieveDataExportItemsInput {
    dateFrom!: moment.Moment;
    dateTo!: moment.Moment;
    itemsCategory?: DataExportItemCategoryEnum | undefined;

    constructor(data?: IRetrieveDataExportItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.itemsCategory = _data["itemsCategory"];
        }
    }

    static fromJS(data: any): RetrieveDataExportItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataExportItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.format('YYYY-MM-DD') : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.format('YYYY-MM-DD') : <any>undefined;
        data["itemsCategory"] = this.itemsCategory;
        return data; 
    }
}

export interface IRetrieveDataExportItemsInput {
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    itemsCategory?: DataExportItemCategoryEnum | undefined;
}

export class DataExportFileDownloadRequestDto implements IDataExportFileDownloadRequestDto {
    identifier?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDataExportFileDownloadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DataExportFileDownloadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataExportFileDownloadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IDataExportFileDownloadRequestDto {
    identifier?: string | undefined;
    fileName?: string | undefined;
}

export class DataExportFileListDto implements IDataExportFileListDto {
    exportFile?: DataExportFileDownloadRequestDto[] | undefined;

    constructor(data?: IDataExportFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exportFile"])) {
                this.exportFile = [] as any;
                for (let item of _data["exportFile"])
                    this.exportFile!.push(DataExportFileDownloadRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataExportFileListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataExportFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exportFile)) {
            data["exportFile"] = [];
            for (let item of this.exportFile)
                data["exportFile"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDataExportFileListDto {
    exportFile?: DataExportFileDownloadRequestDto[] | undefined;
}

export class UploadClaimDocumentInputDto implements IUploadClaimDocumentInputDto {
    documentName!: string;
    fileContent?: string | undefined;

    constructor(data?: IUploadClaimDocumentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): UploadClaimDocumentInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadClaimDocumentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["fileContent"] = this.fileContent;
        return data; 
    }
}

export interface IUploadClaimDocumentInputDto {
    documentName: string;
    fileContent?: string | undefined;
}

export class VcCreateClaimMessageInputDto implements IVcCreateClaimMessageInputDto {
    vcClaimNumber?: string | undefined;
    staffNote?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcCreateClaimMessageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcClaimNumber = _data["vcClaimNumber"];
            this.staffNote = _data["staffNote"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcCreateClaimMessageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcCreateClaimMessageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcClaimNumber"] = this.vcClaimNumber;
        data["staffNote"] = this.staffNote;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcCreateClaimMessageInputDto {
    vcClaimNumber?: string | undefined;
    staffNote?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum VcSubmissionType {
    Application = 1,
    ClaimUpdateRequest = 2,
}

export enum FileAttachmentCategoryEnum {
    AdditionalInfo = 1,
    CopyOfOriginalDocuments = 2,
    CopyOfBill = 3,
    CopyOfCheck = 4,
    DoctorNote = 5,
    InsuranceCard = 6,
    LastPayStub = 7,
    LastTaxReturn = 8,
    OtherAttachmentType = 9,
}

export class AttachmentDto implements IAttachmentDto {
    attachmentCategory?: string | undefined;
    attachmentNote?: string | undefined;
    fileName?: string | undefined;
    binaryObjectId?: string | undefined;
    notes?: string | undefined;
    attachmentType?: FileAttachmentCategoryEnum | undefined;
    attachmentTypeOther?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentCategory = _data["attachmentCategory"];
            this.attachmentNote = _data["attachmentNote"];
            this.fileName = _data["fileName"];
            this.binaryObjectId = _data["binaryObjectId"];
            this.notes = _data["notes"];
            this.attachmentType = _data["attachmentType"];
            this.attachmentTypeOther = _data["attachmentTypeOther"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentCategory"] = this.attachmentCategory;
        data["attachmentNote"] = this.attachmentNote;
        data["fileName"] = this.fileName;
        data["binaryObjectId"] = this.binaryObjectId;
        data["notes"] = this.notes;
        data["attachmentType"] = this.attachmentType;
        data["attachmentTypeOther"] = this.attachmentTypeOther;
        return data; 
    }
}

export interface IAttachmentDto {
    attachmentCategory?: string | undefined;
    attachmentNote?: string | undefined;
    fileName?: string | undefined;
    binaryObjectId?: string | undefined;
    notes?: string | undefined;
    attachmentType?: FileAttachmentCategoryEnum | undefined;
    attachmentTypeOther?: string | undefined;
}

export enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2,
}

export enum ClaimantRelationshipToVictim {
    ClaimantIsTheVictim = 1,
    VictimsChild = 2,
    VictimsParent = 3,
    VictimsAdoptiveParent = 4,
    VictimsSpouse = 5,
    VictimsBrotherOrSister = 6,
    VictimsGrandparent = 7,
    VictimsGrandchild = 8,
    VictimsForestParent = 9,
    VictimsLegalGuardian = 10,
    VictimsLivingWith = 11,
    VictimsPreviouslyLivedWith = 12,
    FamilyMemberWitnessedCrime = 13,
    PrimaryCaretakerOfVictim = 14,
    OtherDescription = 15,
}

export class AppClaimantDto implements IAppClaimantDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    relationshipToVictim?: ClaimantRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppClaimantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? EzAddress.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberOther = _data["phoneNumberOther"];
            this.email = _data["email"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppClaimantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppClaimantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberOther"] = this.phoneNumberOther;
        data["email"] = this.email;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppClaimantDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    relationshipToVictim?: ClaimantRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum RelationshipToVictim {
    SelfImVictim = 1,
    VictimsChild = 2,
    VictimsParent = 3,
    VictimsAdoptiveParent = 4,
    VictimsSpouse = 5,
    VictimsBrotherOrSister = 6,
    VictimsGrandparent = 7,
    VictimsGrandchild = 8,
    VictimsForestParent = 9,
    VictimsLegalGuardian = 10,
    VictimsLivingWith = 11,
    VictimsPreviouslyLivedWith = 12,
    FamilyMemberWitnessedCrime = 13,
    PrimaryCaretakerOfVictim = 14,
    OtherDescription = 15,
}

export class AppCrimeVictimDto implements IAppCrimeVictimDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    ageAtCrimeTime?: string | undefined;
    dod?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    isDeceased?: boolean | undefined;
    publicUsersRelationshipToVictim?: RelationshipToVictim | undefined;
    publicUsersRelationshipToVictimOtherDesc?: string | undefined;
    priorDisabilities?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppCrimeVictimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.ageAtCrimeTime = _data["ageAtCrimeTime"];
            this.dod = _data["dod"] ? moment(_data["dod"].toString()) : <any>undefined;
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? EzAddress.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberOther = _data["phoneNumberOther"];
            this.email = _data["email"];
            this.isDeceased = _data["isDeceased"];
            this.publicUsersRelationshipToVictim = _data["publicUsersRelationshipToVictim"];
            this.publicUsersRelationshipToVictimOtherDesc = _data["publicUsersRelationshipToVictimOtherDesc"];
            this.priorDisabilities = _data["priorDisabilities"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppCrimeVictimDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppCrimeVictimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["ageAtCrimeTime"] = this.ageAtCrimeTime;
        data["dod"] = this.dod ? this.dod.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberOther"] = this.phoneNumberOther;
        data["email"] = this.email;
        data["isDeceased"] = this.isDeceased;
        data["publicUsersRelationshipToVictim"] = this.publicUsersRelationshipToVictim;
        data["publicUsersRelationshipToVictimOtherDesc"] = this.publicUsersRelationshipToVictimOtherDesc;
        data["priorDisabilities"] = this.priorDisabilities;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppCrimeVictimDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    ageAtCrimeTime?: string | undefined;
    dod?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    isDeceased?: boolean | undefined;
    publicUsersRelationshipToVictim?: RelationshipToVictim | undefined;
    publicUsersRelationshipToVictimOtherDesc?: string | undefined;
    priorDisabilities?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum EmailType {
    Work = 0,
    Personal = 1,
}

export class AppFuneralHomeDto implements IAppFuneralHomeDto {
    businessName?: string | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    phoneNumberOther?: string | undefined;
    phoneExtensionOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;

    constructor(data?: IAppFuneralHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? EzAddress.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.phoneNumberOther = _data["phoneNumberOther"];
            this.phoneExtensionOther = _data["phoneExtensionOther"];
            this.email = _data["email"];
            this.emailType = _data["emailType"];
        }
    }

    static fromJS(data: any): AppFuneralHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFuneralHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["phoneNumberOther"] = this.phoneNumberOther;
        data["phoneExtensionOther"] = this.phoneExtensionOther;
        data["email"] = this.email;
        data["emailType"] = this.emailType;
        return data; 
    }
}

export interface IAppFuneralHomeDto {
    businessName?: string | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    phoneNumberOther?: string | undefined;
    phoneExtensionOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;
}

export class AppExpencesInfoDto implements IAppExpencesInfoDto {
    funeral?: boolean | undefined;
    americanIndianService?: boolean | undefined;
    medical?: boolean | undefined;
    mentalHealth?: boolean | undefined;
    dental?: boolean | undefined;
    futureIncomeLoss?: boolean | undefined;
    lossOfSupport?: boolean | undefined;
    rehabilitation?: boolean | undefined;
    griefCounseling?: boolean | undefined;
    replacementService?: boolean | undefined;
    crimeSceneCleanup?: boolean | undefined;
    transportation?: boolean | undefined;
    other?: boolean | undefined;
    incomeLossForVictim?: boolean | undefined;
    incomeLossForCaregiver?: boolean | undefined;
    anticipatedExpenses?: string | undefined;
    victimInjuriesCausedByCrime?: string | undefined;
    doctorsHospitalsMentalHealthProfessionalsList?: string | undefined;
    funeralHome?: AppFuneralHomeDto | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppExpencesInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funeral = _data["funeral"];
            this.americanIndianService = _data["americanIndianService"];
            this.medical = _data["medical"];
            this.mentalHealth = _data["mentalHealth"];
            this.dental = _data["dental"];
            this.futureIncomeLoss = _data["futureIncomeLoss"];
            this.lossOfSupport = _data["lossOfSupport"];
            this.rehabilitation = _data["rehabilitation"];
            this.griefCounseling = _data["griefCounseling"];
            this.replacementService = _data["replacementService"];
            this.crimeSceneCleanup = _data["crimeSceneCleanup"];
            this.transportation = _data["transportation"];
            this.other = _data["other"];
            this.incomeLossForVictim = _data["incomeLossForVictim"];
            this.incomeLossForCaregiver = _data["incomeLossForCaregiver"];
            this.anticipatedExpenses = _data["anticipatedExpenses"];
            this.victimInjuriesCausedByCrime = _data["victimInjuriesCausedByCrime"];
            this.doctorsHospitalsMentalHealthProfessionalsList = _data["doctorsHospitalsMentalHealthProfessionalsList"];
            this.funeralHome = _data["funeralHome"] ? AppFuneralHomeDto.fromJS(_data["funeralHome"]) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppExpencesInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppExpencesInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funeral"] = this.funeral;
        data["americanIndianService"] = this.americanIndianService;
        data["medical"] = this.medical;
        data["mentalHealth"] = this.mentalHealth;
        data["dental"] = this.dental;
        data["futureIncomeLoss"] = this.futureIncomeLoss;
        data["lossOfSupport"] = this.lossOfSupport;
        data["rehabilitation"] = this.rehabilitation;
        data["griefCounseling"] = this.griefCounseling;
        data["replacementService"] = this.replacementService;
        data["crimeSceneCleanup"] = this.crimeSceneCleanup;
        data["transportation"] = this.transportation;
        data["other"] = this.other;
        data["incomeLossForVictim"] = this.incomeLossForVictim;
        data["incomeLossForCaregiver"] = this.incomeLossForCaregiver;
        data["anticipatedExpenses"] = this.anticipatedExpenses;
        data["victimInjuriesCausedByCrime"] = this.victimInjuriesCausedByCrime;
        data["doctorsHospitalsMentalHealthProfessionalsList"] = this.doctorsHospitalsMentalHealthProfessionalsList;
        data["funeralHome"] = this.funeralHome ? this.funeralHome.toJSON() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppExpencesInfoDto {
    funeral?: boolean | undefined;
    americanIndianService?: boolean | undefined;
    medical?: boolean | undefined;
    mentalHealth?: boolean | undefined;
    dental?: boolean | undefined;
    futureIncomeLoss?: boolean | undefined;
    lossOfSupport?: boolean | undefined;
    rehabilitation?: boolean | undefined;
    griefCounseling?: boolean | undefined;
    replacementService?: boolean | undefined;
    crimeSceneCleanup?: boolean | undefined;
    transportation?: boolean | undefined;
    other?: boolean | undefined;
    incomeLossForVictim?: boolean | undefined;
    incomeLossForCaregiver?: boolean | undefined;
    anticipatedExpenses?: string | undefined;
    victimInjuriesCausedByCrime?: string | undefined;
    doctorsHospitalsMentalHealthProfessionalsList?: string | undefined;
    funeralHome?: AppFuneralHomeDto | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class CrimeTypeDto implements ICrimeTypeDto {
    arson?: boolean | undefined;
    assaultBattery?: boolean | undefined;
    burglary?: boolean | undefined;
    carJacking?: boolean | undefined;
    weaponAssault?: boolean | undefined;
    childAbuse?: boolean | undefined;
    childPornography?: boolean | undefined;
    childSexualAbuse?: boolean | undefined;
    childMolest?: boolean | undefined;
    domesticViolence?: boolean | undefined;
    duiOrDwi?: boolean | undefined;
    elderAbuse?: boolean | undefined;
    hitnRunV?: boolean | undefined;
    homicide?: boolean | undefined;
    homicideV?: boolean | undefined;
    humanTrafficking?: boolean | undefined;
    identityTheftFraud?: boolean | undefined;
    kidnapping?: boolean | undefined;
    leavenCrimeScene?: boolean | undefined;
    rape?: boolean | undefined;
    robbery?: boolean | undefined;
    sexAssault?: boolean | undefined;
    stalking?: boolean | undefined;
    terrorism?: boolean | undefined;
    threats?: boolean | undefined;
    other?: boolean | undefined;
    otherDesc?: string | undefined;
    doNotKnow?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: ICrimeTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arson = _data["arson"];
            this.assaultBattery = _data["assaultBattery"];
            this.burglary = _data["burglary"];
            this.carJacking = _data["carJacking"];
            this.weaponAssault = _data["weaponAssault"];
            this.childAbuse = _data["childAbuse"];
            this.childPornography = _data["childPornography"];
            this.childSexualAbuse = _data["childSexualAbuse"];
            this.childMolest = _data["childMolest"];
            this.domesticViolence = _data["domesticViolence"];
            this.duiOrDwi = _data["duiOrDwi"];
            this.elderAbuse = _data["elderAbuse"];
            this.hitnRunV = _data["hitnRunV"];
            this.homicide = _data["homicide"];
            this.homicideV = _data["homicideV"];
            this.humanTrafficking = _data["humanTrafficking"];
            this.identityTheftFraud = _data["identityTheftFraud"];
            this.kidnapping = _data["kidnapping"];
            this.leavenCrimeScene = _data["leavenCrimeScene"];
            this.rape = _data["rape"];
            this.robbery = _data["robbery"];
            this.sexAssault = _data["sexAssault"];
            this.stalking = _data["stalking"];
            this.terrorism = _data["terrorism"];
            this.threats = _data["threats"];
            this.other = _data["other"];
            this.otherDesc = _data["otherDesc"];
            this.doNotKnow = _data["doNotKnow"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): CrimeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrimeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arson"] = this.arson;
        data["assaultBattery"] = this.assaultBattery;
        data["burglary"] = this.burglary;
        data["carJacking"] = this.carJacking;
        data["weaponAssault"] = this.weaponAssault;
        data["childAbuse"] = this.childAbuse;
        data["childPornography"] = this.childPornography;
        data["childSexualAbuse"] = this.childSexualAbuse;
        data["childMolest"] = this.childMolest;
        data["domesticViolence"] = this.domesticViolence;
        data["duiOrDwi"] = this.duiOrDwi;
        data["elderAbuse"] = this.elderAbuse;
        data["hitnRunV"] = this.hitnRunV;
        data["homicide"] = this.homicide;
        data["homicideV"] = this.homicideV;
        data["humanTrafficking"] = this.humanTrafficking;
        data["identityTheftFraud"] = this.identityTheftFraud;
        data["kidnapping"] = this.kidnapping;
        data["leavenCrimeScene"] = this.leavenCrimeScene;
        data["rape"] = this.rape;
        data["robbery"] = this.robbery;
        data["sexAssault"] = this.sexAssault;
        data["stalking"] = this.stalking;
        data["terrorism"] = this.terrorism;
        data["threats"] = this.threats;
        data["other"] = this.other;
        data["otherDesc"] = this.otherDesc;
        data["doNotKnow"] = this.doNotKnow;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface ICrimeTypeDto {
    arson?: boolean | undefined;
    assaultBattery?: boolean | undefined;
    burglary?: boolean | undefined;
    carJacking?: boolean | undefined;
    weaponAssault?: boolean | undefined;
    childAbuse?: boolean | undefined;
    childPornography?: boolean | undefined;
    childSexualAbuse?: boolean | undefined;
    childMolest?: boolean | undefined;
    domesticViolence?: boolean | undefined;
    duiOrDwi?: boolean | undefined;
    elderAbuse?: boolean | undefined;
    hitnRunV?: boolean | undefined;
    homicide?: boolean | undefined;
    homicideV?: boolean | undefined;
    humanTrafficking?: boolean | undefined;
    identityTheftFraud?: boolean | undefined;
    kidnapping?: boolean | undefined;
    leavenCrimeScene?: boolean | undefined;
    rape?: boolean | undefined;
    robbery?: boolean | undefined;
    sexAssault?: boolean | undefined;
    stalking?: boolean | undefined;
    terrorism?: boolean | undefined;
    threats?: boolean | undefined;
    other?: boolean | undefined;
    otherDesc?: string | undefined;
    doNotKnow?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum OKCounty {
    None = 0,
    Adair = 1,
    Alfalfa = 2,
    Atoka = 3,
    Beaver = 4,
    Beckham = 5,
    Blaine = 6,
    Bryan = 7,
    Caddo = 8,
    Canadian = 9,
    Carter = 10,
    Cherokee = 11,
    Choctaw = 12,
    Cimarron = 13,
    Cleveland = 14,
    Coal = 15,
    Comanche = 16,
    Cotton = 17,
    Craig = 18,
    Creek = 19,
    Custer = 20,
    Delaware = 21,
    Dewey = 22,
    Ellis = 23,
    Garfield = 24,
    Garvin = 25,
    Grady = 26,
    Grant = 27,
    Greer = 28,
    Harmon = 29,
    Harper = 30,
    Haskell = 31,
    Hughes = 32,
    Jackson = 33,
    Jefferson = 34,
    Johnston = 35,
    Kay = 36,
    Kingfisher = 37,
    Kiowa = 38,
    Latimer = 39,
    LeFlore = 40,
    Lincoln = 41,
    Logan = 42,
    Love = 43,
    Major = 44,
    Marshall = 45,
    Mayes = 46,
    Mcclain = 47,
    Mccurtain = 48,
    Mcintosh = 49,
    Murray = 50,
    Muskogee = 51,
    Noble = 52,
    Nowata = 53,
    Okfuskee = 54,
    Oklahoma = 55,
    Okmulgee = 56,
    Osage = 57,
    Ottawa = 58,
    Pawnee = 59,
    Payne = 60,
    Pittsburg = 61,
    Pontotoc = 62,
    Pottawatomie = 63,
    Pushmataha = 64,
    RogerMills = 65,
    Rogers = 66,
    Seminole = 67,
    Sequoyah = 68,
    Stephens = 69,
    Texas = 70,
    Tillman = 71,
    Tulsa = 72,
    Wagoner = 73,
    Washington = 74,
    Washita = 75,
    Woods = 76,
    Woodward = 77,
}

export enum LocationType {
    BarOrClub = 1,
    Business = 2,
    RuralArea = 3,
    SomeonesResidence = 4,
    Street = 5,
    Vehicle = 6,
    VictimsWorkplace = 7,
    VictimsResidence = 8,
    Other = 9,
    School = 10,
}

export class AppCrimeInfoDto implements IAppCrimeInfoDto {
    timeOfCrime?: string | undefined;
    dateOfCrime?: moment.Moment | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeTypeOther?: string | undefined;
    crimeDescription?: string | undefined;
    reportedByMinorToAdultDate?: moment.Moment | undefined;
    reportedByMinorToAdultTime?: string | undefined;
    reportedToLeaDate?: moment.Moment | undefined;
    reportedToLeaTime?: string | undefined;
    reportedBy?: string | undefined;
    reportNumber?: string | undefined;
    reportedToAgencyName?: string | undefined;
    agencyContactInformation?: string | undefined;
    address?: EzAddress | undefined;
    crimeCounty?: OKCounty | undefined;
    crimeLocationDesc?: string | undefined;
    crimeLocationType?: LocationType | undefined;
    crimeLocationTypeOther?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IAppCrimeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeOfCrime = _data["timeOfCrime"];
            this.dateOfCrime = _data["dateOfCrime"] ? moment(_data["dateOfCrime"].toString()) : <any>undefined;
            this.crimeType = _data["crimeType"] ? CrimeTypeDto.fromJS(_data["crimeType"]) : <any>undefined;
            this.crimeTypeOther = _data["crimeTypeOther"];
            this.crimeDescription = _data["crimeDescription"];
            this.reportedByMinorToAdultDate = _data["reportedByMinorToAdultDate"] ? moment(_data["reportedByMinorToAdultDate"].toString()) : <any>undefined;
            this.reportedByMinorToAdultTime = _data["reportedByMinorToAdultTime"];
            this.reportedToLeaDate = _data["reportedToLeaDate"] ? moment(_data["reportedToLeaDate"].toString()) : <any>undefined;
            this.reportedToLeaTime = _data["reportedToLeaTime"];
            this.reportedBy = _data["reportedBy"];
            this.reportNumber = _data["reportNumber"];
            this.reportedToAgencyName = _data["reportedToAgencyName"];
            this.agencyContactInformation = _data["agencyContactInformation"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.crimeCounty = _data["crimeCounty"];
            this.crimeLocationDesc = _data["crimeLocationDesc"];
            this.crimeLocationType = _data["crimeLocationType"];
            this.crimeLocationTypeOther = _data["crimeLocationTypeOther"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppCrimeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppCrimeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeOfCrime"] = this.timeOfCrime;
        data["dateOfCrime"] = this.dateOfCrime ? this.dateOfCrime.toISOString() : <any>undefined;
        data["crimeType"] = this.crimeType ? this.crimeType.toJSON() : <any>undefined;
        data["crimeTypeOther"] = this.crimeTypeOther;
        data["crimeDescription"] = this.crimeDescription;
        data["reportedByMinorToAdultDate"] = this.reportedByMinorToAdultDate ? this.reportedByMinorToAdultDate.toISOString() : <any>undefined;
        data["reportedByMinorToAdultTime"] = this.reportedByMinorToAdultTime;
        data["reportedToLeaDate"] = this.reportedToLeaDate ? this.reportedToLeaDate.toISOString() : <any>undefined;
        data["reportedToLeaTime"] = this.reportedToLeaTime;
        data["reportedBy"] = this.reportedBy;
        data["reportNumber"] = this.reportNumber;
        data["reportedToAgencyName"] = this.reportedToAgencyName;
        data["agencyContactInformation"] = this.agencyContactInformation;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["crimeCounty"] = this.crimeCounty;
        data["crimeLocationDesc"] = this.crimeLocationDesc;
        data["crimeLocationType"] = this.crimeLocationType;
        data["crimeLocationTypeOther"] = this.crimeLocationTypeOther;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppCrimeInfoDto {
    timeOfCrime?: string | undefined;
    dateOfCrime?: moment.Moment | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeTypeOther?: string | undefined;
    crimeDescription?: string | undefined;
    reportedByMinorToAdultDate?: moment.Moment | undefined;
    reportedByMinorToAdultTime?: string | undefined;
    reportedToLeaDate?: moment.Moment | undefined;
    reportedToLeaTime?: string | undefined;
    reportedBy?: string | undefined;
    reportNumber?: string | undefined;
    reportedToAgencyName?: string | undefined;
    agencyContactInformation?: string | undefined;
    address?: EzAddress | undefined;
    crimeCounty?: OKCounty | undefined;
    crimeLocationDesc?: string | undefined;
    crimeLocationType?: LocationType | undefined;
    crimeLocationTypeOther?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class AppHowYouFindInfoDto implements IAppHowYouFindInfoDto {
    lawEnforcement?: boolean | undefined;
    districtAttorney?: boolean | undefined;
    medicalProvider?: boolean | undefined;
    victimAssistanceProgram?: boolean | undefined;
    media?: boolean | undefined;
    cardOrBooklet?: boolean | undefined;
    medicalExaminer?: boolean | undefined;
    funeralHome?: boolean | undefined;
    other?: boolean | undefined;
    otherDesc?: string | undefined;

    constructor(data?: IAppHowYouFindInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lawEnforcement = _data["lawEnforcement"];
            this.districtAttorney = _data["districtAttorney"];
            this.medicalProvider = _data["medicalProvider"];
            this.victimAssistanceProgram = _data["victimAssistanceProgram"];
            this.media = _data["media"];
            this.cardOrBooklet = _data["cardOrBooklet"];
            this.medicalExaminer = _data["medicalExaminer"];
            this.funeralHome = _data["funeralHome"];
            this.other = _data["other"];
            this.otherDesc = _data["otherDesc"];
        }
    }

    static fromJS(data: any): AppHowYouFindInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppHowYouFindInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lawEnforcement"] = this.lawEnforcement;
        data["districtAttorney"] = this.districtAttorney;
        data["medicalProvider"] = this.medicalProvider;
        data["victimAssistanceProgram"] = this.victimAssistanceProgram;
        data["media"] = this.media;
        data["cardOrBooklet"] = this.cardOrBooklet;
        data["medicalExaminer"] = this.medicalExaminer;
        data["funeralHome"] = this.funeralHome;
        data["other"] = this.other;
        data["otherDesc"] = this.otherDesc;
        return data; 
    }
}

export interface IAppHowYouFindInfoDto {
    lawEnforcement?: boolean | undefined;
    districtAttorney?: boolean | undefined;
    medicalProvider?: boolean | undefined;
    victimAssistanceProgram?: boolean | undefined;
    media?: boolean | undefined;
    cardOrBooklet?: boolean | undefined;
    medicalExaminer?: boolean | undefined;
    funeralHome?: boolean | undefined;
    other?: boolean | undefined;
    otherDesc?: string | undefined;
}

export class AppFedReportingInfoDto implements IAppFedReportingInfoDto {
    americanIndianOrAlaskaNative?: boolean | undefined;
    asian?: boolean | undefined;
    africanAmerican?: boolean | undefined;
    hispanicOrLatino?: boolean | undefined;
    nativeHawaiianOrPacific?: boolean | undefined;
    whiteNonLatinoOrCaucasian?: boolean | undefined;
    otherRace?: boolean | undefined;
    other?: string | undefined;
    tribalAffiliation?: string | undefined;

    constructor(data?: IAppFedReportingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.americanIndianOrAlaskaNative = _data["americanIndianOrAlaskaNative"];
            this.asian = _data["asian"];
            this.africanAmerican = _data["africanAmerican"];
            this.hispanicOrLatino = _data["hispanicOrLatino"];
            this.nativeHawaiianOrPacific = _data["nativeHawaiianOrPacific"];
            this.whiteNonLatinoOrCaucasian = _data["whiteNonLatinoOrCaucasian"];
            this.otherRace = _data["otherRace"];
            this.other = _data["other"];
            this.tribalAffiliation = _data["tribalAffiliation"];
        }
    }

    static fromJS(data: any): AppFedReportingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFedReportingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["americanIndianOrAlaskaNative"] = this.americanIndianOrAlaskaNative;
        data["asian"] = this.asian;
        data["africanAmerican"] = this.africanAmerican;
        data["hispanicOrLatino"] = this.hispanicOrLatino;
        data["nativeHawaiianOrPacific"] = this.nativeHawaiianOrPacific;
        data["whiteNonLatinoOrCaucasian"] = this.whiteNonLatinoOrCaucasian;
        data["otherRace"] = this.otherRace;
        data["other"] = this.other;
        data["tribalAffiliation"] = this.tribalAffiliation;
        return data; 
    }
}

export interface IAppFedReportingInfoDto {
    americanIndianOrAlaskaNative?: boolean | undefined;
    asian?: boolean | undefined;
    africanAmerican?: boolean | undefined;
    hispanicOrLatino?: boolean | undefined;
    nativeHawaiianOrPacific?: boolean | undefined;
    whiteNonLatinoOrCaucasian?: boolean | undefined;
    otherRace?: boolean | undefined;
    other?: string | undefined;
    tribalAffiliation?: string | undefined;
}

export class AppContactPersonDto implements IAppContactPersonDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: RelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isTribalVictimStaff?: boolean | undefined;
    allowOCVCToContactLocate?: boolean | undefined;
    allowOCVCTodiscussClaim?: boolean | undefined;
    isOnlineUser?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppContactPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? EzAddress.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberOther = _data["phoneNumberOther"];
            this.email = _data["email"];
            this.emailType = _data["emailType"];
            this.isTribalVictimStaff = _data["isTribalVictimStaff"];
            this.allowOCVCToContactLocate = _data["allowOCVCToContactLocate"];
            this.allowOCVCTodiscussClaim = _data["allowOCVCTodiscussClaim"];
            this.isOnlineUser = _data["isOnlineUser"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberOther"] = this.phoneNumberOther;
        data["email"] = this.email;
        data["emailType"] = this.emailType;
        data["isTribalVictimStaff"] = this.isTribalVictimStaff;
        data["allowOCVCToContactLocate"] = this.allowOCVCToContactLocate;
        data["allowOCVCTodiscussClaim"] = this.allowOCVCTodiscussClaim;
        data["isOnlineUser"] = this.isOnlineUser;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppContactPersonDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: RelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    address?: EzAddress | undefined;
    mailingAddress?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneNumberOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isTribalVictimStaff?: boolean | undefined;
    allowOCVCToContactLocate?: boolean | undefined;
    allowOCVCTodiscussClaim?: boolean | undefined;
    isOnlineUser?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum SuspectRelationshipToVictim {
    VictimsChild = 1,
    VictimsParent = 2,
    VictimsAdoptiveParent = 3,
    VictimsSpouse = 4,
    VictimsBrotherOrSister = 5,
    VictimsGrandparent = 6,
    VictimsGrandchild = 7,
    VictimsForestParent = 8,
    VictimsBoyfriend = 9,
    VictimsGirlfriend = 10,
    VictimsLegalGuardian = 11,
    VictimsLivingWith = 12,
    VictimsPreviouslyLivedWith = 13,
    FamilyMemberWitnessedCrime = 14,
    PrimaryCaregiverOfVictim = 15,
    VictimsEmployer = 16,
    VictimsCoworker = 17,
    VictimsFriend = 18,
    VictimsAcquaintance = 19,
    OtherDescription = 20,
}

export class AppSuspectDto implements IAppSuspectDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: SuspectRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    hasBeenArrested?: boolean | undefined;
    hasChargesBeenFiled?: boolean | undefined;
    criminalCaseNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppSuspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.hasBeenArrested = _data["hasBeenArrested"];
            this.hasChargesBeenFiled = _data["hasChargesBeenFiled"];
            this.criminalCaseNumber = _data["criminalCaseNumber"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppSuspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSuspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["hasBeenArrested"] = this.hasBeenArrested;
        data["hasChargesBeenFiled"] = this.hasChargesBeenFiled;
        data["criminalCaseNumber"] = this.criminalCaseNumber;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppSuspectDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: SuspectRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    hasBeenArrested?: boolean | undefined;
    hasChargesBeenFiled?: boolean | undefined;
    criminalCaseNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class AppCivilSuitInfoDto implements IAppCivilSuitInfoDto {
    civilCaseNumber?: string | undefined;
    civilSuitType?: string | undefined;
    lawFirmName?: string | undefined;
    attorneyFirstName?: string | undefined;
    attorneyLastName?: string | undefined;
    attorneyAddress?: EzAddress | undefined;
    attorneyPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppCivilSuitInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.civilCaseNumber = _data["civilCaseNumber"];
            this.civilSuitType = _data["civilSuitType"];
            this.lawFirmName = _data["lawFirmName"];
            this.attorneyFirstName = _data["attorneyFirstName"];
            this.attorneyLastName = _data["attorneyLastName"];
            this.attorneyAddress = _data["attorneyAddress"] ? EzAddress.fromJS(_data["attorneyAddress"]) : <any>undefined;
            this.attorneyPhoneNumber = _data["attorneyPhoneNumber"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppCivilSuitInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppCivilSuitInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["civilCaseNumber"] = this.civilCaseNumber;
        data["civilSuitType"] = this.civilSuitType;
        data["lawFirmName"] = this.lawFirmName;
        data["attorneyFirstName"] = this.attorneyFirstName;
        data["attorneyLastName"] = this.attorneyLastName;
        data["attorneyAddress"] = this.attorneyAddress ? this.attorneyAddress.toJSON() : <any>undefined;
        data["attorneyPhoneNumber"] = this.attorneyPhoneNumber;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppCivilSuitInfoDto {
    civilCaseNumber?: string | undefined;
    civilSuitType?: string | undefined;
    lawFirmName?: string | undefined;
    attorneyFirstName?: string | undefined;
    attorneyLastName?: string | undefined;
    attorneyAddress?: EzAddress | undefined;
    attorneyPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum InsuranceType {
    AutoInsurance = 1,
    HealthInsurancePlan = 2,
    LifeInsurance = 3,
    MedicareSoonercare = 4,
    OffendersAutoInsurance = 5,
    VehicleOwnersInsurance = 6,
    HomeownersInsurance = 7,
    DentalInsurance = 8,
    BurialInsurance = 9,
    WorkersCompInsurance = 10,
}

export class AppBeneficiaryDto implements IAppBeneficiaryDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: RelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    address?: EzAddress | undefined;

    constructor(data?: IAppBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAppBeneficiaryDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: RelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    address?: EzAddress | undefined;
}

export class AppInsuranceInfoDto implements IAppInsuranceInfoDto {
    insuranceType?: InsuranceType | undefined;
    insuranceCompanyName?: string | undefined;
    policyGroupMemberNumber?: string | undefined;
    beneficiary?: AppBeneficiaryDto | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    phone?: string | undefined;
    policyTypeMedicaidSoonercareNumber?: string | undefined;
    policyIssuedDate?: moment.Moment | undefined;
    amountReceived?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppInsuranceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceType = _data["insuranceType"];
            this.insuranceCompanyName = _data["insuranceCompanyName"];
            this.policyGroupMemberNumber = _data["policyGroupMemberNumber"];
            this.beneficiary = _data["beneficiary"] ? AppBeneficiaryDto.fromJS(_data["beneficiary"]) : <any>undefined;
            this.agentFirstName = _data["agentFirstName"];
            this.agentLastName = _data["agentLastName"];
            this.phone = _data["phone"];
            this.policyTypeMedicaidSoonercareNumber = _data["policyTypeMedicaidSoonercareNumber"];
            this.policyIssuedDate = _data["policyIssuedDate"] ? moment(_data["policyIssuedDate"].toString()) : <any>undefined;
            this.amountReceived = _data["amountReceived"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppInsuranceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppInsuranceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceType"] = this.insuranceType;
        data["insuranceCompanyName"] = this.insuranceCompanyName;
        data["policyGroupMemberNumber"] = this.policyGroupMemberNumber;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["agentFirstName"] = this.agentFirstName;
        data["agentLastName"] = this.agentLastName;
        data["phone"] = this.phone;
        data["policyTypeMedicaidSoonercareNumber"] = this.policyTypeMedicaidSoonercareNumber;
        data["policyIssuedDate"] = this.policyIssuedDate ? this.policyIssuedDate.toISOString() : <any>undefined;
        data["amountReceived"] = this.amountReceived;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppInsuranceInfoDto {
    insuranceType?: InsuranceType | undefined;
    insuranceCompanyName?: string | undefined;
    policyGroupMemberNumber?: string | undefined;
    beneficiary?: AppBeneficiaryDto | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    phone?: string | undefined;
    policyTypeMedicaidSoonercareNumber?: string | undefined;
    policyIssuedDate?: moment.Moment | undefined;
    amountReceived?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class AppPersonDto implements IAppPersonDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    phoneNumberOther?: string | undefined;
    phoneExtensionOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.phoneNumberOther = _data["phoneNumberOther"];
            this.phoneExtensionOther = _data["phoneExtensionOther"];
            this.email = _data["email"];
            this.emailType = _data["emailType"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["phoneNumberOther"] = this.phoneNumberOther;
        data["phoneExtensionOther"] = this.phoneExtensionOther;
        data["email"] = this.email;
        data["emailType"] = this.emailType;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppPersonDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    phoneNumberOther?: string | undefined;
    phoneExtensionOther?: string | undefined;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum MissedWorkCoveredSourceEnum {
    SickLeave = 1,
    AnnualLeave = 2,
    WorkersCompensation = 3,
    DisabilityInsurance = 4,
    SocialSecurityDisability = 5,
}

export class AppEmploymentDto implements IAppEmploymentDto {
    victimSelfEmployed?: boolean | undefined;
    missWorkDueCrimeInjuries?: boolean | undefined;
    missWorkFromDate?: moment.Moment | undefined;
    missWorkToDate?: moment.Moment | undefined;
    releasedToWorkDoctor?: AppPersonDto | undefined;
    occupation?: string | undefined;
    employerBusinessName?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    weeklyNetPay?: number | undefined;
    howLongEmployed?: string | undefined;
    selfEmploymentBusinessName?: string | undefined;
    howLongSelfEmployed?: string | undefined;
    isMissedWorkCovered?: boolean | undefined;
    missedWorkCoveredSource?: MissedWorkCoveredSourceEnum | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.victimSelfEmployed = _data["victimSelfEmployed"];
            this.missWorkDueCrimeInjuries = _data["missWorkDueCrimeInjuries"];
            this.missWorkFromDate = _data["missWorkFromDate"] ? moment(_data["missWorkFromDate"].toString()) : <any>undefined;
            this.missWorkToDate = _data["missWorkToDate"] ? moment(_data["missWorkToDate"].toString()) : <any>undefined;
            this.releasedToWorkDoctor = _data["releasedToWorkDoctor"] ? AppPersonDto.fromJS(_data["releasedToWorkDoctor"]) : <any>undefined;
            this.occupation = _data["occupation"];
            this.employerBusinessName = _data["employerBusinessName"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.weeklyNetPay = _data["weeklyNetPay"];
            this.howLongEmployed = _data["howLongEmployed"];
            this.selfEmploymentBusinessName = _data["selfEmploymentBusinessName"];
            this.howLongSelfEmployed = _data["howLongSelfEmployed"];
            this.isMissedWorkCovered = _data["isMissedWorkCovered"];
            this.missedWorkCoveredSource = _data["missedWorkCoveredSource"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["victimSelfEmployed"] = this.victimSelfEmployed;
        data["missWorkDueCrimeInjuries"] = this.missWorkDueCrimeInjuries;
        data["missWorkFromDate"] = this.missWorkFromDate ? this.missWorkFromDate.toISOString() : <any>undefined;
        data["missWorkToDate"] = this.missWorkToDate ? this.missWorkToDate.toISOString() : <any>undefined;
        data["releasedToWorkDoctor"] = this.releasedToWorkDoctor ? this.releasedToWorkDoctor.toJSON() : <any>undefined;
        data["occupation"] = this.occupation;
        data["employerBusinessName"] = this.employerBusinessName;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["weeklyNetPay"] = this.weeklyNetPay;
        data["howLongEmployed"] = this.howLongEmployed;
        data["selfEmploymentBusinessName"] = this.selfEmploymentBusinessName;
        data["howLongSelfEmployed"] = this.howLongSelfEmployed;
        data["isMissedWorkCovered"] = this.isMissedWorkCovered;
        data["missedWorkCoveredSource"] = this.missedWorkCoveredSource;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppEmploymentDto {
    victimSelfEmployed?: boolean | undefined;
    missWorkDueCrimeInjuries?: boolean | undefined;
    missWorkFromDate?: moment.Moment | undefined;
    missWorkToDate?: moment.Moment | undefined;
    releasedToWorkDoctor?: AppPersonDto | undefined;
    occupation?: string | undefined;
    employerBusinessName?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    weeklyNetPay?: number | undefined;
    howLongEmployed?: string | undefined;
    selfEmploymentBusinessName?: string | undefined;
    howLongSelfEmployed?: string | undefined;
    isMissedWorkCovered?: boolean | undefined;
    missedWorkCoveredSource?: MissedWorkCoveredSourceEnum | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class AppDependentDto implements IAppDependentDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: string | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    isDependantOnVictimsTaxReturn?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IAppDependentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.isDependantOnVictimsTaxReturn = _data["isDependantOnVictimsTaxReturn"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): AppDependentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDependentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["isDependantOnVictimsTaxReturn"] = this.isDependantOnVictimsTaxReturn;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IAppDependentDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    relationshipToVictim?: string | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    isDependantOnVictimsTaxReturn?: boolean | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicationDto implements IApplicationDto {
    applicationSubmittedDateTime?: moment.Moment | undefined;
    creationTime?: moment.Moment | undefined;
    claimants?: AppClaimantDto[] | undefined;
    crimeVictimInfo?: AppCrimeVictimDto | undefined;
    expencesInfo?: AppExpencesInfoDto | undefined;
    crimeInfo?: AppCrimeInfoDto | undefined;
    howYouFindInfo?: AppHowYouFindInfoDto | undefined;
    fedReportingInfo?: AppFedReportingInfoDto | undefined;
    victimUnableToWorkDueToCrime?: boolean | undefined;
    contactPersons?: AppContactPersonDto[] | undefined;
    isSuspectKnown?: boolean | undefined;
    suspects?: AppSuspectDto[] | undefined;
    isCivilSuitFiled?: boolean | undefined;
    civilSuits?: AppCivilSuitInfoDto[] | undefined;
    isInsuranceExists?: boolean | undefined;
    insurances?: AppInsuranceInfoDto[] | undefined;
    victimHasEmployers?: boolean | undefined;
    victimEmployments?: AppEmploymentDto[] | undefined;
    isThereAnyDependents?: boolean | undefined;
    dependents?: AppDependentDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationSubmittedDateTime = _data["applicationSubmittedDateTime"] ? moment(_data["applicationSubmittedDateTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["claimants"])) {
                this.claimants = [] as any;
                for (let item of _data["claimants"])
                    this.claimants!.push(AppClaimantDto.fromJS(item));
            }
            this.crimeVictimInfo = _data["crimeVictimInfo"] ? AppCrimeVictimDto.fromJS(_data["crimeVictimInfo"]) : <any>undefined;
            this.expencesInfo = _data["expencesInfo"] ? AppExpencesInfoDto.fromJS(_data["expencesInfo"]) : <any>undefined;
            this.crimeInfo = _data["crimeInfo"] ? AppCrimeInfoDto.fromJS(_data["crimeInfo"]) : <any>undefined;
            this.howYouFindInfo = _data["howYouFindInfo"] ? AppHowYouFindInfoDto.fromJS(_data["howYouFindInfo"]) : <any>undefined;
            this.fedReportingInfo = _data["fedReportingInfo"] ? AppFedReportingInfoDto.fromJS(_data["fedReportingInfo"]) : <any>undefined;
            this.victimUnableToWorkDueToCrime = _data["victimUnableToWorkDueToCrime"];
            if (Array.isArray(_data["contactPersons"])) {
                this.contactPersons = [] as any;
                for (let item of _data["contactPersons"])
                    this.contactPersons!.push(AppContactPersonDto.fromJS(item));
            }
            this.isSuspectKnown = _data["isSuspectKnown"];
            if (Array.isArray(_data["suspects"])) {
                this.suspects = [] as any;
                for (let item of _data["suspects"])
                    this.suspects!.push(AppSuspectDto.fromJS(item));
            }
            this.isCivilSuitFiled = _data["isCivilSuitFiled"];
            if (Array.isArray(_data["civilSuits"])) {
                this.civilSuits = [] as any;
                for (let item of _data["civilSuits"])
                    this.civilSuits!.push(AppCivilSuitInfoDto.fromJS(item));
            }
            this.isInsuranceExists = _data["isInsuranceExists"];
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances!.push(AppInsuranceInfoDto.fromJS(item));
            }
            this.victimHasEmployers = _data["victimHasEmployers"];
            if (Array.isArray(_data["victimEmployments"])) {
                this.victimEmployments = [] as any;
                for (let item of _data["victimEmployments"])
                    this.victimEmployments!.push(AppEmploymentDto.fromJS(item));
            }
            this.isThereAnyDependents = _data["isThereAnyDependents"];
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(AppDependentDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationSubmittedDateTime"] = this.applicationSubmittedDateTime ? this.applicationSubmittedDateTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.claimants)) {
            data["claimants"] = [];
            for (let item of this.claimants)
                data["claimants"].push(item.toJSON());
        }
        data["crimeVictimInfo"] = this.crimeVictimInfo ? this.crimeVictimInfo.toJSON() : <any>undefined;
        data["expencesInfo"] = this.expencesInfo ? this.expencesInfo.toJSON() : <any>undefined;
        data["crimeInfo"] = this.crimeInfo ? this.crimeInfo.toJSON() : <any>undefined;
        data["howYouFindInfo"] = this.howYouFindInfo ? this.howYouFindInfo.toJSON() : <any>undefined;
        data["fedReportingInfo"] = this.fedReportingInfo ? this.fedReportingInfo.toJSON() : <any>undefined;
        data["victimUnableToWorkDueToCrime"] = this.victimUnableToWorkDueToCrime;
        if (Array.isArray(this.contactPersons)) {
            data["contactPersons"] = [];
            for (let item of this.contactPersons)
                data["contactPersons"].push(item.toJSON());
        }
        data["isSuspectKnown"] = this.isSuspectKnown;
        if (Array.isArray(this.suspects)) {
            data["suspects"] = [];
            for (let item of this.suspects)
                data["suspects"].push(item.toJSON());
        }
        data["isCivilSuitFiled"] = this.isCivilSuitFiled;
        if (Array.isArray(this.civilSuits)) {
            data["civilSuits"] = [];
            for (let item of this.civilSuits)
                data["civilSuits"].push(item.toJSON());
        }
        data["isInsuranceExists"] = this.isInsuranceExists;
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item.toJSON());
        }
        data["victimHasEmployers"] = this.victimHasEmployers;
        if (Array.isArray(this.victimEmployments)) {
            data["victimEmployments"] = [];
            for (let item of this.victimEmployments)
                data["victimEmployments"].push(item.toJSON());
        }
        data["isThereAnyDependents"] = this.isThereAnyDependents;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicationDto {
    applicationSubmittedDateTime?: moment.Moment | undefined;
    creationTime?: moment.Moment | undefined;
    claimants?: AppClaimantDto[] | undefined;
    crimeVictimInfo?: AppCrimeVictimDto | undefined;
    expencesInfo?: AppExpencesInfoDto | undefined;
    crimeInfo?: AppCrimeInfoDto | undefined;
    howYouFindInfo?: AppHowYouFindInfoDto | undefined;
    fedReportingInfo?: AppFedReportingInfoDto | undefined;
    victimUnableToWorkDueToCrime?: boolean | undefined;
    contactPersons?: AppContactPersonDto[] | undefined;
    isSuspectKnown?: boolean | undefined;
    suspects?: AppSuspectDto[] | undefined;
    isCivilSuitFiled?: boolean | undefined;
    civilSuits?: AppCivilSuitInfoDto[] | undefined;
    isInsuranceExists?: boolean | undefined;
    insurances?: AppInsuranceInfoDto[] | undefined;
    victimHasEmployers?: boolean | undefined;
    victimEmployments?: AppEmploymentDto[] | undefined;
    isThereAnyDependents?: boolean | undefined;
    dependents?: AppDependentDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum SubmissionStatus {
    Draft = 0,
    Submitted = 1,
    InProcess = 2,
    Approved = 3,
    Denied = 4,
    Completed = 5,
}

export enum WorkItemState {
    Draft = 0,
    InProcess = 1,
    Completed = 1024,
}

export class VcSubmissionDtoOfApplicationDto implements IVcSubmissionDtoOfApplicationDto {
    creationTime?: moment.Moment | undefined;
    vcClaimId?: number | undefined;
    claimNumber?: string | undefined;
    note?: string | undefined;
    submissionIdText?: string | undefined;
    vcSubmissionType?: VcSubmissionType | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: ApplicationDto | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: SubmissionStatus[] | undefined;
    id?: number | undefined;

    constructor(data?: IVcSubmissionDtoOfApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.vcClaimId = _data["vcClaimId"];
            this.claimNumber = _data["claimNumber"];
            this.note = _data["note"];
            this.submissionIdText = _data["submissionIdText"];
            this.vcSubmissionType = _data["vcSubmissionType"];
            this.submittedDate = _data["submittedDate"] ? moment(_data["submittedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.submissionPdfId = _data["submissionPdfId"];
            this.submissionData = _data["submissionData"] ? ApplicationDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.workItemStatus = _data["workItemStatus"];
            this.workItemStatusDate = _data["workItemStatusDate"] ? moment(_data["workItemStatusDate"].toString()) : <any>undefined;
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.workItemState = _data["workItemState"];
            this.workItemStateDate = _data["workItemStateDate"] ? moment(_data["workItemStateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["validWorkItemStatuses"])) {
                this.validWorkItemStatuses = [] as any;
                for (let item of _data["validWorkItemStatuses"])
                    this.validWorkItemStatuses!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VcSubmissionDtoOfApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcSubmissionDtoOfApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["vcClaimId"] = this.vcClaimId;
        data["claimNumber"] = this.claimNumber;
        data["note"] = this.note;
        data["submissionIdText"] = this.submissionIdText;
        data["vcSubmissionType"] = this.vcSubmissionType;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["submissionPdfId"] = this.submissionPdfId;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemStatusDate"] = this.workItemStatusDate ? this.workItemStatusDate.toISOString() : <any>undefined;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["workItemState"] = this.workItemState;
        data["workItemStateDate"] = this.workItemStateDate ? this.workItemStateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.validWorkItemStatuses)) {
            data["validWorkItemStatuses"] = [];
            for (let item of this.validWorkItemStatuses)
                data["validWorkItemStatuses"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IVcSubmissionDtoOfApplicationDto {
    creationTime?: moment.Moment | undefined;
    vcClaimId?: number | undefined;
    claimNumber?: string | undefined;
    note?: string | undefined;
    submissionIdText?: string | undefined;
    vcSubmissionType?: VcSubmissionType | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: ApplicationDto | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: SubmissionStatus[] | undefined;
    id?: number | undefined;
}

export class DiscardApplicationSubmissionInputDto implements IDiscardApplicationSubmissionInputDto {
    submissionId?: number | undefined;
    discardReason?: string | undefined;

    constructor(data?: IDiscardApplicationSubmissionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.discardReason = _data["discardReason"];
        }
    }

    static fromJS(data: any): DiscardApplicationSubmissionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscardApplicationSubmissionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["discardReason"] = this.discardReason;
        return data; 
    }
}

export interface IDiscardApplicationSubmissionInputDto {
    submissionId?: number | undefined;
    discardReason?: string | undefined;
}

export class SubmitApplicationDto implements ISubmitApplicationDto {
    submission?: VcSubmissionDtoOfApplicationDto | undefined;
    application?: ApplicationDto | undefined;
    section12SignedText?: string | undefined;
    section12SignedDate?: moment.Moment | undefined;
    section12SignatureImage?: string | undefined;
    section12PrintedName?: string | undefined;
    section13SignedText?: string | undefined;
    section13SignedDate?: moment.Moment | undefined;
    section13SignatureImage?: string | undefined;
    section13PrintedName?: string | undefined;
    section13aSignedText?: string | undefined;
    section13aSignedDate?: moment.Moment | undefined;
    section13aSignatureImage?: string | undefined;
    section13aPrintedName?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: ISubmitApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submission = _data["submission"] ? VcSubmissionDtoOfApplicationDto.fromJS(_data["submission"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.section12SignedText = _data["section12SignedText"];
            this.section12SignedDate = _data["section12SignedDate"] ? moment(_data["section12SignedDate"].toString()) : <any>undefined;
            this.section12SignatureImage = _data["section12SignatureImage"];
            this.section12PrintedName = _data["section12PrintedName"];
            this.section13SignedText = _data["section13SignedText"];
            this.section13SignedDate = _data["section13SignedDate"] ? moment(_data["section13SignedDate"].toString()) : <any>undefined;
            this.section13SignatureImage = _data["section13SignatureImage"];
            this.section13PrintedName = _data["section13PrintedName"];
            this.section13aSignedText = _data["section13aSignedText"];
            this.section13aSignedDate = _data["section13aSignedDate"] ? moment(_data["section13aSignedDate"].toString()) : <any>undefined;
            this.section13aSignatureImage = _data["section13aSignatureImage"];
            this.section13aPrintedName = _data["section13aPrintedName"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): SubmitApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submission"] = this.submission ? this.submission.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["section12SignedText"] = this.section12SignedText;
        data["section12SignedDate"] = this.section12SignedDate ? this.section12SignedDate.toISOString() : <any>undefined;
        data["section12SignatureImage"] = this.section12SignatureImage;
        data["section12PrintedName"] = this.section12PrintedName;
        data["section13SignedText"] = this.section13SignedText;
        data["section13SignedDate"] = this.section13SignedDate ? this.section13SignedDate.toISOString() : <any>undefined;
        data["section13SignatureImage"] = this.section13SignatureImage;
        data["section13PrintedName"] = this.section13PrintedName;
        data["section13aSignedText"] = this.section13aSignedText;
        data["section13aSignedDate"] = this.section13aSignedDate ? this.section13aSignedDate.toISOString() : <any>undefined;
        data["section13aSignatureImage"] = this.section13aSignatureImage;
        data["section13aPrintedName"] = this.section13aPrintedName;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface ISubmitApplicationDto {
    submission?: VcSubmissionDtoOfApplicationDto | undefined;
    application?: ApplicationDto | undefined;
    section12SignedText?: string | undefined;
    section12SignedDate?: moment.Moment | undefined;
    section12SignatureImage?: string | undefined;
    section12PrintedName?: string | undefined;
    section13SignedText?: string | undefined;
    section13SignedDate?: moment.Moment | undefined;
    section13SignatureImage?: string | undefined;
    section13PrintedName?: string | undefined;
    section13aSignedText?: string | undefined;
    section13aSignedDate?: moment.Moment | undefined;
    section13aSignatureImage?: string | undefined;
    section13aPrintedName?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum ClaimStatus {
    Draft = 0,
    HoldingInHouse = 4,
    Awarded = 5,
    PendingAtDa = 6,
    PendingAtBoard = 7,
    Appeal = 8,
    Rescind = 9,
    Denied = 10,
    Continued = 11,
    Withdrawn = 14,
}

export class SubmitApplicationOutputDto implements ISubmitApplicationOutputDto {
    claimNumber?: string | undefined;
    status?: ClaimStatus | undefined;
    statusDate?: moment.Moment | undefined;
    assignedCountyName?: string | undefined;
    applicationSubmittedDateTime?: moment.Moment | undefined;

    constructor(data?: ISubmitApplicationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.status = _data["status"];
            this.statusDate = _data["statusDate"] ? moment(_data["statusDate"].toString()) : <any>undefined;
            this.assignedCountyName = _data["assignedCountyName"];
            this.applicationSubmittedDateTime = _data["applicationSubmittedDateTime"] ? moment(_data["applicationSubmittedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitApplicationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitApplicationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["status"] = this.status;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["assignedCountyName"] = this.assignedCountyName;
        data["applicationSubmittedDateTime"] = this.applicationSubmittedDateTime ? this.applicationSubmittedDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISubmitApplicationOutputDto {
    claimNumber?: string | undefined;
    status?: ClaimStatus | undefined;
    statusDate?: moment.Moment | undefined;
    assignedCountyName?: string | undefined;
    applicationSubmittedDateTime?: moment.Moment | undefined;
}

export class ClaimCrimeVictimDto implements IClaimCrimeVictimDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    ageAtCrimeTime?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IClaimCrimeVictimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.ageAtCrimeTime = _data["ageAtCrimeTime"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ClaimCrimeVictimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimCrimeVictimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["ageAtCrimeTime"] = this.ageAtCrimeTime;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IClaimCrimeVictimDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    ageAtCrimeTime?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ClaimClaimantDto implements IClaimClaimantDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    relationshipToVictim?: ClaimantRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IClaimClaimantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.relationshipToVictim = _data["relationshipToVictim"];
            this.relationshipOther = _data["relationshipOther"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ClaimClaimantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimClaimantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["relationshipToVictim"] = this.relationshipToVictim;
        data["relationshipOther"] = this.relationshipOther;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IClaimClaimantDto {
    prefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: Gender | undefined;
    relationshipToVictim?: ClaimantRelationshipToVictim | undefined;
    relationshipOther?: string | undefined;
    ssn?: string | undefined;
    dob?: moment.Moment | undefined;
    address?: EzAddress | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ClaimCrimeInfoDto implements IClaimCrimeInfoDto {
    dateOfCrime?: moment.Moment | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeCounty?: OKCounty | undefined;

    constructor(data?: IClaimCrimeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfCrime = _data["dateOfCrime"] ? moment(_data["dateOfCrime"].toString()) : <any>undefined;
            this.crimeType = _data["crimeType"] ? CrimeTypeDto.fromJS(_data["crimeType"]) : <any>undefined;
            this.crimeCounty = _data["crimeCounty"];
        }
    }

    static fromJS(data: any): ClaimCrimeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimCrimeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfCrime"] = this.dateOfCrime ? this.dateOfCrime.toISOString() : <any>undefined;
        data["crimeType"] = this.crimeType ? this.crimeType.toJSON() : <any>undefined;
        data["crimeCounty"] = this.crimeCounty;
        return data; 
    }
}

export interface IClaimCrimeInfoDto {
    dateOfCrime?: moment.Moment | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeCounty?: OKCounty | undefined;
}

export class ClaimDataDto implements IClaimDataDto {
    crimeVictimInfo?: ClaimCrimeVictimDto | undefined;
    claimants?: ClaimClaimantDto[] | undefined;
    crimeInfo?: ClaimCrimeInfoDto | undefined;
    fedReportingInfo?: AppFedReportingInfoDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IClaimDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crimeVictimInfo = _data["crimeVictimInfo"] ? ClaimCrimeVictimDto.fromJS(_data["crimeVictimInfo"]) : <any>undefined;
            if (Array.isArray(_data["claimants"])) {
                this.claimants = [] as any;
                for (let item of _data["claimants"])
                    this.claimants!.push(ClaimClaimantDto.fromJS(item));
            }
            this.crimeInfo = _data["crimeInfo"] ? ClaimCrimeInfoDto.fromJS(_data["crimeInfo"]) : <any>undefined;
            this.fedReportingInfo = _data["fedReportingInfo"] ? AppFedReportingInfoDto.fromJS(_data["fedReportingInfo"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ClaimDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crimeVictimInfo"] = this.crimeVictimInfo ? this.crimeVictimInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.claimants)) {
            data["claimants"] = [];
            for (let item of this.claimants)
                data["claimants"].push(item.toJSON());
        }
        data["crimeInfo"] = this.crimeInfo ? this.crimeInfo.toJSON() : <any>undefined;
        data["fedReportingInfo"] = this.fedReportingInfo ? this.fedReportingInfo.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IClaimDataDto {
    crimeVictimInfo?: ClaimCrimeVictimDto | undefined;
    claimants?: ClaimClaimantDto[] | undefined;
    crimeInfo?: ClaimCrimeInfoDto | undefined;
    fedReportingInfo?: AppFedReportingInfoDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class UserSumDto implements IUserSumDto {
    id?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    userCategory?: UserCategory | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUserSumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.userCategory = _data["userCategory"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserSumDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["userCategory"] = this.userCategory;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IUserSumDto {
    id?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    userCategory?: UserCategory | undefined;
    phoneNumber?: string | undefined;
}

export class VcClaimDto implements IVcClaimDto {
    claimNumber?: string | undefined;
    applicationPdfId?: string | undefined;
    assignedCountyName?: string | undefined;
    isApplicationSubmitted?: boolean | undefined;
    applicationSubmittedDateTime?: moment.Moment | undefined;
    victimLastName?: string | undefined;
    claimData?: ClaimDataDto | undefined;
    claimDataLastUpdatedDate?: moment.Moment | undefined;
    user?: UserSumDto | undefined;
    workItemPulbicStatusDate?: moment.Moment | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: ClaimStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: ClaimStatus[] | undefined;
    id?: number | undefined;

    constructor(data?: IVcClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.applicationPdfId = _data["applicationPdfId"];
            this.assignedCountyName = _data["assignedCountyName"];
            this.isApplicationSubmitted = _data["isApplicationSubmitted"];
            this.applicationSubmittedDateTime = _data["applicationSubmittedDateTime"] ? moment(_data["applicationSubmittedDateTime"].toString()) : <any>undefined;
            this.victimLastName = _data["victimLastName"];
            this.claimData = _data["claimData"] ? ClaimDataDto.fromJS(_data["claimData"]) : <any>undefined;
            this.claimDataLastUpdatedDate = _data["claimDataLastUpdatedDate"] ? moment(_data["claimDataLastUpdatedDate"].toString()) : <any>undefined;
            this.user = _data["user"] ? UserSumDto.fromJS(_data["user"]) : <any>undefined;
            this.workItemPulbicStatusDate = _data["workItemPulbicStatusDate"] ? moment(_data["workItemPulbicStatusDate"].toString()) : <any>undefined;
            this.workItemStatus = _data["workItemStatus"];
            this.workItemStatusDate = _data["workItemStatusDate"] ? moment(_data["workItemStatusDate"].toString()) : <any>undefined;
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.workItemState = _data["workItemState"];
            this.workItemStateDate = _data["workItemStateDate"] ? moment(_data["workItemStateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["validWorkItemStatuses"])) {
                this.validWorkItemStatuses = [] as any;
                for (let item of _data["validWorkItemStatuses"])
                    this.validWorkItemStatuses!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VcClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["applicationPdfId"] = this.applicationPdfId;
        data["assignedCountyName"] = this.assignedCountyName;
        data["isApplicationSubmitted"] = this.isApplicationSubmitted;
        data["applicationSubmittedDateTime"] = this.applicationSubmittedDateTime ? this.applicationSubmittedDateTime.toISOString() : <any>undefined;
        data["victimLastName"] = this.victimLastName;
        data["claimData"] = this.claimData ? this.claimData.toJSON() : <any>undefined;
        data["claimDataLastUpdatedDate"] = this.claimDataLastUpdatedDate ? this.claimDataLastUpdatedDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["workItemPulbicStatusDate"] = this.workItemPulbicStatusDate ? this.workItemPulbicStatusDate.toISOString() : <any>undefined;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemStatusDate"] = this.workItemStatusDate ? this.workItemStatusDate.toISOString() : <any>undefined;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["workItemState"] = this.workItemState;
        data["workItemStateDate"] = this.workItemStateDate ? this.workItemStateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.validWorkItemStatuses)) {
            data["validWorkItemStatuses"] = [];
            for (let item of this.validWorkItemStatuses)
                data["validWorkItemStatuses"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IVcClaimDto {
    claimNumber?: string | undefined;
    applicationPdfId?: string | undefined;
    assignedCountyName?: string | undefined;
    isApplicationSubmitted?: boolean | undefined;
    applicationSubmittedDateTime?: moment.Moment | undefined;
    victimLastName?: string | undefined;
    claimData?: ClaimDataDto | undefined;
    claimDataLastUpdatedDate?: moment.Moment | undefined;
    user?: UserSumDto | undefined;
    workItemPulbicStatusDate?: moment.Moment | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: ClaimStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: ClaimStatus[] | undefined;
    id?: number | undefined;
}

export enum ClaimSections {
    VictimInformation = 1,
    VictimRace = 2,
    ClaimantInformation = 3,
    ContactInformation = 4,
    CrimeInformation = 5,
    ClaimedExpenses = 6,
    InsuranceInformation = 7,
    CivilSuitInformation = 8,
    VictimEmploymentInformation = 9,
    VictimDependent = 10,
    SuspectInformation = 11,
}

export class VcClaimChangeDto implements IVcClaimChangeDto {
    newInformation?: string | undefined;
    claimSection?: ClaimSections | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcClaimChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newInformation = _data["newInformation"];
            this.claimSection = _data["claimSection"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcClaimChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newInformation"] = this.newInformation;
        data["claimSection"] = this.claimSection;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcClaimChangeDto {
    newInformation?: string | undefined;
    claimSection?: ClaimSections | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class VcClaimUpdateRequestDto implements IVcClaimUpdateRequestDto {
    vcSubmissionNumber?: string | undefined;
    vcClaimNumber?: string | undefined;
    vcClaimChangeList?: VcClaimChangeDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcClaimUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcSubmissionNumber = _data["vcSubmissionNumber"];
            this.vcClaimNumber = _data["vcClaimNumber"];
            if (Array.isArray(_data["vcClaimChangeList"])) {
                this.vcClaimChangeList = [] as any;
                for (let item of _data["vcClaimChangeList"])
                    this.vcClaimChangeList!.push(VcClaimChangeDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcClaimUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcSubmissionNumber"] = this.vcSubmissionNumber;
        data["vcClaimNumber"] = this.vcClaimNumber;
        if (Array.isArray(this.vcClaimChangeList)) {
            data["vcClaimChangeList"] = [];
            for (let item of this.vcClaimChangeList)
                data["vcClaimChangeList"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcClaimUpdateRequestDto {
    vcSubmissionNumber?: string | undefined;
    vcClaimNumber?: string | undefined;
    vcClaimChangeList?: VcClaimChangeDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class VcSubmissionDtoOfVcClaimUpdateRequestDto implements IVcSubmissionDtoOfVcClaimUpdateRequestDto {
    creationTime?: moment.Moment | undefined;
    vcClaimId?: number | undefined;
    claimNumber?: string | undefined;
    note?: string | undefined;
    submissionIdText?: string | undefined;
    vcSubmissionType?: VcSubmissionType | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: VcClaimUpdateRequestDto | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: SubmissionStatus[] | undefined;
    id?: number | undefined;

    constructor(data?: IVcSubmissionDtoOfVcClaimUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.vcClaimId = _data["vcClaimId"];
            this.claimNumber = _data["claimNumber"];
            this.note = _data["note"];
            this.submissionIdText = _data["submissionIdText"];
            this.vcSubmissionType = _data["vcSubmissionType"];
            this.submittedDate = _data["submittedDate"] ? moment(_data["submittedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.submissionPdfId = _data["submissionPdfId"];
            this.submissionData = _data["submissionData"] ? VcClaimUpdateRequestDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.workItemStatus = _data["workItemStatus"];
            this.workItemStatusDate = _data["workItemStatusDate"] ? moment(_data["workItemStatusDate"].toString()) : <any>undefined;
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.workItemState = _data["workItemState"];
            this.workItemStateDate = _data["workItemStateDate"] ? moment(_data["workItemStateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["validWorkItemStatuses"])) {
                this.validWorkItemStatuses = [] as any;
                for (let item of _data["validWorkItemStatuses"])
                    this.validWorkItemStatuses!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VcSubmissionDtoOfVcClaimUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcSubmissionDtoOfVcClaimUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["vcClaimId"] = this.vcClaimId;
        data["claimNumber"] = this.claimNumber;
        data["note"] = this.note;
        data["submissionIdText"] = this.submissionIdText;
        data["vcSubmissionType"] = this.vcSubmissionType;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["submissionPdfId"] = this.submissionPdfId;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemStatusDate"] = this.workItemStatusDate ? this.workItemStatusDate.toISOString() : <any>undefined;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["workItemState"] = this.workItemState;
        data["workItemStateDate"] = this.workItemStateDate ? this.workItemStateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.validWorkItemStatuses)) {
            data["validWorkItemStatuses"] = [];
            for (let item of this.validWorkItemStatuses)
                data["validWorkItemStatuses"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IVcSubmissionDtoOfVcClaimUpdateRequestDto {
    creationTime?: moment.Moment | undefined;
    vcClaimId?: number | undefined;
    claimNumber?: string | undefined;
    note?: string | undefined;
    submissionIdText?: string | undefined;
    vcSubmissionType?: VcSubmissionType | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: VcClaimUpdateRequestDto | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    validWorkItemStatuses?: SubmissionStatus[] | undefined;
    id?: number | undefined;
}

export enum UserSubmissionType {
    PersonalInfoChange = 1,
    ApplicantContactChange = 2,
    ClaimAccessRequest = 3,
}

export enum OnlineUserAssociationToClaimEnum {
    Applicant = 1,
    Victim = 2,
    Claimant = 3,
    Contact = 4,
}

export class VcClaimAccessRequestDto implements IVcClaimAccessRequestDto {
    vcClaimNumber?: string | undefined;
    onlineUserAssociationToClaim?: OnlineUserAssociationToClaimEnum | undefined;
    reasonText?: string | undefined;
    contactPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    personalInfo?: PersonalInfoDto | undefined;
    mailingAddress?: AddressInputDto | undefined;
    contactInfo?: EzContactInfo | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcClaimAccessRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcClaimNumber = _data["vcClaimNumber"];
            this.onlineUserAssociationToClaim = _data["onlineUserAssociationToClaim"];
            this.reasonText = _data["reasonText"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.personalInfo = _data["personalInfo"] ? PersonalInfoDto.fromJS(_data["personalInfo"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? AddressInputDto.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.contactInfo = _data["contactInfo"] ? EzContactInfo.fromJS(_data["contactInfo"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcClaimAccessRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimAccessRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcClaimNumber"] = this.vcClaimNumber;
        data["onlineUserAssociationToClaim"] = this.onlineUserAssociationToClaim;
        data["reasonText"] = this.reasonText;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcClaimAccessRequestDto {
    vcClaimNumber?: string | undefined;
    onlineUserAssociationToClaim?: OnlineUserAssociationToClaimEnum | undefined;
    reasonText?: string | undefined;
    contactPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    personalInfo?: PersonalInfoDto | undefined;
    mailingAddress?: AddressInputDto | undefined;
    contactInfo?: EzContactInfo | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class UserSubmissionDtoOfVcClaimAccessRequestDto implements IUserSubmissionDtoOfVcClaimAccessRequestDto {
    creationTime?: moment.Moment | undefined;
    userId?: number | undefined;
    note?: string | undefined;
    responseNote?: string | undefined;
    submissionIdText?: string | undefined;
    submissionType?: UserSubmissionType | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: VcClaimAccessRequestDto | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    id?: number | undefined;

    constructor(data?: IUserSubmissionDtoOfVcClaimAccessRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.note = _data["note"];
            this.responseNote = _data["responseNote"];
            this.submissionIdText = _data["submissionIdText"];
            this.submissionType = _data["submissionType"];
            this.workItemStatus = _data["workItemStatus"];
            this.workItemStatusDate = _data["workItemStatusDate"] ? moment(_data["workItemStatusDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? moment(_data["submittedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.submissionPdfId = _data["submissionPdfId"];
            this.submissionData = _data["submissionData"] ? VcClaimAccessRequestDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.workItemState = _data["workItemState"];
            this.workItemStateDate = _data["workItemStateDate"] ? moment(_data["workItemStateDate"].toString()) : <any>undefined;
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserSubmissionDtoOfVcClaimAccessRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubmissionDtoOfVcClaimAccessRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["note"] = this.note;
        data["responseNote"] = this.responseNote;
        data["submissionIdText"] = this.submissionIdText;
        data["submissionType"] = this.submissionType;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemStatusDate"] = this.workItemStatusDate ? this.workItemStatusDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["submissionPdfId"] = this.submissionPdfId;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["workItemState"] = this.workItemState;
        data["workItemStateDate"] = this.workItemStateDate ? this.workItemStateDate.toISOString() : <any>undefined;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserSubmissionDtoOfVcClaimAccessRequestDto {
    creationTime?: moment.Moment | undefined;
    userId?: number | undefined;
    note?: string | undefined;
    responseNote?: string | undefined;
    submissionIdText?: string | undefined;
    submissionType?: UserSubmissionType | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    submittedDate?: moment.Moment | undefined;
    attachments?: AttachmentDto[] | undefined;
    submissionPdfId?: string | undefined;
    submissionData?: VcClaimAccessRequestDto | undefined;
    workItemState?: WorkItemState | undefined;
    workItemStateDate?: moment.Moment | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    id?: number | undefined;
}

export class VcReplyToClaimMessageInputDto implements IVcReplyToClaimMessageInputDto {
    vcClaimMessageId?: number | undefined;
    applicantNote?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcReplyToClaimMessageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcClaimMessageId = _data["vcClaimMessageId"];
            this.applicantNote = _data["applicantNote"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcReplyToClaimMessageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcReplyToClaimMessageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcClaimMessageId"] = this.vcClaimMessageId;
        data["applicantNote"] = this.applicantNote;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcReplyToClaimMessageInputDto {
    vcClaimMessageId?: number | undefined;
    applicantNote?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class VcClaimMessageDto implements IVcClaimMessageDto {
    id?: number | undefined;
    creationTime?: moment.Moment | undefined;
    createdByStaffUserName?: string | undefined;
    staffNote?: string | undefined;
    applicantNote?: string | undefined;
    applicantResponseDate?: moment.Moment | undefined;
    messageProcessedByStaffUser?: boolean | undefined;
    processedByStaffUserName?: string | undefined;
    processedByStaffUserDate?: moment.Moment | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcClaimMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.createdByStaffUserName = _data["createdByStaffUserName"];
            this.staffNote = _data["staffNote"];
            this.applicantNote = _data["applicantNote"];
            this.applicantResponseDate = _data["applicantResponseDate"] ? moment(_data["applicantResponseDate"].toString()) : <any>undefined;
            this.messageProcessedByStaffUser = _data["messageProcessedByStaffUser"];
            this.processedByStaffUserName = _data["processedByStaffUserName"];
            this.processedByStaffUserDate = _data["processedByStaffUserDate"] ? moment(_data["processedByStaffUserDate"].toString()) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcClaimMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["createdByStaffUserName"] = this.createdByStaffUserName;
        data["staffNote"] = this.staffNote;
        data["applicantNote"] = this.applicantNote;
        data["applicantResponseDate"] = this.applicantResponseDate ? this.applicantResponseDate.toISOString() : <any>undefined;
        data["messageProcessedByStaffUser"] = this.messageProcessedByStaffUser;
        data["processedByStaffUserName"] = this.processedByStaffUserName;
        data["processedByStaffUserDate"] = this.processedByStaffUserDate ? this.processedByStaffUserDate.toISOString() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcClaimMessageDto {
    id?: number | undefined;
    creationTime?: moment.Moment | undefined;
    createdByStaffUserName?: string | undefined;
    staffNote?: string | undefined;
    applicantNote?: string | undefined;
    applicantResponseDate?: moment.Moment | undefined;
    messageProcessedByStaffUser?: boolean | undefined;
    processedByStaffUserName?: string | undefined;
    processedByStaffUserDate?: moment.Moment | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export enum EntityTypeEnum {
    UserSubmission = 1,
    VcSubmission = 2,
}

export class UploadAttachmentInputDto implements IUploadAttachmentInputDto {
    mimeType!: string;
    fileName?: string | undefined;
    fileContent?: string | undefined;
    submissionId!: number;
    submissionType?: EntityTypeEnum | undefined;

    constructor(data?: IUploadAttachmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.submissionId = _data["submissionId"];
            this.submissionType = _data["submissionType"];
        }
    }

    static fromJS(data: any): UploadAttachmentInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAttachmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["submissionId"] = this.submissionId;
        data["submissionType"] = this.submissionType;
        return data; 
    }
}

export interface IUploadAttachmentInputDto {
    mimeType: string;
    fileName?: string | undefined;
    fileContent?: string | undefined;
    submissionId: number;
    submissionType?: EntityTypeEnum | undefined;
}

export class VcClaimSummaryLightDto implements IVcClaimSummaryLightDto {
    workItemPublicStatus?: ClaimStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    createdDate?: moment.Moment | undefined;
    claimNumber?: string | undefined;
    claimDataLastUpdatedDate?: moment.Moment | undefined;
    dateOfCrime?: moment.Moment | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    assignedCountyName?: string | undefined;
    assignedDistrictOfficeName?: string | undefined;
    assignedDistrictOfficePhone?: string | undefined;

    constructor(data?: IVcClaimSummaryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.workItemStatus = _data["workItemStatus"];
            this.workItemStatusDate = _data["workItemStatusDate"] ? moment(_data["workItemStatusDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.claimNumber = _data["claimNumber"];
            this.claimDataLastUpdatedDate = _data["claimDataLastUpdatedDate"] ? moment(_data["claimDataLastUpdatedDate"].toString()) : <any>undefined;
            this.dateOfCrime = _data["dateOfCrime"] ? moment(_data["dateOfCrime"].toString()) : <any>undefined;
            this.claimantFirstName = _data["claimantFirstName"];
            this.claimantLastName = _data["claimantLastName"];
            this.victimFirstName = _data["victimFirstName"];
            this.victimLastName = _data["victimLastName"];
            this.assignedCountyName = _data["assignedCountyName"];
            this.assignedDistrictOfficeName = _data["assignedDistrictOfficeName"];
            this.assignedDistrictOfficePhone = _data["assignedDistrictOfficePhone"];
        }
    }

    static fromJS(data: any): VcClaimSummaryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimSummaryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemStatusDate"] = this.workItemStatusDate ? this.workItemStatusDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["claimNumber"] = this.claimNumber;
        data["claimDataLastUpdatedDate"] = this.claimDataLastUpdatedDate ? this.claimDataLastUpdatedDate.toISOString() : <any>undefined;
        data["dateOfCrime"] = this.dateOfCrime ? this.dateOfCrime.toISOString() : <any>undefined;
        data["claimantFirstName"] = this.claimantFirstName;
        data["claimantLastName"] = this.claimantLastName;
        data["victimFirstName"] = this.victimFirstName;
        data["victimLastName"] = this.victimLastName;
        data["assignedCountyName"] = this.assignedCountyName;
        data["assignedDistrictOfficeName"] = this.assignedDistrictOfficeName;
        data["assignedDistrictOfficePhone"] = this.assignedDistrictOfficePhone;
        return data; 
    }
}

export interface IVcClaimSummaryLightDto {
    workItemPublicStatus?: ClaimStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemStatusDate?: moment.Moment | undefined;
    createdDate?: moment.Moment | undefined;
    claimNumber?: string | undefined;
    claimDataLastUpdatedDate?: moment.Moment | undefined;
    dateOfCrime?: moment.Moment | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    assignedCountyName?: string | undefined;
    assignedDistrictOfficeName?: string | undefined;
    assignedDistrictOfficePhone?: string | undefined;
}

export enum VocApplicationStatus {
    Draft = 0,
    Received = 1,
    LinkedToVocCase = 2,
    MarkAsNotValid = 3,
}

export class VcApplicationSummaryLightDto implements IVcApplicationSummaryLightDto {
    submissionId?: number | undefined;
    vcClaimId?: number | undefined;
    appType?: string | undefined;
    appStatus?: VocApplicationStatus | undefined;
    appStatusDate?: moment.Moment | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeDate?: moment.Moment | undefined;

    constructor(data?: IVcApplicationSummaryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.vcClaimId = _data["vcClaimId"];
            this.appType = _data["appType"];
            this.appStatus = _data["appStatus"];
            this.appStatusDate = _data["appStatusDate"] ? moment(_data["appStatusDate"].toString()) : <any>undefined;
            this.victimFirstName = _data["victimFirstName"];
            this.victimLastName = _data["victimLastName"];
            this.claimantFirstName = _data["claimantFirstName"];
            this.claimantLastName = _data["claimantLastName"];
            this.crimeType = _data["crimeType"] ? CrimeTypeDto.fromJS(_data["crimeType"]) : <any>undefined;
            this.crimeDate = _data["crimeDate"] ? moment(_data["crimeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VcApplicationSummaryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcApplicationSummaryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["vcClaimId"] = this.vcClaimId;
        data["appType"] = this.appType;
        data["appStatus"] = this.appStatus;
        data["appStatusDate"] = this.appStatusDate ? this.appStatusDate.toISOString() : <any>undefined;
        data["victimFirstName"] = this.victimFirstName;
        data["victimLastName"] = this.victimLastName;
        data["claimantFirstName"] = this.claimantFirstName;
        data["claimantLastName"] = this.claimantLastName;
        data["crimeType"] = this.crimeType ? this.crimeType.toJSON() : <any>undefined;
        data["crimeDate"] = this.crimeDate ? this.crimeDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IVcApplicationSummaryLightDto {
    submissionId?: number | undefined;
    vcClaimId?: number | undefined;
    appType?: string | undefined;
    appStatus?: VocApplicationStatus | undefined;
    appStatusDate?: moment.Moment | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    crimeType?: CrimeTypeDto | undefined;
    crimeDate?: moment.Moment | undefined;
}

export class VcClaimAccessRequestSummaryLightDto implements IVcClaimAccessRequestSummaryLightDto {
    submissionId?: number | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    createdDate?: moment.Moment | undefined;
    vcClaimNumber?: string | undefined;
    onlineUserAssociationToClaim?: OnlineUserAssociationToClaimEnum | undefined;
    reasonText?: string | undefined;
    contactPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IVcClaimAccessRequestSummaryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemPublicStatusDate = _data["workItemPublicStatusDate"] ? moment(_data["workItemPublicStatusDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.vcClaimNumber = _data["vcClaimNumber"];
            this.onlineUserAssociationToClaim = _data["onlineUserAssociationToClaim"];
            this.reasonText = _data["reasonText"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): VcClaimAccessRequestSummaryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimAccessRequestSummaryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemPublicStatusDate"] = this.workItemPublicStatusDate ? this.workItemPublicStatusDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["vcClaimNumber"] = this.vcClaimNumber;
        data["onlineUserAssociationToClaim"] = this.onlineUserAssociationToClaim;
        data["reasonText"] = this.reasonText;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IVcClaimAccessRequestSummaryLightDto {
    submissionId?: number | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemPublicStatusDate?: moment.Moment | undefined;
    createdDate?: moment.Moment | undefined;
    vcClaimNumber?: string | undefined;
    onlineUserAssociationToClaim?: OnlineUserAssociationToClaimEnum | undefined;
    reasonText?: string | undefined;
    contactPhoneNumber?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicantDashboardDto implements IApplicantDashboardDto {
    vcClaims?: VcClaimSummaryLightDto[] | undefined;
    vcApplications?: VcApplicationSummaryLightDto[] | undefined;
    claimAccessRequests?: VcClaimAccessRequestSummaryLightDto[] | undefined;

    constructor(data?: IApplicantDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vcClaims"])) {
                this.vcClaims = [] as any;
                for (let item of _data["vcClaims"])
                    this.vcClaims!.push(VcClaimSummaryLightDto.fromJS(item));
            }
            if (Array.isArray(_data["vcApplications"])) {
                this.vcApplications = [] as any;
                for (let item of _data["vcApplications"])
                    this.vcApplications!.push(VcApplicationSummaryLightDto.fromJS(item));
            }
            if (Array.isArray(_data["claimAccessRequests"])) {
                this.claimAccessRequests = [] as any;
                for (let item of _data["claimAccessRequests"])
                    this.claimAccessRequests!.push(VcClaimAccessRequestSummaryLightDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicantDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vcClaims)) {
            data["vcClaims"] = [];
            for (let item of this.vcClaims)
                data["vcClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.vcApplications)) {
            data["vcApplications"] = [];
            for (let item of this.vcApplications)
                data["vcApplications"].push(item.toJSON());
        }
        if (Array.isArray(this.claimAccessRequests)) {
            data["claimAccessRequests"] = [];
            for (let item of this.claimAccessRequests)
                data["claimAccessRequests"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApplicantDashboardDto {
    vcClaims?: VcClaimSummaryLightDto[] | undefined;
    vcApplications?: VcApplicationSummaryLightDto[] | undefined;
    claimAccessRequests?: VcClaimAccessRequestSummaryLightDto[] | undefined;
}

export class RetrieveVcClaimsByUserInput implements IRetrieveVcClaimsByUserInput {
    userId!: number;
    filter?: string | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;

    constructor(data?: IRetrieveVcClaimsByUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): RetrieveVcClaimsByUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveVcClaimsByUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface IRetrieveVcClaimsByUserInput {
    userId: number;
    filter?: string | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
}

export class SearchVcClaimInput implements ISearchVcClaimInput {
    isApplicationSubmitted?: boolean | undefined;
    victimLastName?: string | undefined;
    victimFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    assignedCountyName?: string | undefined;
    claimNumber?: string | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemState?: WorkItemState | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;

    constructor(data?: ISearchVcClaimInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApplicationSubmitted = _data["isApplicationSubmitted"];
            this.victimLastName = _data["victimLastName"];
            this.victimFirstName = _data["victimFirstName"];
            this.claimantLastName = _data["claimantLastName"];
            this.claimantFirstName = _data["claimantFirstName"];
            this.assignedCountyName = _data["assignedCountyName"];
            this.claimNumber = _data["claimNumber"];
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.workItemStatus = _data["workItemStatus"];
            this.workItemState = _data["workItemState"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchVcClaimInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVcClaimInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isApplicationSubmitted"] = this.isApplicationSubmitted;
        data["victimLastName"] = this.victimLastName;
        data["victimFirstName"] = this.victimFirstName;
        data["claimantLastName"] = this.claimantLastName;
        data["claimantFirstName"] = this.claimantFirstName;
        data["assignedCountyName"] = this.assignedCountyName;
        data["claimNumber"] = this.claimNumber;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemState"] = this.workItemState;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface ISearchVcClaimInput {
    isApplicationSubmitted?: boolean | undefined;
    victimLastName?: string | undefined;
    victimFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    assignedCountyName?: string | undefined;
    claimNumber?: string | undefined;
    workItemPublicStatus?: SubmissionStatus | undefined;
    workItemStatus?: SubmissionStatus | undefined;
    workItemState?: WorkItemState | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
}

export class PagedResultDtoOfVcClaimSummaryLightDto implements IPagedResultDtoOfVcClaimSummaryLightDto {
    totalCount?: number | undefined;
    items?: VcClaimSummaryLightDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVcClaimSummaryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VcClaimSummaryLightDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVcClaimSummaryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVcClaimSummaryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfVcClaimSummaryLightDto {
    totalCount?: number | undefined;
    items?: VcClaimSummaryLightDto[] | undefined;
}

export class StaffTaskCountDto implements IStaffTaskCountDto {
    claimTasksCount?: number | undefined;
    applicantRequestsCount?: number | undefined;
    remindersCount?: number | undefined;

    constructor(data?: IStaffTaskCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimTasksCount = _data["claimTasksCount"];
            this.applicantRequestsCount = _data["applicantRequestsCount"];
            this.remindersCount = _data["remindersCount"];
        }
    }

    static fromJS(data: any): StaffTaskCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffTaskCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimTasksCount"] = this.claimTasksCount;
        data["applicantRequestsCount"] = this.applicantRequestsCount;
        data["remindersCount"] = this.remindersCount;
        return data; 
    }
}

export interface IStaffTaskCountDto {
    claimTasksCount?: number | undefined;
    applicantRequestsCount?: number | undefined;
    remindersCount?: number | undefined;
}

export class PagedAndSortedInputDto implements IPagedAndSortedInputDto {
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
    sorting?: string | undefined;

    constructor(data?: IPagedAndSortedInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): PagedAndSortedInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedAndSortedInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        return data; 
    }
}

export interface IPagedAndSortedInputDto {
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
    sorting?: string | undefined;
}

export enum EventType {
    ApplicationSubmitted = 1,
    ClaimAssigned = 3,
    ClaimStatusChanged = 4,
    ClaimUpdateRequestSubmitted = 5,
    ClaimUpdateRequestStatusChanged = 6,
    ClaimAccessRequestSubmitted = 7,
    ClaimAccessRequestStatusChanged = 8,
    ApplicantContactInfoChangeSubmitted = 9,
    ApplicantPersonalInfoChangeSubmitted = 10,
    ApplicantPersonalInfoApproved = 11,
    MessageSent = 12,
    ApplicantRespondedToMessage = 13,
    NotificationSent = 14,
    PhoneCall = 15,
    Email = 16,
    Other = 17,
    ClaimReassigned = 18,
    VPostalBoxMail = 19,
}

export class VcClaimLogDto implements IVcClaimLogDto {
    claimNumber?: string | undefined;
    note?: string | undefined;
    eventType?: EventType | undefined;
    creatorUserId?: number | undefined;
    creatorUserFullName?: string | undefined;
    eventTypeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    dueDate?: moment.Moment | undefined;
    completedDate?: moment.Moment | undefined;
    id?: number | undefined;

    constructor(data?: IVcClaimLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.note = _data["note"];
            this.eventType = _data["eventType"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.eventTypeName = _data["eventTypeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? moment(_data["completedDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VcClaimLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["note"] = this.note;
        data["eventType"] = this.eventType;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["eventTypeName"] = this.eventTypeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVcClaimLogDto {
    claimNumber?: string | undefined;
    note?: string | undefined;
    eventType?: EventType | undefined;
    creatorUserId?: number | undefined;
    creatorUserFullName?: string | undefined;
    eventTypeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    dueDate?: moment.Moment | undefined;
    completedDate?: moment.Moment | undefined;
    id?: number | undefined;
}

export class PagedResultDtoOfVcClaimLogDto implements IPagedResultDtoOfVcClaimLogDto {
    totalCount?: number | undefined;
    items?: VcClaimLogDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVcClaimLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VcClaimLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVcClaimLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVcClaimLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfVcClaimLogDto {
    totalCount?: number | undefined;
    items?: VcClaimLogDto[] | undefined;
}

export enum ClaimUpdateTaskCategory {
    NewClaim = 1,
    ClaimUpdateRequest = 2,
    ApplicantResponse = 3,
}

export class ClaimTaskDto implements IClaimTaskDto {
    id?: number | undefined;
    claimUpdateTaskCategory?: ClaimUpdateTaskCategory | undefined;
    claimNumber?: string | undefined;
    receivedDate?: moment.Moment | undefined;
    claimAssignedCounty?: string | undefined;
    crimeDate?: moment.Moment | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IClaimTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claimUpdateTaskCategory = _data["claimUpdateTaskCategory"];
            this.claimNumber = _data["claimNumber"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.claimAssignedCounty = _data["claimAssignedCounty"];
            this.crimeDate = _data["crimeDate"] ? moment(_data["crimeDate"].toString()) : <any>undefined;
            this.victimFirstName = _data["victimFirstName"];
            this.victimLastName = _data["victimLastName"];
            this.claimantFirstName = _data["claimantFirstName"];
            this.claimantLastName = _data["claimantLastName"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ClaimTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claimUpdateTaskCategory"] = this.claimUpdateTaskCategory;
        data["claimNumber"] = this.claimNumber;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["claimAssignedCounty"] = this.claimAssignedCounty;
        data["crimeDate"] = this.crimeDate ? this.crimeDate.toISOString() : <any>undefined;
        data["victimFirstName"] = this.victimFirstName;
        data["victimLastName"] = this.victimLastName;
        data["claimantFirstName"] = this.claimantFirstName;
        data["claimantLastName"] = this.claimantLastName;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IClaimTaskDto {
    id?: number | undefined;
    claimUpdateTaskCategory?: ClaimUpdateTaskCategory | undefined;
    claimNumber?: string | undefined;
    receivedDate?: moment.Moment | undefined;
    claimAssignedCounty?: string | undefined;
    crimeDate?: moment.Moment | undefined;
    victimFirstName?: string | undefined;
    victimLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    claimantLastName?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ClaimsTasksDto implements IClaimsTasksDto {
    claimTasks?: ClaimTaskDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IClaimsTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claimTasks"])) {
                this.claimTasks = [] as any;
                for (let item of _data["claimTasks"])
                    this.claimTasks!.push(ClaimTaskDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ClaimsTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claimTasks)) {
            data["claimTasks"] = [];
            for (let item of this.claimTasks)
                data["claimTasks"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IClaimsTasksDto {
    claimTasks?: ClaimTaskDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class VcClaimAssignDto implements IVcClaimAssignDto {
    claimNumber?: string | undefined;
    countyName?: string | undefined;
    note?: string | undefined;

    constructor(data?: IVcClaimAssignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.countyName = _data["countyName"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): VcClaimAssignDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimAssignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["countyName"] = this.countyName;
        data["note"] = this.note;
        return data; 
    }
}

export interface IVcClaimAssignDto {
    claimNumber?: string | undefined;
    countyName?: string | undefined;
    note?: string | undefined;
}

export class VcClaimSetStatusDto implements IVcClaimSetStatusDto {
    claimNumber?: string | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemPublicStatus?: ClaimStatus | undefined;
    note?: string | undefined;

    constructor(data?: IVcClaimSetStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.workItemStatus = _data["workItemStatus"];
            this.workItemPublicStatus = _data["workItemPublicStatus"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): VcClaimSetStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcClaimSetStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["workItemStatus"] = this.workItemStatus;
        data["workItemPublicStatus"] = this.workItemPublicStatus;
        data["note"] = this.note;
        return data; 
    }
}

export interface IVcClaimSetStatusDto {
    claimNumber?: string | undefined;
    workItemStatus?: ClaimStatus | undefined;
    workItemPublicStatus?: ClaimStatus | undefined;
    note?: string | undefined;
}

export class ResponseToApplicantRequestDto implements IResponseToApplicantRequestDto {
    itemId?: number | undefined;
    status?: SubmissionStatus | undefined;
    responseNote?: string | undefined;

    constructor(data?: IResponseToApplicantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.status = _data["status"];
            this.responseNote = _data["responseNote"];
        }
    }

    static fromJS(data: any): ResponseToApplicantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseToApplicantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["status"] = this.status;
        data["responseNote"] = this.responseNote;
        return data; 
    }
}

export interface IResponseToApplicantRequestDto {
    itemId?: number | undefined;
    status?: SubmissionStatus | undefined;
    responseNote?: string | undefined;
}

export class ResponseToClaimSubmissionDto implements IResponseToClaimSubmissionDto {
    vcSubmissionId?: number | undefined;
    status?: SubmissionStatus | undefined;
    responseNote?: string | undefined;

    constructor(data?: IResponseToClaimSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcSubmissionId = _data["vcSubmissionId"];
            this.status = _data["status"];
            this.responseNote = _data["responseNote"];
        }
    }

    static fromJS(data: any): ResponseToClaimSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseToClaimSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcSubmissionId"] = this.vcSubmissionId;
        data["status"] = this.status;
        data["responseNote"] = this.responseNote;
        return data; 
    }
}

export interface IResponseToClaimSubmissionDto {
    vcSubmissionId?: number | undefined;
    status?: SubmissionStatus | undefined;
    responseNote?: string | undefined;
}

export class ApplicantRequestTaskDto implements IApplicantRequestTaskDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    requestTypeId?: number | undefined;
    requestedByUserId?: number | undefined;
    applicantUserName?: string | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicantRequestTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.requestType = _data["requestType"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestedByUserId = _data["requestedByUserId"];
            this.applicantUserName = _data["applicantUserName"];
            this.applicantFirstName = _data["applicantFirstName"];
            this.applicantLastName = _data["applicantLastName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.applicantNotes = _data["applicantNotes"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicantRequestTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantRequestTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["requestType"] = this.requestType;
        data["requestTypeId"] = this.requestTypeId;
        data["requestedByUserId"] = this.requestedByUserId;
        data["applicantUserName"] = this.applicantUserName;
        data["applicantFirstName"] = this.applicantFirstName;
        data["applicantLastName"] = this.applicantLastName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["applicantNotes"] = this.applicantNotes;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicantRequestTaskDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    requestTypeId?: number | undefined;
    requestedByUserId?: number | undefined;
    applicantUserName?: string | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicantsTasksDto implements IApplicantsTasksDto {
    applicantsTasks?: ApplicantRequestTaskDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicantsTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicantsTasks"])) {
                this.applicantsTasks = [] as any;
                for (let item of _data["applicantsTasks"])
                    this.applicantsTasks!.push(ApplicantRequestTaskDto.fromJS(item));
            }
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicantsTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantsTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicantsTasks)) {
            data["applicantsTasks"] = [];
            for (let item of this.applicantsTasks)
                data["applicantsTasks"].push(item.toJSON());
        }
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicantsTasksDto {
    applicantsTasks?: ApplicantRequestTaskDto[] | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicantRequestTaskDtoOfVcClaimAccessRequestDto implements IApplicantRequestTaskDtoOfVcClaimAccessRequestDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: VcClaimAccessRequestDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicantRequestTaskDtoOfVcClaimAccessRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.requestType = _data["requestType"];
            this.applicantUserName = _data["applicantUserName"];
            this.applicantPrefix = _data["applicantPrefix"];
            this.applicantMiddleName = _data["applicantMiddleName"];
            this.applicantSuffix = _data["applicantSuffix"];
            this.applicantDob = _data["applicantDob"] ? moment(_data["applicantDob"].toString()) : <any>undefined;
            this.applicantFirstName = _data["applicantFirstName"];
            this.applicantLastName = _data["applicantLastName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.applicantNotes = _data["applicantNotes"];
            this.responseNote = _data["responseNote"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["applicableSubmissionStatusList"])) {
                this.applicableSubmissionStatusList = [] as any;
                for (let item of _data["applicableSubmissionStatusList"])
                    this.applicableSubmissionStatusList!.push(item);
            }
            this.submissionStatus = _data["submissionStatus"];
            this.submissionStatusDate = _data["submissionStatusDate"] ? moment(_data["submissionStatusDate"].toString()) : <any>undefined;
            this.submissionData = _data["submissionData"] ? VcClaimAccessRequestDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicantRequestTaskDtoOfVcClaimAccessRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantRequestTaskDtoOfVcClaimAccessRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["requestType"] = this.requestType;
        data["applicantUserName"] = this.applicantUserName;
        data["applicantPrefix"] = this.applicantPrefix;
        data["applicantMiddleName"] = this.applicantMiddleName;
        data["applicantSuffix"] = this.applicantSuffix;
        data["applicantDob"] = this.applicantDob ? this.applicantDob.toISOString() : <any>undefined;
        data["applicantFirstName"] = this.applicantFirstName;
        data["applicantLastName"] = this.applicantLastName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["applicantNotes"] = this.applicantNotes;
        data["responseNote"] = this.responseNote;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.applicableSubmissionStatusList)) {
            data["applicableSubmissionStatusList"] = [];
            for (let item of this.applicableSubmissionStatusList)
                data["applicableSubmissionStatusList"].push(item);
        }
        data["submissionStatus"] = this.submissionStatus;
        data["submissionStatusDate"] = this.submissionStatusDate ? this.submissionStatusDate.toISOString() : <any>undefined;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicantRequestTaskDtoOfVcClaimAccessRequestDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: VcClaimAccessRequestDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ContactInfoChangeDto implements IContactInfoChangeDto {
    oldAddress?: EzAddress | undefined;
    oldPhoneNumber?: string | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IContactInfoChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldAddress = _data["oldAddress"] ? EzAddress.fromJS(_data["oldAddress"]) : <any>undefined;
            this.oldPhoneNumber = _data["oldPhoneNumber"];
            this.address = _data["address"] ? EzAddress.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ContactInfoChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldAddress"] = this.oldAddress ? this.oldAddress.toJSON() : <any>undefined;
        data["oldPhoneNumber"] = this.oldPhoneNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IContactInfoChangeDto {
    oldAddress?: EzAddress | undefined;
    oldPhoneNumber?: string | undefined;
    address?: EzAddress | undefined;
    phoneNumber?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicantRequestTaskDtoOfContactInfoChangeDto implements IApplicantRequestTaskDtoOfContactInfoChangeDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: ContactInfoChangeDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicantRequestTaskDtoOfContactInfoChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.requestType = _data["requestType"];
            this.applicantUserName = _data["applicantUserName"];
            this.applicantPrefix = _data["applicantPrefix"];
            this.applicantMiddleName = _data["applicantMiddleName"];
            this.applicantSuffix = _data["applicantSuffix"];
            this.applicantDob = _data["applicantDob"] ? moment(_data["applicantDob"].toString()) : <any>undefined;
            this.applicantFirstName = _data["applicantFirstName"];
            this.applicantLastName = _data["applicantLastName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.applicantNotes = _data["applicantNotes"];
            this.responseNote = _data["responseNote"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["applicableSubmissionStatusList"])) {
                this.applicableSubmissionStatusList = [] as any;
                for (let item of _data["applicableSubmissionStatusList"])
                    this.applicableSubmissionStatusList!.push(item);
            }
            this.submissionStatus = _data["submissionStatus"];
            this.submissionStatusDate = _data["submissionStatusDate"] ? moment(_data["submissionStatusDate"].toString()) : <any>undefined;
            this.submissionData = _data["submissionData"] ? ContactInfoChangeDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicantRequestTaskDtoOfContactInfoChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantRequestTaskDtoOfContactInfoChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["requestType"] = this.requestType;
        data["applicantUserName"] = this.applicantUserName;
        data["applicantPrefix"] = this.applicantPrefix;
        data["applicantMiddleName"] = this.applicantMiddleName;
        data["applicantSuffix"] = this.applicantSuffix;
        data["applicantDob"] = this.applicantDob ? this.applicantDob.toISOString() : <any>undefined;
        data["applicantFirstName"] = this.applicantFirstName;
        data["applicantLastName"] = this.applicantLastName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["applicantNotes"] = this.applicantNotes;
        data["responseNote"] = this.responseNote;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.applicableSubmissionStatusList)) {
            data["applicableSubmissionStatusList"] = [];
            for (let item of this.applicableSubmissionStatusList)
                data["applicableSubmissionStatusList"].push(item);
        }
        data["submissionStatus"] = this.submissionStatus;
        data["submissionStatusDate"] = this.submissionStatusDate ? this.submissionStatusDate.toISOString() : <any>undefined;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicantRequestTaskDtoOfContactInfoChangeDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: ContactInfoChangeDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class ApplicantRequestTaskDtoOfPersonalInfoDto implements IApplicantRequestTaskDtoOfPersonalInfoDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: PersonalInfoDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IApplicantRequestTaskDtoOfPersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.requestType = _data["requestType"];
            this.applicantUserName = _data["applicantUserName"];
            this.applicantPrefix = _data["applicantPrefix"];
            this.applicantMiddleName = _data["applicantMiddleName"];
            this.applicantSuffix = _data["applicantSuffix"];
            this.applicantDob = _data["applicantDob"] ? moment(_data["applicantDob"].toString()) : <any>undefined;
            this.applicantFirstName = _data["applicantFirstName"];
            this.applicantLastName = _data["applicantLastName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.applicantNotes = _data["applicantNotes"];
            this.responseNote = _data["responseNote"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["applicableSubmissionStatusList"])) {
                this.applicableSubmissionStatusList = [] as any;
                for (let item of _data["applicableSubmissionStatusList"])
                    this.applicableSubmissionStatusList!.push(item);
            }
            this.submissionStatus = _data["submissionStatus"];
            this.submissionStatusDate = _data["submissionStatusDate"] ? moment(_data["submissionStatusDate"].toString()) : <any>undefined;
            this.submissionData = _data["submissionData"] ? PersonalInfoDto.fromJS(_data["submissionData"]) : <any>undefined;
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): ApplicantRequestTaskDtoOfPersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantRequestTaskDtoOfPersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["requestType"] = this.requestType;
        data["applicantUserName"] = this.applicantUserName;
        data["applicantPrefix"] = this.applicantPrefix;
        data["applicantMiddleName"] = this.applicantMiddleName;
        data["applicantSuffix"] = this.applicantSuffix;
        data["applicantDob"] = this.applicantDob ? this.applicantDob.toISOString() : <any>undefined;
        data["applicantFirstName"] = this.applicantFirstName;
        data["applicantLastName"] = this.applicantLastName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["applicantNotes"] = this.applicantNotes;
        data["responseNote"] = this.responseNote;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.applicableSubmissionStatusList)) {
            data["applicableSubmissionStatusList"] = [];
            for (let item of this.applicableSubmissionStatusList)
                data["applicableSubmissionStatusList"].push(item);
        }
        data["submissionStatus"] = this.submissionStatus;
        data["submissionStatusDate"] = this.submissionStatusDate ? this.submissionStatusDate.toISOString() : <any>undefined;
        data["submissionData"] = this.submissionData ? this.submissionData.toJSON() : <any>undefined;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IApplicantRequestTaskDtoOfPersonalInfoDto {
    itemId?: number | undefined;
    receivedDate?: moment.Moment | undefined;
    requestType?: UserSubmissionType | undefined;
    applicantUserName?: string | undefined;
    applicantPrefix?: string | undefined;
    applicantMiddleName?: string | undefined;
    applicantSuffix?: string | undefined;
    applicantDob?: moment.Moment | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantPhone?: string | undefined;
    applicantEmail?: string | undefined;
    applicantNotes?: string | undefined;
    responseNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    applicableSubmissionStatusList?: SubmissionStatus[] | undefined;
    submissionStatus?: SubmissionStatus | undefined;
    submissionStatusDate?: moment.Moment | undefined;
    submissionData?: PersonalInfoDto | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class NewVcClaimLogInputDto implements INewVcClaimLogInputDto {
    claimNumber?: string | undefined;
    eventType?: EventType | undefined;
    note?: string | undefined;
    dueDate?: moment.Moment | undefined;

    constructor(data?: INewVcClaimLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.eventType = _data["eventType"];
            this.note = _data["note"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewVcClaimLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewVcClaimLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["eventType"] = this.eventType;
        data["note"] = this.note;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface INewVcClaimLogInputDto {
    claimNumber?: string | undefined;
    eventType?: EventType | undefined;
    note?: string | undefined;
    dueDate?: moment.Moment | undefined;
}

export class UpdateVcClaimLogInputDto implements IUpdateVcClaimLogInputDto {
    claimNumber?: string | undefined;
    claimLogId?: number | undefined;
    dueDate?: moment.Moment | undefined;
    completeReminder?: boolean | undefined;

    constructor(data?: IUpdateVcClaimLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.claimLogId = _data["claimLogId"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.completeReminder = _data["completeReminder"];
        }
    }

    static fromJS(data: any): UpdateVcClaimLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVcClaimLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["claimLogId"] = this.claimLogId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completeReminder"] = this.completeReminder;
        return data; 
    }
}

export interface IUpdateVcClaimLogInputDto {
    claimNumber?: string | undefined;
    claimLogId?: number | undefined;
    dueDate?: moment.Moment | undefined;
    completeReminder?: boolean | undefined;
}

export enum StaffUserNotificationType {
    ApplicationSubmitted = 1,
    ApplicationSubmitted_Email = 2,
    ClaimAssignedToCounty = 3,
    ClaimAssignedToCounty_Email = 4,
    ClaimReAssignedFromCounty = 5,
    ClaimReAssignedFromCounty_Email = 6,
    ClaimStatusChanged = 7,
    ClaimStatusChanged_Email = 8,
    ClaimUpdateSubmitted = 9,
    ClaimUpdateSubmitted_Email = 10,
    ClaimAccessRequested = 11,
    ClaimAccessRequested_Email = 12,
    ApplicantContactInfoChangeSubmitted = 13,
    ApplicantContactInfoChangeSubmitted_Email = 14,
    ApplicantPersonalInfoChangeSubmitted = 15,
    ApplicantPersonalInfoChangeSubmitted_Email = 16,
    ApplicantRespondedToMessage = 17,
    ApplicantRespondedToMessage_Email = 18,
    ClaimUpdated = 19,
    ClaimUpdated_Email = 20,
    DataExchangeError = 21,
    DataExchangeError_Email = 22,
}

export class StaffNotificationSubscriptionDto implements IStaffNotificationSubscriptionDto {
    notificationType!: StaffUserNotificationType;
    subscribe!: boolean;

    constructor(data?: IStaffNotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.subscribe = _data["subscribe"];
        }
    }

    static fromJS(data: any): StaffNotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffNotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["subscribe"] = this.subscribe;
        return data; 
    }
}

export interface IStaffNotificationSubscriptionDto {
    notificationType: StaffUserNotificationType;
    subscribe: boolean;
}

export class OkCountyDto implements IOkCountyDto {
    countyName?: string | undefined;
    phoneNumber?: string | undefined;
    staffUserGroupId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IOkCountyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countyName = _data["countyName"];
            this.phoneNumber = _data["phoneNumber"];
            this.staffUserGroupId = _data["staffUserGroupId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OkCountyDto {
        data = typeof data === 'object' ? data : {};
        let result = new OkCountyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countyName"] = this.countyName;
        data["phoneNumber"] = this.phoneNumber;
        data["staffUserGroupId"] = this.staffUserGroupId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOkCountyDto {
    countyName?: string | undefined;
    phoneNumber?: string | undefined;
    staffUserGroupId?: number | undefined;
    id?: number | undefined;
}

export class StaffUserSummaryDto implements IStaffUserSummaryDto {
    userName?: string | undefined;
    email?: string | undefined;
    staffUserGroupId?: number | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IStaffUserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.staffUserGroupId = _data["staffUserGroupId"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): StaffUserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffUserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["staffUserGroupId"] = this.staffUserGroupId;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IStaffUserSummaryDto {
    userName?: string | undefined;
    email?: string | undefined;
    staffUserGroupId?: number | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class DistrictDto implements IDistrictDto {
    name?: string | undefined;
    displayName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    okCounties?: OkCountyDto[] | undefined;
    staffUsers?: StaffUserSummaryDto[] | undefined;
    id?: number | undefined;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            if (Array.isArray(_data["okCounties"])) {
                this.okCounties = [] as any;
                for (let item of _data["okCounties"])
                    this.okCounties!.push(OkCountyDto.fromJS(item));
            }
            if (Array.isArray(_data["staffUsers"])) {
                this.staffUsers = [] as any;
                for (let item of _data["staffUsers"])
                    this.staffUsers!.push(StaffUserSummaryDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        if (Array.isArray(this.okCounties)) {
            data["okCounties"] = [];
            for (let item of this.okCounties)
                data["okCounties"].push(item.toJSON());
        }
        if (Array.isArray(this.staffUsers)) {
            data["staffUsers"] = [];
            for (let item of this.staffUsers)
                data["staffUsers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IDistrictDto {
    name?: string | undefined;
    displayName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    okCounties?: OkCountyDto[] | undefined;
    staffUsers?: StaffUserSummaryDto[] | undefined;
    id?: number | undefined;
}

export class SearchMailItemInputforCustomer implements ISearchMailItemInputforCustomer {
    claimNumber?: string | undefined;
    isMailItemNew?: boolean | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;

    constructor(data?: ISearchMailItemInputforCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.isMailItemNew = _data["isMailItemNew"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchMailItemInputforCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMailItemInputforCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["isMailItemNew"] = this.isMailItemNew;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface ISearchMailItemInputforCustomer {
    claimNumber?: string | undefined;
    isMailItemNew?: boolean | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
}

export class MailItemDto implements IMailItemDto {
    creationTime?: moment.Moment | undefined;
    documentName?: string | undefined;
    isOpened?: boolean | undefined;
    pageCount?: number | undefined;
    claimNumber?: string | undefined;
    id?: number | undefined;
    documentBinaryObjectId?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;

    constructor(data?: IMailItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.isOpened = _data["isOpened"];
            this.pageCount = _data["pageCount"];
            this.claimNumber = _data["claimNumber"];
            this.id = _data["id"];
            this.documentBinaryObjectId = _data["documentBinaryObjectId"];
            this.idText = _data["idText"];
            this.nameText = _data["nameText"];
            this.idGuid = _data["idGuid"];
        }
    }

    static fromJS(data: any): MailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["isOpened"] = this.isOpened;
        data["pageCount"] = this.pageCount;
        data["claimNumber"] = this.claimNumber;
        data["id"] = this.id;
        data["documentBinaryObjectId"] = this.documentBinaryObjectId;
        data["idText"] = this.idText;
        data["nameText"] = this.nameText;
        data["idGuid"] = this.idGuid;
        return data; 
    }
}

export interface IMailItemDto {
    creationTime?: moment.Moment | undefined;
    documentName?: string | undefined;
    isOpened?: boolean | undefined;
    pageCount?: number | undefined;
    claimNumber?: string | undefined;
    id?: number | undefined;
    documentBinaryObjectId?: string | undefined;
    idText?: string | undefined;
    nameText?: string | undefined;
    idGuid?: string | undefined;
}

export class PagedResultDtoOfMailItemDto implements IPagedResultDtoOfMailItemDto {
    totalCount?: number | undefined;
    items?: MailItemDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMailItemDto {
    totalCount?: number | undefined;
    items?: MailItemDto[] | undefined;
}

export class RetrieveMailItemInput implements IRetrieveMailItemInput {
    mailItemId?: number | undefined;

    constructor(data?: IRetrieveMailItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailItemId = _data["mailItemId"];
        }
    }

    static fromJS(data: any): RetrieveMailItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveMailItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailItemId"] = this.mailItemId;
        return data; 
    }
}

export interface IRetrieveMailItemInput {
    mailItemId?: number | undefined;
}

export class RetrieveMailItemLogInput implements IRetrieveMailItemLogInput {
    mailItemId?: number | undefined;

    constructor(data?: IRetrieveMailItemLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailItemId = _data["mailItemId"];
        }
    }

    static fromJS(data: any): RetrieveMailItemLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveMailItemLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailItemId"] = this.mailItemId;
        return data; 
    }
}

export interface IRetrieveMailItemLogInput {
    mailItemId?: number | undefined;
}

export enum MailItemActionEnum {
    Uploaded = 0,
    Updated = 5,
    Opened = 6,
    Downloaded = 7,
}

export class MailItemLogDto implements IMailItemLogDto {
    creationTime?: moment.Moment | undefined;
    mailItemActionEnum?: MailItemActionEnum | undefined;

    constructor(data?: IMailItemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.mailItemActionEnum = _data["mailItemActionEnum"];
        }
    }

    static fromJS(data: any): MailItemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailItemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["mailItemActionEnum"] = this.mailItemActionEnum;
        return data; 
    }
}

export interface IMailItemLogDto {
    creationTime?: moment.Moment | undefined;
    mailItemActionEnum?: MailItemActionEnum | undefined;
}

export class RetrieveMailItemLogStaffInput implements IRetrieveMailItemLogStaffInput {
    mailItemId?: number | undefined;

    constructor(data?: IRetrieveMailItemLogStaffInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailItemId = _data["mailItemId"];
        }
    }

    static fromJS(data: any): RetrieveMailItemLogStaffInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveMailItemLogStaffInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailItemId"] = this.mailItemId;
        return data; 
    }
}

export interface IRetrieveMailItemLogStaffInput {
    mailItemId?: number | undefined;
}

export class SearchMailItemInputforStaff implements ISearchMailItemInputforStaff {
    claimNumber?: string | undefined;
    isMailItemNew?: boolean | undefined;
    username?: string | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;

    constructor(data?: ISearchMailItemInputforStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.isMailItemNew = _data["isMailItemNew"];
            this.username = _data["username"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchMailItemInputforStaff {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMailItemInputforStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["isMailItemNew"] = this.isMailItemNew;
        data["username"] = this.username;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface ISearchMailItemInputforStaff {
    claimNumber?: string | undefined;
    isMailItemNew?: boolean | undefined;
    username?: string | undefined;
    sorting?: string | undefined;
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
}

export class CreateMailItemInput implements ICreateMailItemInput {
    claimNumber?: string | undefined;
    pdfFileName?: string | undefined;
    pdfFile?: string | undefined;

    constructor(data?: ICreateMailItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimNumber = _data["claimNumber"];
            this.pdfFileName = _data["pdfFileName"];
            this.pdfFile = _data["pdfFile"];
        }
    }

    static fromJS(data: any): CreateMailItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMailItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimNumber"] = this.claimNumber;
        data["pdfFileName"] = this.pdfFileName;
        data["pdfFile"] = this.pdfFile;
        return data; 
    }
}

export interface ICreateMailItemInput {
    claimNumber?: string | undefined;
    pdfFileName?: string | undefined;
    pdfFile?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}